import FocusLock from 'vue-focus-lock';
import Cookies from 'js-cookie';
import axios from 'axios';
import Vue from 'vue';
import { createPopper } from '@popperjs/core';
import InfiniteLoading from 'vue-infinite-loading';
import { SpringSpinner } from 'epic-spinners';
import vue2Dropzone from 'vue2-dropzone';
import fileDownload from 'js-file-download';
import Flickity from 'vue-flickity';
import PortalVue from 'portal-vue';

class Api {
  /**
   * Class constructor
   */
  constructor() {
    this.instance = axios.create();
  }
  /**
   * Set base url
   */


  setBaseUrl(url) {
    this.instance.defaults.baseURL = url;
  }
  /**
   * Set auth header
   */


  setAuthHeader(token) {
    this.instance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  get(...args) {
    return this.instance.get(...args);
  }

  post(...args) {
    return this.instance.post(...args);
  }

  patch(...args) {
    return this.instance.patch(...args);
  }

  put(...args) {
    return this.instance.put(...args);
  }

  delete(...args) {
    return this.instance.delete(...args);
  }

}

const api = new Api();

const eventBus = new Vue({
  methods: {
    on(namespace, event, callback) {
      this.$on(`${namespace}-${event}`, callback);
    },

    emit(namespace, event, payload) {
      this.$emit(`${namespace}-${event}`, payload);
    },

    off(namespace, event) {
      this.$off(`${namespace}-${event}`);
    }

  }
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");.font-inter{font-family:Inter,sans-serif}.tm-media-modal *,.tm-media-modal :after,.tm-media-modal :before{box-sizing:border-box;border:0 solid #e5e7eb;font-family:inherit}.tm-media-modal h1,.tm-media-modal h2,.tm-media-modal h3,.tm-media-modal h4,.tm-media-modal h5,.tm-media-modal h6,.tm-media-modal hr,.tm-media-modal p{margin-top:0;margin-bottom:0}.tm-media-modal dd,.tm-media-modal dl{margin:0}.tm-media-modal audio,.tm-media-modal canvas,.tm-media-modal embed,.tm-media-modal iframe,.tm-media-modal img,.tm-media-modal object,.tm-media-modal svg,.tm-media-modal video{display:block;vertical-align:middle}.tm-media-modal img,.tm-media-modal video{max-width:100%}.tm-media-modal [role=button],.tm-media-modal button{cursor:pointer}.tm-space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.25rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.25rem*var(--tw-space-y-reverse))}.tm-space-x-1>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.25rem*var(--tw-space-x-reverse));margin-left:calc(0.25rem*(1 - var(--tw-space-x-reverse)))}.tm-space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.5rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.5rem*var(--tw-space-y-reverse))}.tm-space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.5rem*var(--tw-space-x-reverse));margin-left:calc(0.5rem*(1 - var(--tw-space-x-reverse)))}.tm-space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.75rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.75rem*var(--tw-space-y-reverse))}.tm-space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(1rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem*var(--tw-space-y-reverse))}.tm-space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem*var(--tw-space-x-reverse));margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)))}.tm-space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(1.5rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem*var(--tw-space-y-reverse))}.tm-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.tm-appearance-none{-webkit-appearance:none;appearance:none}.tm-bg-transparent{background-color:transparent}.tm-bg-white{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity))}.tm-bg-gray-50{--tw-bg-opacity:1;background-color:rgba(249,250,251,var(--tw-bg-opacity))}.tm-bg-gray-100{--tw-bg-opacity:1;background-color:rgba(243,244,246,var(--tw-bg-opacity))}.tm-bg-red-50{--tw-bg-opacity:1;background-color:rgba(254,242,242,var(--tw-bg-opacity))}.tm-bg-red-600{--tw-bg-opacity:1;background-color:rgba(220,38,38,var(--tw-bg-opacity))}.tm-bg-green-500{--tw-bg-opacity:1;background-color:rgba(16,185,129,var(--tw-bg-opacity))}.tm-bg-yankFire{--tw-bg-opacity:1;background-color:rgba(33,42,74,var(--tw-bg-opacity))}.tm-bg-yank{--tw-bg-opacity:1;background-color:rgba(24,31,54,var(--tw-bg-opacity))}.tm-bg-yankMiddle{--tw-bg-opacity:1;background-color:rgba(103,116,158,var(--tw-bg-opacity))}.tm-bg-aquamarine{--tw-bg-opacity:1;background-color:rgba(91,217,164,var(--tw-bg-opacity))}.tm-bg-carolina{--tw-bg-opacity:1;background-color:rgba(87,184,217,var(--tw-bg-opacity))}.tm-bg-bronze{--tw-bg-opacity:1;background-color:rgba(240,156,96,var(--tw-bg-opacity))}.tm-bg-payneFire{--tw-bg-opacity:1;background-color:rgba(107,126,153,var(--tw-bg-opacity))}.tm-bg-platinum{--tw-bg-opacity:1;background-color:rgba(232,232,232,var(--tw-bg-opacity))}.tm-bg-platinumFire{--tw-bg-opacity:1;background-color:rgba(241,241,241,var(--tw-bg-opacity))}.hover\\:tm-bg-gray-50:hover{--tw-bg-opacity:1;background-color:rgba(249,250,251,var(--tw-bg-opacity))}.hover\\:tm-bg-gray-100:hover{--tw-bg-opacity:1;background-color:rgba(243,244,246,var(--tw-bg-opacity))}.hover\\:tm-bg-red-700:hover{--tw-bg-opacity:1;background-color:rgba(185,28,28,var(--tw-bg-opacity))}.hover\\:tm-bg-platinumHot:hover{--tw-bg-opacity:1;background-color:rgba(247,247,247,var(--tw-bg-opacity))}.disabled\\:tm-bg-platinum:disabled{--tw-bg-opacity:1;background-color:rgba(232,232,232,var(--tw-bg-opacity))}.tm-bg-gradient-to-t{background-image:linear-gradient(0deg,var(--tw-gradient-stops))}.tm-from-gray-900{--tw-gradient-from:#111827;--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to,rgba(17,24,39,0))}.tm-bg-opacity-0{--tw-bg-opacity:0}.tm-bg-opacity-20{--tw-bg-opacity:0.2}.tm-border-transparent{border-color:transparent}.tm-border-gray-300{--tw-border-opacity:1;border-color:rgba(209,213,219,var(--tw-border-opacity))}.tm-border-red-600{--tw-border-opacity:1;border-color:rgba(220,38,38,var(--tw-border-opacity))}.tm-border-red-700{--tw-border-opacity:1;border-color:rgba(185,28,28,var(--tw-border-opacity))}.tm-border-aquamarine{--tw-border-opacity:1;border-color:rgba(91,217,164,var(--tw-border-opacity))}.tm-border-carolina{--tw-border-opacity:1;border-color:rgba(87,184,217,var(--tw-border-opacity))}.tm-border-payne{--tw-border-opacity:1;border-color:rgba(80,95,115,var(--tw-border-opacity))}.tm-border-payneHot{--tw-border-opacity:1;border-color:rgba(134,153,178,var(--tw-border-opacity))}.tm-border-platinum{--tw-border-opacity:1;border-color:rgba(232,232,232,var(--tw-border-opacity))}.focus\\:tm-border-payneFire:focus{--tw-border-opacity:1;border-color:rgba(107,126,153,var(--tw-border-opacity))}.tm-rounded{border-radius:.25rem}.tm-rounded-md{border-radius:.375rem}.tm-rounded-lg{border-radius:.5rem}.tm-rounded-xl{border-radius:.75rem}.tm-rounded-full{border-radius:9999px}.tm-rounded-item{border-radius:8px}.tm-rounded-l-md{border-top-left-radius:.375rem;border-bottom-left-radius:.375rem}.tm-rounded-r-xl{border-top-right-radius:.75rem;border-bottom-right-radius:.75rem}.tm-border-2{border-width:2px}.tm-border-4{border-width:4px}.tm-border{border-width:1px}.tm-border-t{border-top-width:1px}.tm-border-r{border-right-width:1px}.tm-border-b{border-bottom-width:1px}.tm-cursor-pointer{cursor:pointer}.tm-block{display:block}.tm-inline-block{display:inline-block}.tm-flex{display:flex}.tm-inline-flex{display:inline-flex}.tm-grid{display:grid}.tm-hidden{display:none}.tm-flex-col{flex-direction:column}.tm-items-start{align-items:flex-start}.tm-items-end{align-items:flex-end}.tm-items-center{align-items:center}.tm-justify-end{justify-content:flex-end}.tm-justify-center{justify-content:center}.tm-justify-between{justify-content:space-between}.tm-flex-1{flex:1 1 0%}.tm-flex-grow{flex-grow:1}.tm-flex-shrink-0{flex-shrink:0}.tm-font-normal{font-weight:400}.tm-font-medium{font-weight:500}.tm-font-semibold{font-weight:600}.tm-h-0{height:0}.tm-h-1{height:.25rem}.tm-h-2{height:.5rem}.tm-h-3{height:.75rem}.tm-h-4{height:1rem}.tm-h-5{height:1.25rem}.tm-h-6{height:1.5rem}.tm-h-7{height:1.75rem}.tm-h-8{height:2rem}.tm-h-9{height:2.25rem}.tm-h-10{height:2.5rem}.tm-h-11{height:2.75rem}.tm-h-12{height:3rem}.tm-h-14{height:3.5rem}.tm-h-16{height:4rem}.tm-h-18{height:4.5rem}.tm-h-24{height:6rem}.tm-h-28{height:7rem}.tm-h-48{height:12rem}.tm-h-56{height:14rem}.tm-h-64{height:16rem}.tm-h-1\\.5{height:.375rem}.tm-h-3\\.5{height:.875rem}.tm-h-full{height:100%}.tm-h-screen{height:100vh}.tm-text-xs{font-size:.75rem;line-height:1rem}.tm-text-sm{font-size:.875rem;line-height:1.25rem}.tm-text-base{font-size:1rem;line-height:1.5rem}.tm-text-lg{font-size:1.125rem;line-height:1.75rem}.tm-text-xl{font-size:1.25rem;line-height:1.75rem}.tm-text-2\\.5xl{font-size:1.75rem;line-height:2rem}.tm-leading-6{line-height:1.5rem}.tm-leading-none{line-height:1}.tm-leading-tight{line-height:1.25}.tm-leading-normal{line-height:1.5}.tm-list-none{list-style-type:none}.tm-m-0{margin:0}.tm-my-2{margin-top:.5rem;margin-bottom:.5rem}.tm-mx-2{margin-left:.5rem;margin-right:.5rem}.tm-mx-auto{margin-left:auto;margin-right:auto}.tm-ml-0{margin-left:0}.tm-mt-1{margin-top:.25rem}.tm-ml-1{margin-left:.25rem}.tm-mt-2{margin-top:.5rem}.tm-ml-2{margin-left:.5rem}.tm-mt-3{margin-top:.75rem}.tm-mr-3{margin-right:.75rem}.tm-ml-3{margin-left:.75rem}.tm-mt-4{margin-top:1rem}.tm-mr-4{margin-right:1rem}.tm-mb-4{margin-bottom:1rem}.tm-ml-4{margin-left:1rem}.tm-mt-5{margin-top:1.25rem}.tm-mt-6{margin-top:1.5rem}.tm-mb-6{margin-bottom:1.5rem}.tm-ml-6{margin-left:1.5rem}.tm-mt-8{margin-top:2rem}.tm-mt-10{margin-top:2.5rem}.tm-mt-12{margin-top:3rem}.tm-mb-16{margin-bottom:4rem}.tm-ml-0\\.5{margin-left:.125rem}.tm--mr-0{margin-right:0}.tm--ml-0{margin-left:0}.tm--ml-2{margin-left:-.5rem}.tm--ml-3{margin-left:-.75rem}.tm--ml-6{margin-left:-1.5rem}.tm--mr-12{margin-right:-3rem}.tm--mr-0\\.5{margin-right:-.125rem}.tm-max-h-56{max-height:14rem}.tm-max-w-xs{max-width:20rem}.tm-max-w-full{max-width:100%}.tm-max-w-screen-lg{max-width:1024px}.tm-max-w-2xs{max-width:16rem}.tm-min-h-screen{min-height:100vh}.tm-object-cover{object-fit:cover}.tm-opacity-0{opacity:0}.tm-opacity-40{opacity:.4}.tm-opacity-60{opacity:.6}.tm-opacity-75{opacity:.75}.tm-opacity-80{opacity:.8}.tm-opacity-90{opacity:.9}.tm-opacity-100{opacity:1}.tm-group:hover .group-hover\\:tm-opacity-30{opacity:.3}.tm-group:hover .group-hover\\:tm-opacity-80{opacity:.8}.tm-group:hover .group-hover\\:tm-opacity-100{opacity:1}.hover\\:tm-opacity-80:hover{opacity:.8}.hover\\:tm-opacity-90:hover{opacity:.9}.disabled\\:tm-opacity-50:disabled{opacity:.5}.disabled\\:tm-opacity-60:disabled{opacity:.6}.focus\\:tm-outline-none:focus,.tm-outline-none{outline:2px solid transparent;outline-offset:2px}.tm-overflow-hidden{overflow:hidden}.tm-overflow-scroll{overflow:scroll}.tm-overflow-y-auto{overflow-y:auto}.tm-overflow-x-hidden{overflow-x:hidden}.tm-overflow-y-hidden{overflow-y:hidden}.tm-overflow-y-scroll{overflow-y:scroll}.tm-p-0{padding:0}.tm-p-1{padding:.25rem}.tm-p-2{padding:.5rem}.tm-p-4{padding:1rem}.tm-p-6{padding:1.5rem}.tm-py-0{padding-top:0;padding-bottom:0}.tm-px-0{padding-left:0;padding-right:0}.tm-py-1{padding-top:.25rem;padding-bottom:.25rem}.tm-px-1{padding-left:.25rem;padding-right:.25rem}.tm-py-2{padding-top:.5rem;padding-bottom:.5rem}.tm-px-2{padding-left:.5rem;padding-right:.5rem}.tm-py-3{padding-top:.75rem;padding-bottom:.75rem}.tm-px-3{padding-left:.75rem;padding-right:.75rem}.tm-py-4{padding-top:1rem;padding-bottom:1rem}.tm-px-4{padding-left:1rem;padding-right:1rem}.tm-px-5{padding-left:1.25rem;padding-right:1.25rem}.tm-px-6{padding-left:1.5rem;padding-right:1.5rem}.tm-px-8{padding-left:2rem;padding-right:2rem}.tm-py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.tm-pt-0{padding-top:0}.tm-pt-2{padding-top:.5rem}.tm-pr-2{padding-right:.5rem}.tm-pl-2{padding-left:.5rem}.tm-pl-3{padding-left:.75rem}.tm-pt-4{padding-top:1rem}.tm-pr-4{padding-right:1rem}.tm-pb-4{padding-bottom:1rem}.tm-pl-4{padding-left:1rem}.tm-pt-5{padding-top:1.25rem}.tm-pt-6{padding-top:1.5rem}.tm-pl-6{padding-left:1.5rem}.tm-pr-7{padding-right:1.75rem}.tm-pt-8{padding-top:2rem}.tm-pr-8{padding-right:2rem}.tm-pr-10{padding-right:2.5rem}.tm-pb-10{padding-bottom:2.5rem}.tm-pt-18{padding-top:4.5rem}.tm-pb-18{padding-bottom:4.5rem}.tm-pb-20{padding-bottom:5rem}.tm-pt-0\\.5{padding-top:.125rem}.tm-pb-full{padding-bottom:100%}.tm-placeholder-cosmosHot:-ms-input-placeholder{--tw-placeholder-opacity:1;color:rgba(191,191,201,var(--tw-placeholder-opacity))}.tm-placeholder-cosmosHot::placeholder{--tw-placeholder-opacity:1;color:rgba(191,191,201,var(--tw-placeholder-opacity))}.tm-pointer-events-none{pointer-events:none}.tm-pointer-events-auto{pointer-events:auto}.tm-fixed{position:fixed}.tm-absolute{position:absolute}.tm-relative{position:relative}.tm-inset-0{right:0;left:0}.tm-inset-0,.tm-inset-y-0{top:0;bottom:0}.tm-inset-x-0{right:0;left:0}.tm-top-0{top:0}.tm-right-0{right:0}.tm-bottom-0{bottom:0}.tm-left-0{left:0}.tm-right-1{right:.25rem}.tm-bottom-1{bottom:.25rem}.tm-top-2{top:.5rem}.tm-right-2{right:.5rem}.tm-bottom-2{bottom:.5rem}.tm-top-3{top:.75rem}.tm-right-3{right:.75rem}.tm-right-5{right:1.25rem}.tm-bottom-5{bottom:1.25rem}.tm-bottom-9{bottom:2.25rem}.tm-bottom-1\\.5{bottom:.375rem}*{--tw-shadow:0 0 transparent}.tm-shadow-sm{--tw-shadow:0 1px 2px 0 rgba(0,0,0,0.05)}.tm-shadow,.tm-shadow-sm{box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.tm-shadow{--tw-shadow:0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06)}.tm-shadow-md{--tw-shadow:0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -1px rgba(0,0,0,0.06)}.tm-shadow-lg,.tm-shadow-md{box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.tm-shadow-lg{--tw-shadow:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05)}.tm-shadow-xl{--tw-shadow:0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}*{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,0.5);--tw-ring-offset-shadow:0 0 transparent;--tw-ring-shadow:0 0 transparent}.tm-ring-1{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)}.focus\\:tm-ring-2:focus,.tm-ring-1{box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus\\:tm-ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)}.focus\\:tm-ring:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus\\:tm-ring-inset:focus{--tw-ring-inset:inset}.focus-visible\\:tm-ring-2.focus-visible,.focus-visible\\:tm-ring-2:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus-visible\\:tm-ring.focus-visible,.focus-visible\\:tm-ring:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus\\:tm-ring-offset-1:focus{--tw-ring-offset-width:1px}.focus\\:tm-ring-offset-2:focus{--tw-ring-offset-width:2px}.tm-ring-black{--tw-ring-opacity:1;--tw-ring-color:rgba(0,0,0,var(--tw-ring-opacity))}.focus\\:tm-ring-white:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(255,255,255,var(--tw-ring-opacity))}.focus\\:tm-ring-yankFire:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(33,42,74,var(--tw-ring-opacity))}.focus\\:tm-ring-yank:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(24,31,54,var(--tw-ring-opacity))}.focus\\:tm-ring-aquamarine:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(91,217,164,var(--tw-ring-opacity))}.focus\\:tm-ring-carolina:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(87,184,217,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-gray-300.focus-visible,.focus-visible\\:tm-ring-gray-300:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(209,213,219,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-red-500.focus-visible,.focus-visible\\:tm-ring-red-500:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(239,68,68,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-aquamarine.focus-visible,.focus-visible\\:tm-ring-aquamarine:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(91,217,164,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-payneFire.focus-visible,.focus-visible\\:tm-ring-payneFire:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(107,126,153,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-platinum.focus-visible,.focus-visible\\:tm-ring-platinum:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(232,232,232,var(--tw-ring-opacity))}.tm-ring-opacity-5{--tw-ring-opacity:0.05}.tm-ring-opacity-10{--tw-ring-opacity:0.1}.tm-text-left{text-align:left}.tm-text-center{text-align:center}.tm-text-white{--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}.tm-text-gray-400{--tw-text-opacity:1;color:rgba(156,163,175,var(--tw-text-opacity))}.tm-text-gray-500{--tw-text-opacity:1;color:rgba(107,114,128,var(--tw-text-opacity))}.tm-text-gray-700{--tw-text-opacity:1;color:rgba(55,65,81,var(--tw-text-opacity))}.tm-text-gray-900{--tw-text-opacity:1;color:rgba(17,24,39,var(--tw-text-opacity))}.tm-text-red-600{--tw-text-opacity:1;color:rgba(220,38,38,var(--tw-text-opacity))}.tm-text-red-700{--tw-text-opacity:1;color:rgba(185,28,28,var(--tw-text-opacity))}.tm-text-red-800{--tw-text-opacity:1;color:rgba(153,27,27,var(--tw-text-opacity))}.tm-text-yankFire{--tw-text-opacity:1;color:rgba(33,42,74,var(--tw-text-opacity))}.tm-text-yank{--tw-text-opacity:1;color:rgba(24,31,54,var(--tw-text-opacity))}.tm-text-aquamarine{--tw-text-opacity:1;color:rgba(91,217,164,var(--tw-text-opacity))}.tm-text-carolina{--tw-text-opacity:1;color:rgba(87,184,217,var(--tw-text-opacity))}.tm-text-payne{--tw-text-opacity:1;color:rgba(80,95,115,var(--tw-text-opacity))}.tm-text-payneHot{--tw-text-opacity:1;color:rgba(134,153,178,var(--tw-text-opacity))}.tm-text-payneFire{--tw-text-opacity:1;color:rgba(107,126,153,var(--tw-text-opacity))}.tm-text-cosmos{--tw-text-opacity:1;color:rgba(124,124,136,var(--tw-text-opacity))}.tm-text-cosmosFire{--tw-text-opacity:1;color:rgba(154,154,163,var(--tw-text-opacity))}.hover\\:tm-text-gray-900:hover{--tw-text-opacity:1;color:rgba(17,24,39,var(--tw-text-opacity))}.disabled\\:tm-text-cosmos:disabled{--tw-text-opacity:1;color:rgba(124,124,136,var(--tw-text-opacity))}.tm-text-opacity-50{--tw-text-opacity:0.5}.hover\\:tm-text-opacity-90:hover{--tw-text-opacity:0.9}.hover\\:tm-text-opacity-100:hover{--tw-text-opacity:1}.tm-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tm-underline{text-decoration:underline}.tm-antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.tm-select-none{-webkit-user-select:none;-ms-user-select:none;user-select:none}.tm-align-bottom{vertical-align:bottom}.tm-whitespace-nowrap{white-space:nowrap}.tm-w-0{width:0}.tm-w-3{width:.75rem}.tm-w-4{width:1rem}.tm-w-5{width:1.25rem}.tm-w-6{width:1.5rem}.tm-w-8{width:2rem}.tm-w-9{width:2.25rem}.tm-w-10{width:2.5rem}.tm-w-12{width:3rem}.tm-w-14{width:3.5rem}.tm-w-16{width:4rem}.tm-w-24{width:6rem}.tm-w-28{width:7rem}.tm-w-44{width:11rem}.tm-w-48{width:12rem}.tm-w-52{width:13rem}.tm-w-56{width:14rem}.tm-w-auto{width:auto}.tm-w-3\\.5{width:.875rem}.tm-w-full{width:100%}.tm-z-0{z-index:0}.tm-z-10{z-index:10}.tm-z-20{z-index:20}.tm-z-30{z-index:30}.tm-z-40{z-index:40}.tm-z-50{z-index:50}.tm-gap-4{grid-gap:1rem;gap:1rem}.tm-gap-x-4{grid-column-gap:1rem;column-gap:1rem}.tm-gap-y-6{grid-row-gap:1.5rem;row-gap:1.5rem}.tm-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.tm-transform{--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;transform:translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.tm-translate-x-0{--tw-translate-x:0px}.tm-translate-x-4{--tw-translate-x:1rem}.tm-translate-x-8{--tw-translate-x:2rem}.tm-translate-x-full{--tw-translate-x:100%}.tm--translate-x-full{--tw-translate-x:-100%}.tm-translate-y-0{--tw-translate-y:0px}.tm-translate-y-4{--tw-translate-y:1rem}.tm-translate-y-12{--tw-translate-y:3rem}.tm--translate-y-0{--tw-translate-y:0px}.tm--translate-y-4{--tw-translate-y:-1rem}.tm--translate-y-8{--tw-translate-y:-2rem}.tm-translate-y-full{--tw-translate-y:100%}.tm-transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.tm-transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.tm-transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.tm-ease-linear{transition-timing-function:linear}.tm-ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.tm-ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.tm-ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.tm-duration-75{transition-duration:75ms}.tm-duration-100{transition-duration:.1s}.tm-duration-200{transition-duration:.2s}.tm-duration-300{transition-duration:.3s}.tm-duration-500{transition-duration:.5s}@keyframes tm-spin{to{transform:rotate(1turn)}}@keyframes tm-ping{75%,to{transform:scale(2);opacity:0}}@keyframes tm-pulse{50%{opacity:.5}}@keyframes tm-bounce{0%,to{transform:translateY(-25%);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{transform:none;animation-timing-function:cubic-bezier(0,0,.2,1)}}.tm-animate-spin{animation:tm-spin 1s linear infinite}@media (min-width:640px){.sm\\:tm-space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem*var(--tw-space-x-reverse));margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)))}.sm\\:tm-bg-transparent{background-color:transparent}.sm\\:tm-bg-cosmos{--tw-bg-opacity:1;background-color:rgba(124,124,136,var(--tw-bg-opacity))}.sm\\:tm-bg-opacity-5{--tw-bg-opacity:0.05}.sm\\:tm-rounded-2\\.5xl{border-radius:1.25rem}.sm\\:tm-border-b{border-bottom-width:1px}.sm\\:tm-block{display:block}.sm\\:tm-inline-block{display:inline-block}.sm\\:tm-flex{display:flex}.sm\\:tm-grid{display:grid}.sm\\:tm-hidden{display:none}.sm\\:tm-flex-row{flex-direction:row}.sm\\:tm-flex-row-reverse{flex-direction:row-reverse}.sm\\:tm-items-start{align-items:flex-start}.sm\\:tm-items-center{align-items:center}.sm\\:tm-flex-shrink-0{flex-shrink:0}.sm\\:tm-h-5{height:1.25rem}.sm\\:tm-h-9{height:2.25rem}.sm\\:tm-h-10{height:2.5rem}.sm\\:tm-h-14{height:3.5rem}.sm\\:tm-h-18{height:4.5rem}.sm\\:tm-h-40{height:10rem}.sm\\:tm-h-screen{height:100vh}.sm\\:tm-text-xs{font-size:.75rem;line-height:1rem}.sm\\:tm-text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:tm-text-base{font-size:1rem;line-height:1.5rem}.sm\\:tm-mx-0{margin-left:0;margin-right:0}.sm\\:tm-mx-4{margin-left:1rem;margin-right:1rem}.sm\\:tm-my-8{margin-top:2rem;margin-bottom:2rem}.sm\\:tm-mt-0{margin-top:0}.sm\\:tm-ml-0{margin-left:0}.sm\\:tm-ml-3{margin-left:.75rem}.sm\\:tm-mt-4{margin-top:1rem}.sm\\:tm-mb-4{margin-bottom:1rem}.sm\\:tm-ml-4{margin-left:1rem}.sm\\:tm-mt-6{margin-top:1.5rem}.sm\\:tm-ml-6{margin-left:1.5rem}.sm\\:tm-max-h-148{max-height:36rem}.sm\\:tm-max-w-sm{max-width:24rem}.sm\\:tm-max-w-lg{max-width:32rem}.sm\\:tm-max-w-2xs{max-width:16rem}.sm\\:tm-p-0{padding:0}.sm\\:tm-p-6{padding:1.5rem}.sm\\:tm-px-0{padding-left:0;padding-right:0}.sm\\:tm-py-1{padding-top:.25rem;padding-bottom:.25rem}.sm\\:tm-py-2{padding-top:.5rem;padding-bottom:.5rem}.sm\\:tm-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.sm\\:tm-px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:tm-pb-4{padding-bottom:1rem}.sm\\:tm-pl-4{padding-left:1rem}.sm\\:tm-pr-6{padding-right:1.5rem}.sm\\:tm-pl-6{padding-left:1.5rem}.sm\\:tm-relative{position:relative}.sm\\:tm-shadow-xl{--tw-shadow:0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.sm\\:tm-text-left{text-align:left}.sm\\:tm-text-yankFire{--tw-text-opacity:1;color:rgba(33,42,74,var(--tw-text-opacity))}.sm\\:tm-align-middle{vertical-align:middle}.sm\\:tm-w-5{width:1.25rem}.sm\\:tm-w-10{width:2.5rem}.sm\\:tm-w-14{width:3.5rem}.sm\\:tm-w-64{width:16rem}.sm\\:tm-w-auto{width:auto}.sm\\:tm-w-full{width:100%}.sm\\:tm-gap-3{grid-gap:.75rem;gap:.75rem}.sm\\:tm-grid-flow-row-dense{grid-auto-flow:row dense}.sm\\:tm-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:tm-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.sm\\:tm-grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.sm\\:tm-col-start-1{grid-column-start:1}.sm\\:tm-col-start-2{grid-column-start:2}.sm\\:tm-scale-95{--tw-scale-x:.95;--tw-scale-y:.95}.sm\\:tm-scale-100{--tw-scale-x:1;--tw-scale-y:1}.sm\\:tm-translate-y-0{--tw-translate-y:0px}.sm\\:tm-translate-y-4{--tw-translate-y:1rem}.sm\\:tm-duration-75{transition-duration:75ms}.sm\\:tm-duration-300{transition-duration:.3s}}@media (min-width:768px){.md\\:tm-h-32{height:8rem}.md\\:tm-px-0{padding-left:0;padding-right:0}.md\\:tm-left-auto{left:auto}.md\\:tm-w-56{width:14rem}}@media (min-width:1024px){.lg\\:tm-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}";
var stylesheet="@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap\");.font-inter{font-family:Inter,sans-serif}.tm-media-modal *,.tm-media-modal :after,.tm-media-modal :before{box-sizing:border-box;border:0 solid #e5e7eb;font-family:inherit}.tm-media-modal h1,.tm-media-modal h2,.tm-media-modal h3,.tm-media-modal h4,.tm-media-modal h5,.tm-media-modal h6,.tm-media-modal hr,.tm-media-modal p{margin-top:0;margin-bottom:0}.tm-media-modal dd,.tm-media-modal dl{margin:0}.tm-media-modal audio,.tm-media-modal canvas,.tm-media-modal embed,.tm-media-modal iframe,.tm-media-modal img,.tm-media-modal object,.tm-media-modal svg,.tm-media-modal video{display:block;vertical-align:middle}.tm-media-modal img,.tm-media-modal video{max-width:100%}.tm-media-modal [role=button],.tm-media-modal button{cursor:pointer}.tm-space-y-1>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.25rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.25rem*var(--tw-space-y-reverse))}.tm-space-x-1>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.25rem*var(--tw-space-x-reverse));margin-left:calc(0.25rem*(1 - var(--tw-space-x-reverse)))}.tm-space-y-2>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.5rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.5rem*var(--tw-space-y-reverse))}.tm-space-x-2>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.5rem*var(--tw-space-x-reverse));margin-left:calc(0.5rem*(1 - var(--tw-space-x-reverse)))}.tm-space-y-3>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.75rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.75rem*var(--tw-space-y-reverse))}.tm-space-y-4>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(1rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem*var(--tw-space-y-reverse))}.tm-space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem*var(--tw-space-x-reverse));margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)))}.tm-space-y-6>:not([hidden])~:not([hidden]){--tw-space-y-reverse:0;margin-top:calc(1.5rem*(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem*var(--tw-space-y-reverse))}.tm-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.tm-appearance-none{-webkit-appearance:none;appearance:none}.tm-bg-transparent{background-color:transparent}.tm-bg-white{--tw-bg-opacity:1;background-color:rgba(255,255,255,var(--tw-bg-opacity))}.tm-bg-gray-50{--tw-bg-opacity:1;background-color:rgba(249,250,251,var(--tw-bg-opacity))}.tm-bg-gray-100{--tw-bg-opacity:1;background-color:rgba(243,244,246,var(--tw-bg-opacity))}.tm-bg-red-50{--tw-bg-opacity:1;background-color:rgba(254,242,242,var(--tw-bg-opacity))}.tm-bg-red-600{--tw-bg-opacity:1;background-color:rgba(220,38,38,var(--tw-bg-opacity))}.tm-bg-green-500{--tw-bg-opacity:1;background-color:rgba(16,185,129,var(--tw-bg-opacity))}.tm-bg-yankFire{--tw-bg-opacity:1;background-color:rgba(33,42,74,var(--tw-bg-opacity))}.tm-bg-yank{--tw-bg-opacity:1;background-color:rgba(24,31,54,var(--tw-bg-opacity))}.tm-bg-yankMiddle{--tw-bg-opacity:1;background-color:rgba(103,116,158,var(--tw-bg-opacity))}.tm-bg-aquamarine{--tw-bg-opacity:1;background-color:rgba(91,217,164,var(--tw-bg-opacity))}.tm-bg-carolina{--tw-bg-opacity:1;background-color:rgba(87,184,217,var(--tw-bg-opacity))}.tm-bg-bronze{--tw-bg-opacity:1;background-color:rgba(240,156,96,var(--tw-bg-opacity))}.tm-bg-payneFire{--tw-bg-opacity:1;background-color:rgba(107,126,153,var(--tw-bg-opacity))}.tm-bg-platinum{--tw-bg-opacity:1;background-color:rgba(232,232,232,var(--tw-bg-opacity))}.tm-bg-platinumFire{--tw-bg-opacity:1;background-color:rgba(241,241,241,var(--tw-bg-opacity))}.hover\\:tm-bg-gray-50:hover{--tw-bg-opacity:1;background-color:rgba(249,250,251,var(--tw-bg-opacity))}.hover\\:tm-bg-gray-100:hover{--tw-bg-opacity:1;background-color:rgba(243,244,246,var(--tw-bg-opacity))}.hover\\:tm-bg-red-700:hover{--tw-bg-opacity:1;background-color:rgba(185,28,28,var(--tw-bg-opacity))}.hover\\:tm-bg-platinumHot:hover{--tw-bg-opacity:1;background-color:rgba(247,247,247,var(--tw-bg-opacity))}.disabled\\:tm-bg-platinum:disabled{--tw-bg-opacity:1;background-color:rgba(232,232,232,var(--tw-bg-opacity))}.tm-bg-gradient-to-t{background-image:linear-gradient(0deg,var(--tw-gradient-stops))}.tm-from-gray-900{--tw-gradient-from:#111827;--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to,rgba(17,24,39,0))}.tm-bg-opacity-0{--tw-bg-opacity:0}.tm-bg-opacity-20{--tw-bg-opacity:0.2}.tm-border-transparent{border-color:transparent}.tm-border-gray-300{--tw-border-opacity:1;border-color:rgba(209,213,219,var(--tw-border-opacity))}.tm-border-red-600{--tw-border-opacity:1;border-color:rgba(220,38,38,var(--tw-border-opacity))}.tm-border-red-700{--tw-border-opacity:1;border-color:rgba(185,28,28,var(--tw-border-opacity))}.tm-border-aquamarine{--tw-border-opacity:1;border-color:rgba(91,217,164,var(--tw-border-opacity))}.tm-border-carolina{--tw-border-opacity:1;border-color:rgba(87,184,217,var(--tw-border-opacity))}.tm-border-payne{--tw-border-opacity:1;border-color:rgba(80,95,115,var(--tw-border-opacity))}.tm-border-payneHot{--tw-border-opacity:1;border-color:rgba(134,153,178,var(--tw-border-opacity))}.tm-border-platinum{--tw-border-opacity:1;border-color:rgba(232,232,232,var(--tw-border-opacity))}.focus\\:tm-border-payneFire:focus{--tw-border-opacity:1;border-color:rgba(107,126,153,var(--tw-border-opacity))}.tm-rounded{border-radius:.25rem}.tm-rounded-md{border-radius:.375rem}.tm-rounded-lg{border-radius:.5rem}.tm-rounded-xl{border-radius:.75rem}.tm-rounded-full{border-radius:9999px}.tm-rounded-item{border-radius:8px}.tm-rounded-l-md{border-top-left-radius:.375rem;border-bottom-left-radius:.375rem}.tm-rounded-r-xl{border-top-right-radius:.75rem;border-bottom-right-radius:.75rem}.tm-border-2{border-width:2px}.tm-border-4{border-width:4px}.tm-border{border-width:1px}.tm-border-t{border-top-width:1px}.tm-border-r{border-right-width:1px}.tm-border-b{border-bottom-width:1px}.tm-cursor-pointer{cursor:pointer}.tm-block{display:block}.tm-inline-block{display:inline-block}.tm-flex{display:flex}.tm-inline-flex{display:inline-flex}.tm-grid{display:grid}.tm-hidden{display:none}.tm-flex-col{flex-direction:column}.tm-items-start{align-items:flex-start}.tm-items-end{align-items:flex-end}.tm-items-center{align-items:center}.tm-justify-end{justify-content:flex-end}.tm-justify-center{justify-content:center}.tm-justify-between{justify-content:space-between}.tm-flex-1{flex:1 1 0%}.tm-flex-grow{flex-grow:1}.tm-flex-shrink-0{flex-shrink:0}.tm-font-normal{font-weight:400}.tm-font-medium{font-weight:500}.tm-font-semibold{font-weight:600}.tm-h-0{height:0}.tm-h-1{height:.25rem}.tm-h-2{height:.5rem}.tm-h-3{height:.75rem}.tm-h-4{height:1rem}.tm-h-5{height:1.25rem}.tm-h-6{height:1.5rem}.tm-h-7{height:1.75rem}.tm-h-8{height:2rem}.tm-h-9{height:2.25rem}.tm-h-10{height:2.5rem}.tm-h-11{height:2.75rem}.tm-h-12{height:3rem}.tm-h-14{height:3.5rem}.tm-h-16{height:4rem}.tm-h-18{height:4.5rem}.tm-h-24{height:6rem}.tm-h-28{height:7rem}.tm-h-48{height:12rem}.tm-h-56{height:14rem}.tm-h-64{height:16rem}.tm-h-1\\.5{height:.375rem}.tm-h-3\\.5{height:.875rem}.tm-h-full{height:100%}.tm-h-screen{height:100vh}.tm-text-xs{font-size:.75rem;line-height:1rem}.tm-text-sm{font-size:.875rem;line-height:1.25rem}.tm-text-base{font-size:1rem;line-height:1.5rem}.tm-text-lg{font-size:1.125rem;line-height:1.75rem}.tm-text-xl{font-size:1.25rem;line-height:1.75rem}.tm-text-2\\.5xl{font-size:1.75rem;line-height:2rem}.tm-leading-6{line-height:1.5rem}.tm-leading-none{line-height:1}.tm-leading-tight{line-height:1.25}.tm-leading-normal{line-height:1.5}.tm-list-none{list-style-type:none}.tm-m-0{margin:0}.tm-my-2{margin-top:.5rem;margin-bottom:.5rem}.tm-mx-2{margin-left:.5rem;margin-right:.5rem}.tm-mx-auto{margin-left:auto;margin-right:auto}.tm-ml-0{margin-left:0}.tm-mt-1{margin-top:.25rem}.tm-ml-1{margin-left:.25rem}.tm-mt-2{margin-top:.5rem}.tm-ml-2{margin-left:.5rem}.tm-mt-3{margin-top:.75rem}.tm-mr-3{margin-right:.75rem}.tm-ml-3{margin-left:.75rem}.tm-mt-4{margin-top:1rem}.tm-mr-4{margin-right:1rem}.tm-mb-4{margin-bottom:1rem}.tm-ml-4{margin-left:1rem}.tm-mt-5{margin-top:1.25rem}.tm-mt-6{margin-top:1.5rem}.tm-mb-6{margin-bottom:1.5rem}.tm-ml-6{margin-left:1.5rem}.tm-mt-8{margin-top:2rem}.tm-mt-10{margin-top:2.5rem}.tm-mt-12{margin-top:3rem}.tm-mb-16{margin-bottom:4rem}.tm-ml-0\\.5{margin-left:.125rem}.tm--mr-0{margin-right:0}.tm--ml-0{margin-left:0}.tm--ml-2{margin-left:-.5rem}.tm--ml-3{margin-left:-.75rem}.tm--ml-6{margin-left:-1.5rem}.tm--mr-12{margin-right:-3rem}.tm--mr-0\\.5{margin-right:-.125rem}.tm-max-h-56{max-height:14rem}.tm-max-w-xs{max-width:20rem}.tm-max-w-full{max-width:100%}.tm-max-w-screen-lg{max-width:1024px}.tm-max-w-2xs{max-width:16rem}.tm-min-h-screen{min-height:100vh}.tm-object-cover{object-fit:cover}.tm-opacity-0{opacity:0}.tm-opacity-40{opacity:.4}.tm-opacity-60{opacity:.6}.tm-opacity-75{opacity:.75}.tm-opacity-80{opacity:.8}.tm-opacity-90{opacity:.9}.tm-opacity-100{opacity:1}.tm-group:hover .group-hover\\:tm-opacity-30{opacity:.3}.tm-group:hover .group-hover\\:tm-opacity-80{opacity:.8}.tm-group:hover .group-hover\\:tm-opacity-100{opacity:1}.hover\\:tm-opacity-80:hover{opacity:.8}.hover\\:tm-opacity-90:hover{opacity:.9}.disabled\\:tm-opacity-50:disabled{opacity:.5}.disabled\\:tm-opacity-60:disabled{opacity:.6}.focus\\:tm-outline-none:focus,.tm-outline-none{outline:2px solid transparent;outline-offset:2px}.tm-overflow-hidden{overflow:hidden}.tm-overflow-scroll{overflow:scroll}.tm-overflow-y-auto{overflow-y:auto}.tm-overflow-x-hidden{overflow-x:hidden}.tm-overflow-y-hidden{overflow-y:hidden}.tm-overflow-y-scroll{overflow-y:scroll}.tm-p-0{padding:0}.tm-p-1{padding:.25rem}.tm-p-2{padding:.5rem}.tm-p-4{padding:1rem}.tm-p-6{padding:1.5rem}.tm-py-0{padding-top:0;padding-bottom:0}.tm-px-0{padding-left:0;padding-right:0}.tm-py-1{padding-top:.25rem;padding-bottom:.25rem}.tm-px-1{padding-left:.25rem;padding-right:.25rem}.tm-py-2{padding-top:.5rem;padding-bottom:.5rem}.tm-px-2{padding-left:.5rem;padding-right:.5rem}.tm-py-3{padding-top:.75rem;padding-bottom:.75rem}.tm-px-3{padding-left:.75rem;padding-right:.75rem}.tm-py-4{padding-top:1rem;padding-bottom:1rem}.tm-px-4{padding-left:1rem;padding-right:1rem}.tm-px-5{padding-left:1.25rem;padding-right:1.25rem}.tm-px-6{padding-left:1.5rem;padding-right:1.5rem}.tm-px-8{padding-left:2rem;padding-right:2rem}.tm-py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.tm-pt-0{padding-top:0}.tm-pt-2{padding-top:.5rem}.tm-pr-2{padding-right:.5rem}.tm-pl-2{padding-left:.5rem}.tm-pl-3{padding-left:.75rem}.tm-pt-4{padding-top:1rem}.tm-pr-4{padding-right:1rem}.tm-pb-4{padding-bottom:1rem}.tm-pl-4{padding-left:1rem}.tm-pt-5{padding-top:1.25rem}.tm-pt-6{padding-top:1.5rem}.tm-pl-6{padding-left:1.5rem}.tm-pr-7{padding-right:1.75rem}.tm-pt-8{padding-top:2rem}.tm-pr-8{padding-right:2rem}.tm-pr-10{padding-right:2.5rem}.tm-pb-10{padding-bottom:2.5rem}.tm-pt-18{padding-top:4.5rem}.tm-pb-18{padding-bottom:4.5rem}.tm-pb-20{padding-bottom:5rem}.tm-pt-0\\.5{padding-top:.125rem}.tm-pb-full{padding-bottom:100%}.tm-placeholder-cosmosHot:-ms-input-placeholder{--tw-placeholder-opacity:1;color:rgba(191,191,201,var(--tw-placeholder-opacity))}.tm-placeholder-cosmosHot::placeholder{--tw-placeholder-opacity:1;color:rgba(191,191,201,var(--tw-placeholder-opacity))}.tm-pointer-events-none{pointer-events:none}.tm-pointer-events-auto{pointer-events:auto}.tm-fixed{position:fixed}.tm-absolute{position:absolute}.tm-relative{position:relative}.tm-inset-0{right:0;left:0}.tm-inset-0,.tm-inset-y-0{top:0;bottom:0}.tm-inset-x-0{right:0;left:0}.tm-top-0{top:0}.tm-right-0{right:0}.tm-bottom-0{bottom:0}.tm-left-0{left:0}.tm-right-1{right:.25rem}.tm-bottom-1{bottom:.25rem}.tm-top-2{top:.5rem}.tm-right-2{right:.5rem}.tm-bottom-2{bottom:.5rem}.tm-top-3{top:.75rem}.tm-right-3{right:.75rem}.tm-right-5{right:1.25rem}.tm-bottom-5{bottom:1.25rem}.tm-bottom-9{bottom:2.25rem}.tm-bottom-1\\.5{bottom:.375rem}*{--tw-shadow:0 0 transparent}.tm-shadow-sm{--tw-shadow:0 1px 2px 0 rgba(0,0,0,0.05)}.tm-shadow,.tm-shadow-sm{box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.tm-shadow{--tw-shadow:0 1px 3px 0 rgba(0,0,0,0.1),0 1px 2px 0 rgba(0,0,0,0.06)}.tm-shadow-md{--tw-shadow:0 4px 6px -1px rgba(0,0,0,0.1),0 2px 4px -1px rgba(0,0,0,0.06)}.tm-shadow-lg,.tm-shadow-md{box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.tm-shadow-lg{--tw-shadow:0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05)}.tm-shadow-xl{--tw-shadow:0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}*{--tw-ring-inset:var(--tw-empty,/*!*/ /*!*/);--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgba(59,130,246,0.5);--tw-ring-offset-shadow:0 0 transparent;--tw-ring-shadow:0 0 transparent}.tm-ring-1{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color)}.focus\\:tm-ring-2:focus,.tm-ring-1{box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus\\:tm-ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)}.focus\\:tm-ring:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus\\:tm-ring-inset:focus{--tw-ring-inset:inset}.focus-visible\\:tm-ring-2.focus-visible,.focus-visible\\:tm-ring-2:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus-visible\\:tm-ring.focus-visible,.focus-visible\\:tm-ring:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.focus\\:tm-ring-offset-1:focus{--tw-ring-offset-width:1px}.focus\\:tm-ring-offset-2:focus{--tw-ring-offset-width:2px}.tm-ring-black{--tw-ring-opacity:1;--tw-ring-color:rgba(0,0,0,var(--tw-ring-opacity))}.focus\\:tm-ring-white:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(255,255,255,var(--tw-ring-opacity))}.focus\\:tm-ring-yankFire:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(33,42,74,var(--tw-ring-opacity))}.focus\\:tm-ring-yank:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(24,31,54,var(--tw-ring-opacity))}.focus\\:tm-ring-aquamarine:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(91,217,164,var(--tw-ring-opacity))}.focus\\:tm-ring-carolina:focus{--tw-ring-opacity:1;--tw-ring-color:rgba(87,184,217,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-gray-300.focus-visible,.focus-visible\\:tm-ring-gray-300:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(209,213,219,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-red-500.focus-visible,.focus-visible\\:tm-ring-red-500:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(239,68,68,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-aquamarine.focus-visible,.focus-visible\\:tm-ring-aquamarine:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(91,217,164,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-payneFire.focus-visible,.focus-visible\\:tm-ring-payneFire:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(107,126,153,var(--tw-ring-opacity))}.focus-visible\\:tm-ring-platinum.focus-visible,.focus-visible\\:tm-ring-platinum:focus-visible{--tw-ring-opacity:1;--tw-ring-color:rgba(232,232,232,var(--tw-ring-opacity))}.tm-ring-opacity-5{--tw-ring-opacity:0.05}.tm-ring-opacity-10{--tw-ring-opacity:0.1}.tm-text-left{text-align:left}.tm-text-center{text-align:center}.tm-text-white{--tw-text-opacity:1;color:rgba(255,255,255,var(--tw-text-opacity))}.tm-text-gray-400{--tw-text-opacity:1;color:rgba(156,163,175,var(--tw-text-opacity))}.tm-text-gray-500{--tw-text-opacity:1;color:rgba(107,114,128,var(--tw-text-opacity))}.tm-text-gray-700{--tw-text-opacity:1;color:rgba(55,65,81,var(--tw-text-opacity))}.tm-text-gray-900{--tw-text-opacity:1;color:rgba(17,24,39,var(--tw-text-opacity))}.tm-text-red-600{--tw-text-opacity:1;color:rgba(220,38,38,var(--tw-text-opacity))}.tm-text-red-700{--tw-text-opacity:1;color:rgba(185,28,28,var(--tw-text-opacity))}.tm-text-red-800{--tw-text-opacity:1;color:rgba(153,27,27,var(--tw-text-opacity))}.tm-text-yankFire{--tw-text-opacity:1;color:rgba(33,42,74,var(--tw-text-opacity))}.tm-text-yank{--tw-text-opacity:1;color:rgba(24,31,54,var(--tw-text-opacity))}.tm-text-aquamarine{--tw-text-opacity:1;color:rgba(91,217,164,var(--tw-text-opacity))}.tm-text-carolina{--tw-text-opacity:1;color:rgba(87,184,217,var(--tw-text-opacity))}.tm-text-payne{--tw-text-opacity:1;color:rgba(80,95,115,var(--tw-text-opacity))}.tm-text-payneHot{--tw-text-opacity:1;color:rgba(134,153,178,var(--tw-text-opacity))}.tm-text-payneFire{--tw-text-opacity:1;color:rgba(107,126,153,var(--tw-text-opacity))}.tm-text-cosmos{--tw-text-opacity:1;color:rgba(124,124,136,var(--tw-text-opacity))}.tm-text-cosmosFire{--tw-text-opacity:1;color:rgba(154,154,163,var(--tw-text-opacity))}.hover\\:tm-text-gray-900:hover{--tw-text-opacity:1;color:rgba(17,24,39,var(--tw-text-opacity))}.disabled\\:tm-text-cosmos:disabled{--tw-text-opacity:1;color:rgba(124,124,136,var(--tw-text-opacity))}.tm-text-opacity-50{--tw-text-opacity:0.5}.hover\\:tm-text-opacity-90:hover{--tw-text-opacity:0.9}.hover\\:tm-text-opacity-100:hover{--tw-text-opacity:1}.tm-truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tm-underline{text-decoration:underline}.tm-antialiased{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.tm-select-none{-webkit-user-select:none;-ms-user-select:none;user-select:none}.tm-align-bottom{vertical-align:bottom}.tm-whitespace-nowrap{white-space:nowrap}.tm-w-0{width:0}.tm-w-3{width:.75rem}.tm-w-4{width:1rem}.tm-w-5{width:1.25rem}.tm-w-6{width:1.5rem}.tm-w-8{width:2rem}.tm-w-9{width:2.25rem}.tm-w-10{width:2.5rem}.tm-w-12{width:3rem}.tm-w-14{width:3.5rem}.tm-w-16{width:4rem}.tm-w-24{width:6rem}.tm-w-28{width:7rem}.tm-w-44{width:11rem}.tm-w-48{width:12rem}.tm-w-52{width:13rem}.tm-w-56{width:14rem}.tm-w-auto{width:auto}.tm-w-3\\.5{width:.875rem}.tm-w-full{width:100%}.tm-z-0{z-index:0}.tm-z-10{z-index:10}.tm-z-20{z-index:20}.tm-z-30{z-index:30}.tm-z-40{z-index:40}.tm-z-50{z-index:50}.tm-gap-4{grid-gap:1rem;gap:1rem}.tm-gap-x-4{grid-column-gap:1rem;column-gap:1rem}.tm-gap-y-6{grid-row-gap:1.5rem;row-gap:1.5rem}.tm-grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.tm-transform{--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;transform:translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.tm-translate-x-0{--tw-translate-x:0px}.tm-translate-x-4{--tw-translate-x:1rem}.tm-translate-x-8{--tw-translate-x:2rem}.tm-translate-x-full{--tw-translate-x:100%}.tm--translate-x-full{--tw-translate-x:-100%}.tm-translate-y-0{--tw-translate-y:0px}.tm-translate-y-4{--tw-translate-y:1rem}.tm-translate-y-12{--tw-translate-y:3rem}.tm--translate-y-0{--tw-translate-y:0px}.tm--translate-y-4{--tw-translate-y:-1rem}.tm--translate-y-8{--tw-translate-y:-2rem}.tm-translate-y-full{--tw-translate-y:100%}.tm-transition-all{transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.tm-transition{transition-property:background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.tm-transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.tm-ease-linear{transition-timing-function:linear}.tm-ease-in{transition-timing-function:cubic-bezier(.4,0,1,1)}.tm-ease-out{transition-timing-function:cubic-bezier(0,0,.2,1)}.tm-ease-in-out{transition-timing-function:cubic-bezier(.4,0,.2,1)}.tm-duration-75{transition-duration:75ms}.tm-duration-100{transition-duration:.1s}.tm-duration-200{transition-duration:.2s}.tm-duration-300{transition-duration:.3s}.tm-duration-500{transition-duration:.5s}@keyframes tm-spin{to{transform:rotate(1turn)}}@keyframes tm-ping{75%,to{transform:scale(2);opacity:0}}@keyframes tm-pulse{50%{opacity:.5}}@keyframes tm-bounce{0%,to{transform:translateY(-25%);animation-timing-function:cubic-bezier(.8,0,1,1)}50%{transform:none;animation-timing-function:cubic-bezier(0,0,.2,1)}}.tm-animate-spin{animation:tm-spin 1s linear infinite}@media (min-width:640px){.sm\\:tm-space-x-4>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem*var(--tw-space-x-reverse));margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)))}.sm\\:tm-bg-transparent{background-color:transparent}.sm\\:tm-bg-cosmos{--tw-bg-opacity:1;background-color:rgba(124,124,136,var(--tw-bg-opacity))}.sm\\:tm-bg-opacity-5{--tw-bg-opacity:0.05}.sm\\:tm-rounded-2\\.5xl{border-radius:1.25rem}.sm\\:tm-border-b{border-bottom-width:1px}.sm\\:tm-block{display:block}.sm\\:tm-inline-block{display:inline-block}.sm\\:tm-flex{display:flex}.sm\\:tm-grid{display:grid}.sm\\:tm-hidden{display:none}.sm\\:tm-flex-row{flex-direction:row}.sm\\:tm-flex-row-reverse{flex-direction:row-reverse}.sm\\:tm-items-start{align-items:flex-start}.sm\\:tm-items-center{align-items:center}.sm\\:tm-flex-shrink-0{flex-shrink:0}.sm\\:tm-h-5{height:1.25rem}.sm\\:tm-h-9{height:2.25rem}.sm\\:tm-h-10{height:2.5rem}.sm\\:tm-h-14{height:3.5rem}.sm\\:tm-h-18{height:4.5rem}.sm\\:tm-h-40{height:10rem}.sm\\:tm-h-screen{height:100vh}.sm\\:tm-text-xs{font-size:.75rem;line-height:1rem}.sm\\:tm-text-sm{font-size:.875rem;line-height:1.25rem}.sm\\:tm-text-base{font-size:1rem;line-height:1.5rem}.sm\\:tm-mx-0{margin-left:0;margin-right:0}.sm\\:tm-mx-4{margin-left:1rem;margin-right:1rem}.sm\\:tm-my-8{margin-top:2rem;margin-bottom:2rem}.sm\\:tm-mt-0{margin-top:0}.sm\\:tm-ml-0{margin-left:0}.sm\\:tm-ml-3{margin-left:.75rem}.sm\\:tm-mt-4{margin-top:1rem}.sm\\:tm-mb-4{margin-bottom:1rem}.sm\\:tm-ml-4{margin-left:1rem}.sm\\:tm-mt-6{margin-top:1.5rem}.sm\\:tm-ml-6{margin-left:1.5rem}.sm\\:tm-max-h-148{max-height:36rem}.sm\\:tm-max-w-sm{max-width:24rem}.sm\\:tm-max-w-lg{max-width:32rem}.sm\\:tm-max-w-2xs{max-width:16rem}.sm\\:tm-p-0{padding:0}.sm\\:tm-p-6{padding:1.5rem}.sm\\:tm-px-0{padding-left:0;padding-right:0}.sm\\:tm-py-1{padding-top:.25rem;padding-bottom:.25rem}.sm\\:tm-py-2{padding-top:.5rem;padding-bottom:.5rem}.sm\\:tm-py-6{padding-top:1.5rem;padding-bottom:1.5rem}.sm\\:tm-px-6{padding-left:1.5rem;padding-right:1.5rem}.sm\\:tm-pb-4{padding-bottom:1rem}.sm\\:tm-pl-4{padding-left:1rem}.sm\\:tm-pr-6{padding-right:1.5rem}.sm\\:tm-pl-6{padding-left:1.5rem}.sm\\:tm-relative{position:relative}.sm\\:tm-shadow-xl{--tw-shadow:0 20px 25px -5px rgba(0,0,0,0.1),0 10px 10px -5px rgba(0,0,0,0.04);box-shadow:0 0 transparent,0 0 transparent,var(--tw-shadow);box-shadow:var(--tw-ring-offset-shadow,0 0 transparent),var(--tw-ring-shadow,0 0 transparent),var(--tw-shadow)}.sm\\:tm-text-left{text-align:left}.sm\\:tm-text-yankFire{--tw-text-opacity:1;color:rgba(33,42,74,var(--tw-text-opacity))}.sm\\:tm-align-middle{vertical-align:middle}.sm\\:tm-w-5{width:1.25rem}.sm\\:tm-w-10{width:2.5rem}.sm\\:tm-w-14{width:3.5rem}.sm\\:tm-w-64{width:16rem}.sm\\:tm-w-auto{width:auto}.sm\\:tm-w-full{width:100%}.sm\\:tm-gap-3{grid-gap:.75rem;gap:.75rem}.sm\\:tm-grid-flow-row-dense{grid-auto-flow:row dense}.sm\\:tm-grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:tm-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}.sm\\:tm-grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.sm\\:tm-col-start-1{grid-column-start:1}.sm\\:tm-col-start-2{grid-column-start:2}.sm\\:tm-scale-95{--tw-scale-x:.95;--tw-scale-y:.95}.sm\\:tm-scale-100{--tw-scale-x:1;--tw-scale-y:1}.sm\\:tm-translate-y-0{--tw-translate-y:0px}.sm\\:tm-translate-y-4{--tw-translate-y:1rem}.sm\\:tm-duration-75{transition-duration:75ms}.sm\\:tm-duration-300{transition-duration:.3s}}@media (min-width:768px){.md\\:tm-h-32{height:8rem}.md\\:tm-px-0{padding-left:0;padding-right:0}.md\\:tm-left-auto{left:auto}.md\\:tm-w-56{width:14rem}}@media (min-width:1024px){.lg\\:tm-grid-cols-4{grid-template-columns:repeat(4,minmax(0,1fr))}}";
styleInject(css_248z);

//
//
//
//
var script = {
  name: 'Logo'
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__ = script;
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 35 37"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17.622 18.659c3.09-1.26 5.386-3.992 5.67-7.196l.031-.708c0-4.348-2.204-8.192-5.638-10.755-3.434 2.563-5.764 6.43-5.764 10.778l.031.708c.285 3.204 2.58 5.912 5.67 7.173zM16.182 23.712c-.17-.67-.443-1.263-.74-1.876a10.181 10.181 0 00-2.876-3.56c-1.776-1.42-4.084-2.209-6.352-2.209H0c.011.785 0 1.57 0 2.355.066 1.378.405 2.73 1.005 3.973a10.233 10.233 0 002.877 3.564c1.748 1.399 3.986 2.288 6.234 2.288h6.196c0-1.693.079-3.716-.13-4.535zM19.543 21.836c-.296.613-.569 1.205-.74 1.876-.164.642-.15 2.026-.137 3.41.004.38.008.76.008 1.125h-.015V30.4l-.26 6.4h1.167l.041-.624c.117-1.785.245-3.737.477-5.337.26-1.789 2.22-2.56 3.628-2.592h1.163c2.25 0 4.49-.89 6.24-2.288 1.21-.95 2.2-2.168 2.88-3.564.6-1.242.94-2.595 1.005-3.973l-.002-.785a82.166 82.166 0 01.002-1.57h-6.22c-2.27 0-4.58.789-6.357 2.21-1.21.946-2.2 2.163-2.88 3.56z",
      "fill": "#181F36"
    }
  })]);
};

var __vue_staticRenderFns__ = [];
/* style */

const __vue_inject_styles__ = undefined;
/* scoped */

const __vue_scope_id__ = undefined;
/* module identifier */

const __vue_module_identifier__ = undefined;
/* functional template */

const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

//
//
//
//
var script$1 = {
  name: 'SearchIcon'
};

/* script */
const __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 12 12"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9.49 8.134l2.229 2.23a.96.96 0 010 1.357.972.972 0 01-1.358 0l-2.23-2.229A4.923 4.923 0 119.49 8.134zm-.61-2.732a3.48 3.48 0 10-6.96 0 3.48 3.48 0 006.96 0z",
      "fill": "currentColor"
    }
  })]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

const __vue_inject_styles__$1 = undefined;
/* scoped */

const __vue_scope_id__$1 = undefined;
/* module identifier */

const __vue_module_identifier__$1 = undefined;
/* functional template */

const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
//
//
//
var script$2 = {
  name: 'UploadIcon'
};

/* script */
const __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 10v2.667A1.334 1.334 0 0112.667 14H3.333A1.334 1.334 0 012 12.667V10M11.333 5.333L8 2 4.667 5.333M8 2v8",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$2 = [];
/* style */

const __vue_inject_styles__$2 = undefined;
/* scoped */

const __vue_scope_id__$2 = undefined;
/* module identifier */

const __vue_module_identifier__$2 = undefined;
/* functional template */

const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$3 = {
  name: 'DotsHorizontalIcon'
};

/* script */
const __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
    }
  })]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

const __vue_inject_styles__$3 = undefined;
/* scoped */

const __vue_scope_id__$3 = undefined;
/* module identifier */

const __vue_module_identifier__$3 = undefined;
/* functional template */

const __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

//
//
//
//
var script$4 = {
  name: 'FolderPlusIcon'
};

/* script */
const __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.667 12.667A1.334 1.334 0 0113.333 14H2.667a1.334 1.334 0 01-1.334-1.333V3.333A1.333 1.333 0 012.667 2H6l1.333 2h6a1.333 1.333 0 011.334 1.333v7.334zM8 7.333v4M6 9.333h4",
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

const __vue_inject_styles__$4 = undefined;
/* scoped */

const __vue_scope_id__$4 = undefined;
/* module identifier */

const __vue_module_identifier__$4 = undefined;
/* functional template */

const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

//
//
//
//
var script$5 = {
  name: 'FolderPlusIconAlt'
};

/* script */
const __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.9 2.1H6.804l-.224-.665A2.1 2.1 0 004.59 0H2.1A2.1 2.1 0 000 2.1v9.8A2.1 2.1 0 002.1 14h9.8a2.1 2.1 0 002.1-2.1V4.2a2.1 2.1 0 00-2.1-2.1zM9.45 9.275H7.875v1.575a.875.875 0 11-1.75 0V9.275H4.55a.875.875 0 010-1.75h1.575V5.95a.875.875 0 011.75 0v1.575H9.45a.875.875 0 110 1.75z",
      "fill": "currentColor"
    }
  })]);
};

var __vue_staticRenderFns__$5 = [];
/* style */

const __vue_inject_styles__$5 = undefined;
/* scoped */

const __vue_scope_id__$5 = undefined;
/* module identifier */

const __vue_module_identifier__$5 = undefined;
/* functional template */

const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

//
//
//
//
var script$6 = {//
};

/* script */
const __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 91 69"
    }
  }, [_c('g', {
    attrs: {
      "filter": "url(#filter0_i)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 8a8 8 0 018-8h34.357a8 8 0 017.482 5.168l20.06 53C71.882 63.402 68.015 69 62.419 69H8a8 8 0 01-8-8V8z",
      "fill": "#57B8D9"
    }
  })]), _c('g', {
    attrs: {
      "filter": "url(#filter1_i)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 12h83a8 8 0 018 8v41a8 8 0 01-8 8H8a8 8 0 01-8-8V12z",
      "fill": "#85D6F2"
    }
  })]), _c('defs', [_c('filter', {
    attrs: {
      "id": "filter0_i",
      "x": "0",
      "y": "0",
      "width": "70.425",
      "height": "69",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _c('feOffset'), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "2"
    }
  }), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }
  }), _c('feBlend', {
    attrs: {
      "in2": "shape",
      "result": "effect1_innerShadow"
    }
  })], 1), _c('filter', {
    attrs: {
      "id": "filter1_i",
      "x": "0",
      "y": "12",
      "width": "91",
      "height": "57",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB"
    }
  }, [_c('feFlood', {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _c('feBlend', {
    attrs: {
      "in": "SourceGraphic",
      "in2": "BackgroundImageFix",
      "result": "shape"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "in": "SourceAlpha",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      "result": "hardAlpha"
    }
  }), _c('feOffset'), _c('feGaussianBlur', {
    attrs: {
      "stdDeviation": "2"
    }
  }), _c('feComposite', {
    attrs: {
      "in2": "hardAlpha",
      "operator": "arithmetic",
      "k2": "-1",
      "k3": "1"
    }
  }), _c('feColorMatrix', {
    attrs: {
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }
  }), _c('feBlend', {
    attrs: {
      "in2": "shape",
      "result": "effect1_innerShadow"
    }
  })], 1)])]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

const __vue_inject_styles__$6 = undefined;
/* scoped */

const __vue_scope_id__$6 = undefined;
/* module identifier */

const __vue_module_identifier__$6 = undefined;
/* functional template */

const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

//
//
//
//
var script$7 = {
  name: 'MenuIcon'
};

/* script */
const __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "d": "M15.25 2.083H.75M15.25 7.861H.75M15.25 13.639H.75"
    }
  })]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

const __vue_inject_styles__$7 = undefined;
/* scoped */

const __vue_scope_id__$7 = undefined;
/* module identifier */

const __vue_module_identifier__$7 = undefined;
/* functional template */

const __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);

//
//
//
//
//
var script$8 = {
  name: 'CheckboxIcon',
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
const __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return !_vm.checked ? _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('rect', {
    attrs: {
      "x": ".5",
      "y": ".5",
      "width": "19",
      "height": "19",
      "rx": "3.5",
      "fill": "#fff",
      "stroke": "#8699B2"
    }
  })]) : _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('rect', {
    attrs: {
      "width": "20",
      "height": "20",
      "rx": "6",
      "fill": "#fff"
    }
  }), _c('rect', {
    attrs: {
      "x": ".5",
      "y": ".5",
      "width": "19",
      "height": "19",
      "rx": "3.5",
      "fill": "#57B8D9",
      "fill-opacity": ".7",
      "stroke": "#57B8D9"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.887 10.392l2.617 2.616 5.61-5.61",
      "stroke": "#fff"
    }
  })]);
};

var __vue_staticRenderFns__$8 = [];
/* style */

const __vue_inject_styles__$8 = undefined;
/* scoped */

const __vue_scope_id__$8 = undefined;
/* module identifier */

const __vue_module_identifier__$8 = undefined;
/* functional template */

const __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);

//
//
//
//
var script$9 = {
  name: 'EditIcon'
};

/* script */
const __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.57 7.736l5.157-5.159a.933.933 0 000-1.316L12.74.28a.93.93 0 00-1.316 0L6.268 5.43a.7.7 0 00-.195.374L5.687 7.99a.28.28 0 00.28.33.28.28 0 00.047 0L8.2 7.933a.7.7 0 00.37-.198z",
      "fill": "currentColor"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.56 8.726a2.1 2.1 0 01-1.12.582l-2.188.387a1.665 1.665 0 01-1.477-.468 1.681 1.681 0 01-.467-1.48l.386-2.188c.075-.425.279-.816.584-1.12l2.44-2.44A.35.35 0 007.47 1.4H2.1A2.1 2.1 0 000 3.501l.014 8.404a2.102 2.102 0 002.1 2.101H10.5a2.1 2.1 0 002.1-2.1V6.53a.35.35 0 00-.598-.248L9.561 8.726z",
      "fill": "currentColor"
    }
  })]);
};

var __vue_staticRenderFns__$9 = [];
/* style */

const __vue_inject_styles__$9 = undefined;
/* scoped */

const __vue_scope_id__$9 = undefined;
/* module identifier */

const __vue_module_identifier__$9 = undefined;
/* functional template */

const __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);

//
//
//
//
var script$a = {
  name: 'XIcon'
};

/* script */
const __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 13 13"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M1.477.827a.65.65 0 00-.46 1.11L5.581 6.5l-4.564 4.564a.653.653 0 000 .918c.122.122.292.19.46.19a.658.658 0 00.46-.19L6.5 7.42l4.564 4.563c.121.122.292.19.459.19.165 0 .33-.06.46-.19a.653.653 0 000-.918L7.418 6.5l4.563-4.564a.653.653 0 000-.919.654.654 0 00-.918 0L6.5 5.581 1.936 1.017a.651.651 0 00-.46-.19z",
      "fill": "currentColor"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "transform": "translate(.5 .5)",
      "d": "M0 0h12v12H0z"
    }
  })])])]);
};

var __vue_staticRenderFns__$a = [];
/* style */

const __vue_inject_styles__$a = undefined;
/* scoped */

const __vue_scope_id__$a = undefined;
/* module identifier */

const __vue_module_identifier__$a = undefined;
/* functional template */

const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);

//
//
//
//
var script$b = {
  name: 'DownloadAltIcon'
};

/* script */
const __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0)",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.581 7.055l2.8 2.8a.875.875 0 001.238 0l2.8-2.8A.875.875 0 009.18 5.817L7.875 7.123V.963a.875.875 0 00-1.75 0v6.16L4.819 5.817A.875.875 0 103.58 7.055z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.95 8.663a1.05 1.05 0 00-1.05 1.05v1.75a.352.352 0 01-.35.35h-9.1a.35.35 0 01-.35-.35v-1.75a1.05 1.05 0 10-2.1 0v1.75a2.454 2.454 0 002.45 2.45h9.1a2.454 2.454 0 002.45-2.45v-1.75a1.05 1.05 0 00-1.05-1.05z"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h14v14H0z"
    }
  })])])]);
};

var __vue_staticRenderFns__$b = [];
/* style */

const __vue_inject_styles__$b = undefined;
/* scoped */

const __vue_scope_id__$b = undefined;
/* module identifier */

const __vue_module_identifier__$b = undefined;
/* functional template */

const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);

//
//
//
//
var script$c = {
  name: 'ShareAltIcon'
};

/* script */
const __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.794 6.16l-4.9-4.9a.7.7 0 00-1.194.49v2.1h-.28a6.317 6.317 0 00-5.918 4.147L.042 12.01a.7.7 0 001.106.777l2.643-2.201A4.9 4.9 0 016.927 9.45H7.7v2.1a.7.7 0 001.194.495l4.9-4.9a.7.7 0 000-.985z",
      "fill": "currentColor"
    }
  })]);
};

var __vue_staticRenderFns__$c = [];
/* style */

const __vue_inject_styles__$c = undefined;
/* scoped */

const __vue_scope_id__$c = undefined;
/* module identifier */

const __vue_module_identifier__$c = undefined;
/* functional template */

const __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$d = {
  name: 'TrashIcon'
};

/* script */
const __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$d = [];
/* style */

const __vue_inject_styles__$d = undefined;
/* scoped */

const __vue_scope_id__$d = undefined;
/* module identifier */

const __vue_module_identifier__$d = undefined;
/* functional template */

const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);

//
//
//
//
var script$e = {
  name: 'TrashAltIcon'
};

/* script */
const __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14 4.119a1.05 1.05 0 00-1.05-1.05h-2.363a.35.35 0 01-.343-.28 3.334 3.334 0 00-6.545 0 .351.351 0 01-.343.28H1.05a1.05 1.05 0 100 2.1h.35a.35.35 0 01.35.35v6.3a2.1 2.1 0 002.1 2.1h6.3a2.1 2.1 0 002.1-2.1v-6.3a.35.35 0 01.35-.35h.35A1.05 1.05 0 0014 4.119zM6.97 1.837a1.551 1.551 0 011.29.683.356.356 0 01.021.363.35.35 0 01-.31.186H5.978a.35.35 0 01-.289-.55 1.54 1.54 0 011.283-.682zm-1.195 8.926a.875.875 0 11-1.75 0v-3.5a.875.875 0 111.75 0v3.5zm4.2 0a.875.875 0 11-1.75 0v-3.5a.875.875 0 111.75 0v3.5z",
      "fill": "currentColor"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h14v14H0z"
    }
  })])])]);
};

var __vue_staticRenderFns__$e = [];
/* style */

const __vue_inject_styles__$e = undefined;
/* scoped */

const __vue_scope_id__$e = undefined;
/* module identifier */

const __vue_module_identifier__$e = undefined;
/* functional template */

const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$f = {
  name: 'ArrowLeftIcon'
};

/* script */
const __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M15 19l-7-7 7-7"
    }
  })]);
};

var __vue_staticRenderFns__$f = [];
/* style */

const __vue_inject_styles__$f = undefined;
/* scoped */

const __vue_scope_id__$f = undefined;
/* module identifier */

const __vue_module_identifier__$f = undefined;
/* functional template */

const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$g = {
  name: 'ArrowRightIcon'
};

/* script */
const __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M9 5l7 7-7 7"
    }
  })]);
};

var __vue_staticRenderFns__$g = [];
/* style */

const __vue_inject_styles__$g = undefined;
/* scoped */

const __vue_scope_id__$g = undefined;
/* module identifier */

const __vue_module_identifier__$g = undefined;
/* functional template */

const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);

//
//
//
//
var script$h = {
  name: 'EmptyStateSvg'
};

/* script */
const __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 200 169"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 88.8a80 80 0 10160 0 80 80 0 00-160 0z",
      "fill": "#7982AD",
      "fill-opacity": ".1"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 153.601c0 .795 4.214 1.558 11.716 2.121 7.501.562 17.675.879 28.284.879 10.609 0 20.783-.317 28.284-.879 7.502-.563 11.716-1.326 11.716-2.121 0-.796-4.214-1.559-11.716-2.122-7.501-.562-17.675-.878-28.284-.878-10.609 0-20.783.316-28.284.878-7.502.563-11.716 1.326-11.716 2.122z",
      "fill": "#C3C9E5"
    }
  }), _c('path', {
    attrs: {
      "d": "M138.736 29.086l-.122.497.419.294a16.604 16.604 0 016.264 18.597 16.602 16.602 0 01-15.846 11.576H66.9a13.15 13.15 0 01-.013-26.3c.545.02 1.09.076 1.628.166l.873.146v-.886 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0-.001 0V33v0V33a27.033 27.033 0 0147.652-17.503l.463.545.566-.435a13.076 13.076 0 0120.667 13.479z",
      "fill": "#fff",
      "stroke": "#8B95C7",
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M116.122 49.097h0a3.25 3.25 0 01-4.595 0s0 0 0 0l-6.172-6.171-1.281-1.28V79.8a4.25 4.25 0 11-8.5 0V41.646l-1.28 1.28-6.163 6.163a3.25 3.25 0 01-4.591-4.596l13.99-13.99s0 0 0 0a3.25 3.25 0 014.596 0s0 0 0 0l14 13.999a3.251 3.251 0 01-.004 4.595z",
      "fill": "#C3C9E5",
      "stroke": "#8B95C7",
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M141 142.8H59a2 2 0 00-2 2v4h86v-4a1.999 1.999 0 00-2-2zM143 148.8H57a7.471 7.471 0 006.884 4h72.266a7.416 7.416 0 006.834-3.968l.016-.032z",
      "fill": "#fff",
      "stroke": "#8B95C7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M135.298 98.502c.61.61.952 1.436.952 2.298v41.25h-72.5V100.8A3.25 3.25 0 0167 97.55h66a3.25 3.25 0 012.298.952z",
      "fill": "#C3C9E5",
      "stroke": "#8B95C7",
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M147.782 120.094h-.001a1.012 1.012 0 01-1.245.719h0l-29.034-7.78h-.001a1.012 1.012 0 01-.619-.474 1.03 1.03 0 01-.102-.773h0l5.944-22.192s0 0 0 0a1.032 1.032 0 01.475-.618 1.022 1.022 0 01.773-.102h0l4.824 1.292 2.344 4.063.156.269.3.08 20.494 5.492h.001a1.014 1.014 0 01.745.85c.018.133.009.268-.026.397v.001l-5.028 18.776z",
      "fill": "#fff",
      "stroke": "#8B95C7",
      "stroke-width": "1.5"
    }
  }), _c('path', {
    attrs: {
      "d": "M148.506 120.288c-.06.224-.163.434-.305.618a1.75 1.75 0 01-1.171.677c-.23.03-.464.015-.688-.045l-29.034-7.78a1.774 1.774 0 01-1.297-1.477 1.777 1.777 0 01.045-.689L122 89.4a1.774 1.774 0 01.824-1.074 1.767 1.767 0 011.342-.176l5.124 1.372 2.5 4.332 20.494 5.492a1.765 1.765 0 011.25 2.166l-5.028 18.776z",
      "stroke": "#8B95C7",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M83.57 113.236a1.831 1.831 0 01-1.296 2.242l-23.756 6.366a1.834 1.834 0 01-2.244-1.294L48.69 92.244A1.832 1.832 0 0149.984 90l16.428-4.4 11.536 6.66 5.622 20.976z",
      "fill": "#fff",
      "stroke": "#8B95C7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M66.412 85.598l2.438 9.098 9.098-2.438-11.536-6.66z",
      "fill": "#fff",
      "stroke": "#8B95C7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M59.97 98.618l3.388 13.584 8.98-9.454-12.368-4.13z",
      "fill": "#C3C9E5",
      "stroke": "#8B95C7",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$h = [];
/* style */

const __vue_inject_styles__$h = undefined;
/* scoped */

const __vue_scope_id__$h = undefined;
/* module identifier */

const __vue_module_identifier__$h = undefined;
/* functional template */

const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);

//
//
//
//
var script$i = {
  name: 'HeartAltIcon'
};

/* script */
const __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.99 1.992A3.814 3.814 0 007.189 3.07L7 3.286 6.836 3.1a3.828 3.828 0 00-4.824-1.108 3.92 3.92 0 00-.66 6.39l4.801 4.711a1.182 1.182 0 001.687.007l4.77-4.683A3.92 3.92 0 0014 5.42a3.878 3.878 0 00-2.01-3.428z",
      "fill": "currentColor"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "transform": "translate(0 .5)",
      "d": "M0 0h14v14H0z"
    }
  })])])]);
};

var __vue_staticRenderFns__$i = [];
/* style */

const __vue_inject_styles__$i = undefined;
/* scoped */

const __vue_scope_id__$i = undefined;
/* module identifier */

const __vue_module_identifier__$i = undefined;
/* functional template */

const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$j = {
  name: 'ExclamationIcon'
};

/* script */
const __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$j = [];
/* style */

const __vue_inject_styles__$j = undefined;
/* scoped */

const __vue_scope_id__$j = undefined;
/* module identifier */

const __vue_module_identifier__$j = undefined;
/* functional template */

const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$k = {
  name: 'CheckCircleIcon'
};

/* script */
const __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$k = [];
/* style */

const __vue_inject_styles__$k = undefined;
/* scoped */

const __vue_scope_id__$k = undefined;
/* module identifier */

const __vue_module_identifier__$k = undefined;
/* functional template */

const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$l = {
  name: 'SelectorIcon'
};

/* script */
const __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$l = [];
/* style */

const __vue_inject_styles__$l = undefined;
/* scoped */

const __vue_scope_id__$l = undefined;
/* module identifier */

const __vue_module_identifier__$l = undefined;
/* functional template */

const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$m = {
  name: 'RefreshIcon'
};

/* script */
const __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$m = [];
/* style */

const __vue_inject_styles__$m = undefined;
/* scoped */

const __vue_scope_id__$m = undefined;
/* module identifier */

const __vue_module_identifier__$m = undefined;
/* functional template */

const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$n = {
  name: 'TerminalIcon'
};

/* script */
const __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$n = [];
/* style */

const __vue_inject_styles__$n = undefined;
/* scoped */

const __vue_scope_id__$n = undefined;
/* module identifier */

const __vue_module_identifier__$n = undefined;
/* functional template */

const __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$o = {
  name: 'VolumneUpIcon'
};

/* script */
const __vue_script__$o = script$o;
/* template */

var __vue_render__$o = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM14.657 2.929a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10c0-2.21-.894-4.208-2.343-5.657a1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$o = [];
/* style */

const __vue_inject_styles__$o = undefined;
/* scoped */

const __vue_scope_id__$o = undefined;
/* module identifier */

const __vue_module_identifier__$o = undefined;
/* functional template */

const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$p = {
  name: 'VolumneOffIcon'
};

/* script */
const __vue_script__$p = script$p;
/* template */

var __vue_render__$p = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zM12.293 7.293a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$p = [];
/* style */

const __vue_inject_styles__$p = undefined;
/* scoped */

const __vue_scope_id__$p = undefined;
/* module identifier */

const __vue_module_identifier__$p = undefined;
/* functional template */

const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$q = {
  name: 'PlayIcon'
};

/* script */
const __vue_script__$q = script$q;
/* template */

var __vue_render__$q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$q = [];
/* style */

const __vue_inject_styles__$q = undefined;
/* scoped */

const __vue_scope_id__$q = undefined;
/* module identifier */

const __vue_module_identifier__$q = undefined;
/* functional template */

const __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$r = {
  name: 'PauseIcon'
};

/* script */
const __vue_script__$r = script$r;
/* template */

var __vue_render__$r = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z",
      "clip-rule": "evenodd"
    }
  })]);
};

var __vue_staticRenderFns__$r = [];
/* style */

const __vue_inject_styles__$r = undefined;
/* scoped */

const __vue_scope_id__$r = undefined;
/* module identifier */

const __vue_module_identifier__$r = undefined;
/* functional template */

const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
var script$s = {
  name: 'UploadFailedIcon'
};

/* script */
const __vue_script__$s = script$s;
/* template */

var __vue_render__$s = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "11",
      "height": "10",
      "viewBox": "0 0 11 10",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M5.5 9.5C7.98528 9.5 10 7.48528 10 5C10 2.51472 7.98528 0.5 5.5 0.5C3.01472 0.5 1 2.51472 1 5C1 7.48528 3.01472 9.5 5.5 9.5Z",
      "stroke": "#F05656",
      "stroke-miterlimit": "10"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.5 2.75V5.375",
      "stroke": "#F05656",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.8125 7.0625C5.8125 7.23509 5.67259 7.375 5.5 7.375C5.32741 7.375 5.1875 7.23509 5.1875 7.0625C5.1875 6.88991 5.32741 6.75 5.5 6.75C5.67259 6.75 5.8125 6.88991 5.8125 7.0625Z",
      "fill": "#F05656",
      "stroke": "#F05656",
      "stroke-width": "0.5"
    }
  })]);
};

var __vue_staticRenderFns__$s = [];
/* style */

const __vue_inject_styles__$s = undefined;
/* scoped */

const __vue_scope_id__$s = undefined;
/* module identifier */

const __vue_module_identifier__$s = undefined;
/* functional template */

const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);

//
//
//
//
//
//
var script$t = {
  name: 'XUploadIcon'
};

/* script */
const __vue_script__$t = script$t;
/* template */

var __vue_render__$t = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.0126 3.9234L3.92383 14.0121",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.0126 14.0121L3.92383 3.9234",
      "stroke": "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};

var __vue_staticRenderFns__$t = [];
/* style */

const __vue_inject_styles__$t = undefined;
/* scoped */

const __vue_scope_id__$t = undefined;
/* module identifier */

const __vue_module_identifier__$t = undefined;
/* functional template */

const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);

//
var script$u = {
  name: 'MainHeader',
  props: {
    selecting: Boolean
  },
  components: {
    XIcon: __vue_component__$a,
    MenuIcon: __vue_component__$7
  },
  computed: {
    activeView() {
      return this.$parent.views.find(view => view.slug == this.$parent.activeView);
    },

    selectedItems() {
      return this.$parent.selectedItems;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },
  methods: {
    closeMediaModal() {
      eventBus.emit(this.namespace, 'close-media-modal');
    },

    returnSelectedItems() {
      eventBus.emit(this.namespace, 'return-selected');
    },

    toggleSelect() {
      eventBus.emit(this.namespace, 'toggle-selecting-items');
    },

    toggleMobileMenu() {
      eventBus.emit(this.namespace, 'toggle-mobile-menu');
    }

  }
};

/* script */
const __vue_script__$u = script$u;
/* template */

var __vue_render__$u = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "header sm:tm-h-18 sm:tm-border-b tm-flex sm:tm-items-center tm-px-4 sm:tm-pl-6 tm-flex-shrink-0 tm-mt-10 sm:tm-mt-0"
  }, [_c('div', {
    staticClass: "tm-flex sm:tm-block tm-items-center tm-justify-between"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-center sm:tm-hidden"
  }, [_c('button', {
    staticClass: "tm-p-1 tm-bg-transparent tm-rounded focus:tm-outline-none focus:tm-ring focus:tm-ring-offset-1 focus:tm-ring-aquamarine",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [_c('menu-icon', {
    staticClass: "tm-h-4 tm-text-yank"
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "tm-ml-4 sm:tm-ml-0 tm-text-yank tm-font-medium tm-whitespace-nowrap tm-text-xl sm:tm-text-base"
  }, [_vm._v("\n        " + _vm._s(_vm.activeView.name) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-flex-1 sm:tm-ml-6 tm-items-center tm-justify-end tm-space-x-4"
  }, [_c('button', {
    staticClass: "tm-hidden tm-h-9 tm-border tm-rounded-xl tm-text-xs focus:tm-outline-none tm-px-4 sm:tm-flex tm-items-center hover:tm-opacity-80 tm-select-none",
    class: _vm.selectedItems.length ? 'tm-bg-aquamarine tm-border-aquamarine tm-text-white' : 'tm-bg-platinumFire tm-border-payne tm-text-cosmos',
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedItems.length
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.returnSelectedItems($event);
      }
    }
  }, [_c('span', {
    staticClass: "tm-font-medium"
  }, [_vm._v("Save and Close")])]), _vm._v(" "), _c('button', {
    staticClass: "tm-h-9 tm-w-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center tm-justify-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.closeMediaModal($event);
      }
    }
  }, [_c('x-icon', {
    staticClass: "tm-h-3.5 tm-w-3.5 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2 tm-sr-only"
  }, [_vm._v("Close Media Modal")])], 1)])]);
};

var __vue_staticRenderFns__$u = [];
/* style */

const __vue_inject_styles__$u = undefined;
/* scoped */

const __vue_scope_id__$u = undefined;
/* module identifier */

const __vue_module_identifier__$u = undefined;
/* functional template */

const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);

//
var script$v = {
  name: 'DesktopMenu',
  computed: {
    views() {
      return this.$parent.views;
    },

    activeView() {
      return this.$parent.activeView;
    },

    namespace() {
      return this.$parent.namespace;
    },

    selectLimit() {
      return this.$parent.selectLimit;
    }

  },
  methods: {
    switchView(view) {
      eventBus.emit(this.namespace, 'change-view', view);
      eventBus.emit(this.namespace, 'clear-item-selection');
    }

  }
};

/* script */
const __vue_script__$v = script$v;
/* template */

var __vue_render__$v = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('aside', {
    staticClass: "tm-hidden sm:tm-flex tm-flex-col tm-w-52 tm-flex-shrink-0 tm-h-full tm-pl-2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tm-pt-6 tm-border-r tm-flex-1"
  }, [_c('ul', {
    staticClass: "tm-list-none tm-m-0 tm-p-0"
  }, _vm._l(_vm.views, function (view) {
    return _c('li', {
      key: "menu-" + view.slug
    }, [_c('button', {
      staticClass: "tm-relative tm-flex tm-justify-between tm-items-center tm-pl-6 tm-py-3 tm-cursor-pointer tm-group tm-w-full focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded-md tm-text-base tm-bg-transparent",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.switchView(view.slug);
        }
      }
    }, [_c('div', {
      staticClass: "tm-flex tm-items-center tm-justify-between tm-flex-grow"
    }, [_c('span', {
      staticClass: "group-hover:tm-opacity-80",
      class: _vm.activeView == view.slug ? 'tm-text-aquamarine tm-font-semibold' : 'tm-text-payneFire'
    }, [_vm._v("\n              " + _vm._s(view.name) + "\n            ")])]), _vm._v(" "), _vm.activeView == view.slug ? _c('span', {
      staticClass: "side-border tm-absolute tm-right-0 tm-inset-y-0 tm-h-full tm-border-2 tm-rounded-l-md tm-border-aquamarine"
    }) : _vm._e()])]);
  }), 0)]), _vm._v(" "), _vm.selectLimit ? _c('div', {
    staticClass: "tm-h-18 tm-pr-2 tm-flex-shrink-0"
  }, [_c('div', {
    staticClass: " tm-bg-bronze tm-bg-opacity-20 tm-px-3 tm-py-2 tm-rounded-lg tm-border tm-border-payne"
  }, [_c('span', {
    staticClass: "tm-text-xs tm-text-payne"
  }, [_vm.selectLimit == 1 ? [_vm._v("\n          You can select one file.\n        ")] : [_vm._v("\n          You can select up to " + _vm._s(_vm.selectLimit) + " files.\n        ")]], 2)])]) : _vm._e()]);
};

var __vue_staticRenderFns__$v = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-h-18 tm-border-b tm-flex tm-items-center tm-pl-4 tm-flex-shrink-0"
  }, [_c('h1', {
    staticClass: "tm-font-semibold tm-text-2.5xl tm-text-yank"
  }, [_vm._v("Media")])]);
}];
/* style */

const __vue_inject_styles__$v = undefined;
/* scoped */

const __vue_scope_id__$v = undefined;
/* module identifier */

const __vue_module_identifier__$v = undefined;
/* functional template */

const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);

//
var script$w = {
  name: 'MobileMenu',
  components: {
    Logo: __vue_component__,
    XIcon: __vue_component__$a
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    views() {
      return this.$parent.views;
    },

    activeView() {
      return this.$parent.activeView;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },
  methods: {
    switchView(view) {
      eventBus.emit(this.namespace, 'change-view', view);
      eventBus.emit(this.namespace, 'clear-item-selection');
      this.show = false;
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'toggle-mobile-menu', () => this.show = !this.show);
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'toggle-mobile-menu');
  }

};

/* script */
const __vue_script__$w = script$w;
/* template */

var __vue_render__$w = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sm:tm-hidden"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-transition-opacity tm-ease-linear tm-duration-300",
      "enter-class": "tm-opacity-90",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-transition-opacity tm-ease-linear tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-90"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-flex tm-z-40"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-transition-opacity tm-ease-linear tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-transition-opacity tm-ease-linear tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-fixed tm-inset-0",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-60"
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-transition tm-ease-in-out tm-duration-300 tm-transform",
      "enter-class": "tm--translate-x-full",
      "enter-to-class": "tm-translate-x-0",
      "leave-active-class": "tm-transition tm-ease-in-out tm-duration-300 tm-transform",
      "leave-class": "tm-translate-x-0",
      "leave-to-class": "tm--translate-x-full"
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-relative tm-flex tm-flex-col tm-w-56 tm-pt-5 tm-pb-4 tm-bg-white tm-rounded-r-xl"
  }, [_c('div', {
    staticClass: "tm-absolute tm-top-0 tm-right-0 tm--mr-12 tm-pt-2"
  }, [_c('button', {
    staticClass: "tm-ml-1 tm-flex tm-items-center tm-justify-center tm-h-10 tm-w-10 tm-rounded-full focus:tm-outline-none focus:tm-ring-2 focus:tm-ring-inset focus:tm-ring-white tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('span', {
    staticClass: "tm-sr-only"
  }, [_vm._v("Close sidebar")]), _vm._v(" "), _c('x-icon', {
    staticClass: "tm-h-6 tm-w-6 tm-text-white"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex-shrink-0 tm-flex tm-items-center tm-px-6 tm-pt-8"
  }, [_c('logo', {
    staticClass: "tm-h-10 tm-w-auto"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-12 tm-flex-1 tm-h-0 tm-overflow-y-auto"
  }, [_c('nav', {
    staticClass: "tm-space-y-1"
  }, [_c('ul', {
    staticClass: "tm-list-none tm-m-0 tm-p-0"
  }, _vm._l(_vm.views, function (view) {
    return _c('li', {
      key: "menu-" + view.slug
    }, [_c('button', {
      staticClass: "tm-relative tm-flex tm-justify-between tm-items-center tm-pl-6 tm-py-2 tm-my-2 tm-cursor-pointer tm-group tm-w-full focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded-md tm-bg-transparent tm-text-base",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.switchView(view.slug);
        }
      }
    }, [_c('div', {
      staticClass: "tm-flex tm-items-center tm-justify-between tm-flex-grow"
    }, [_c('span', {
      staticClass: "group-hover:tm-opacity-80",
      class: _vm.activeView == view.slug ? 'tm-text-aquamarine tm-font-semibold' : 'tm-text-payneFire'
    }, [_vm._v("\n                        " + _vm._s(view.name) + "\n                      ")])]), _vm._v(" "), _vm.activeView == view.slug ? _c('span', {
      staticClass: "side-border tm-absolute tm-right-0 tm-inset-y-0 tm-h-full tm-border-4 tm-rounded-l-md tm-border-aquamarine tm--mr-0.5"
    }) : _vm._e()])]);
  }), 0)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex-shrink-0 tm-w-14",
    attrs: {
      "aria-hidden": "true"
    }
  })], 1)])], 1);
};

var __vue_staticRenderFns__$w = [];
/* style */

const __vue_inject_styles__$w = undefined;
/* scoped */

const __vue_scope_id__$w = undefined;
/* module identifier */

const __vue_module_identifier__$w = undefined;
/* functional template */

const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);

//
var script$x = {
  name: 'CreateFolderDropdown',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundary: {
      type: String,
      default: 'scrollParent'
    },
    locationId: String,
    productId: String
  },

  data() {
    return {
      show: false,
      folderName: '',
      error: null,
      working: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (show) {
        setTimeout(() => {
          this.popper = createPopper(this.$el, this.$refs.dropdown, {
            strategy: "fixed",
            placement: this.placement,
            strategy: "fixed",
            modifiers: [{
              name: 'preventOverflow',
              options: {
                boundary: this.boundary
              }
            }, {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }]
          });
          this.$refs.input.focus();
        }, 200);
      } else if (this.popper) {
        this.folderName = '';
        this.error = null;
        setTimeout(() => this.popper.destroy(), 100);
      }
    },

    folderName(folderName, oldFolderName) {
      if (folderName != oldFolderName) {
        this.error = null;
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    createFolder() {
      this.working = true;
      api.post('/church-media/folders', {
        name: this.folderName,
        product_id: this.productId,
        location_id: this.locationId
      }).then(({
        data
      }) => {
        eventBus.emit(this.namespace, 'new-folder-created', data);
        this.show = false;
      }).catch(error => {
        this.error = error.response.data.errors.name[0];
        setTimeout(() => {
          this.$refs.input.focus();
          this.$refs.input.select();
        }, 100);
      }).finally(() => this.working = false);
    }

  }
};

/* script */
const __vue_script__$x = script$x;
/* template */

var __vue_render__$x = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('button', {
    staticClass: "tm-bg-gray-100",
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("Open")])], {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm.show ? _c('portal', {
    attrs: {
      "to": "dropdown-" + _vm.namespace
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    staticClass: "create-folder-dropdown tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })]), _vm._v(" "), _c('section', {
    ref: "dropdown",
    staticClass: "tm-w-44 tm-z-50 tm-bg-white tm-rounded-md tm-shadow-lg tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-py-1 tm-px-3 tm-py-2",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createFolder($event);
      }
    }
  }, [_c('div', [_c('label', {
    staticClass: "tm-block tm-text-xs tm-font-medium tm-text-yank",
    attrs: {
      "for": "new_folder_name"
    }
  }, [_vm._v("\n              New Folder Name\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.folderName,
      expression: "folderName"
    }],
    ref: "input",
    staticClass: "tm-text-xs tm-rounded-lg tm-border tm-border-payne tm-h-7 tm-px-2 tm-placeholder-cosmosHot focus:tm-outline-none focus:tm-border-payneFire tm-w-full tm-appearance-none",
    attrs: {
      "type": "text",
      "id": "new_folder_name",
      "name": "new_folder_name",
      "required": "",
      "minlength": "1",
      "disabled": _vm.working
    },
    domProps: {
      "value": _vm.folderName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.folderName = $event.target.value;
      }
    }
  })]), _vm._v(" "), _vm.error ? _c('div', {
    staticClass: "tm-text-xs tm-mt-1 tm-text-red-700"
  }, [_vm._v("\n              " + _vm._s(_vm.error) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2 tm-flex tm-items-center tm-space-x-1"
  }, [_c('button', {
    staticClass: "tm-text-xs tm-text-aquamarine tm-font-medium focus:tm-outline-none focus:tm-ring focus:tm-ring-aquamarine tm-px-1 tm-py-0.5 tm-rounded disabled:tm-opacity-60 tm-bg-transparent",
    attrs: {
      "type": "submit",
      "disabled": _vm.working
    }
  }, [_vm._v("\n              Create Folder\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "tm-text-xs tm-text-payneHot tm-font-medium focus:tm-outline-none focus:tm-ring focus:tm-ring-aquamarine tm-px-1 tm-py-0.5 tm-rounded disabled:tm-opacity-60 tm-bg-transparent",
    attrs: {
      "type": "button",
      "disabled": _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])])])], 1)]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$x = [];
/* style */

const __vue_inject_styles__$x = undefined;
/* scoped */

const __vue_scope_id__$x = undefined;
/* module identifier */

const __vue_module_identifier__$x = undefined;
/* functional template */

const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);

//
var script$y = {
  name: 'EmptyState',
  props: {
    productId: String,
    locationId: String
  },
  components: {
    UploadIcon: __vue_component__$2,
    EmptyStateSvg: __vue_component__$h,
    FolderPlusIcon: __vue_component__$4,
    CreateFolderDropdown: __vue_component__$x
  },
  computed: {
    namespace() {
      return this.$parent.$parent.namespace;
    }

  },
  methods: {
    showUploadView() {
      eventBus.emit(this.namespace, 'show-upload-view');
    }

  }
};

/* script */
const __vue_script__$y = script$y;
/* template */

var __vue_render__$y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-mt-10 sm:tm-mt-0 tm-flex tm-items-center tm-flex-col"
  }, [_c('empty-state-svg', {
    staticClass: "tm-h-48 sm:tm-h-40 sm:tm-mt-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-text-center"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "tm-text-payne tm-text-xs tm-mt-2"
  }, [_vm._v("Use the button below to add files.")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-flex tm-justify-center tm-space-x-4"
  }, [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-text-xs focus:tm-outline-none tm-px-4 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-aquamarine tm-border-aquamarine tm-text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showUploadView($event);
      }
    }
  }, [_c('upload-icon', {
    staticClass: "tm-h-4 tm-w-4"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("Upload")])], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-hidden sm:tm-block"
  }, [_c('create-folder-dropdown', {
    attrs: {
      "location-id": _vm.locationId,
      "product-id": _vm.productId
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var toggle = ref.toggle;
        return [_c('button', {
          staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return toggle($event);
            }
          }
        }, [_c('folder-plus-icon', {
          staticClass: "tm-h-4 tm-w-4 tm-text-payneFire"
        }), _vm._v(" "), _c('span', {
          staticClass: "tm-ml-2"
        }, [_vm._v("New Folder")])], 1)];
      }
    }])
  })], 1)])])], 1);
};

var __vue_staticRenderFns__$y = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('h2', {
    staticClass: "tm-leading-tight tm-text-lg tm-font-semibold tm-text-yankFire tm-flex tm-items-center tm-flex-col"
  }, [_c('span', [_vm._v("It’s pretty empty in here")]), _vm._v(" "), _c('span', [_vm._v("don’t you think?")])]);
}];
/* style */

const __vue_inject_styles__$y = undefined;
/* scoped */

const __vue_scope_id__$y = undefined;
/* module identifier */

const __vue_module_identifier__$y = undefined;
/* functional template */

const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);

//
var script$z = {
  name: 'ItemDropdown',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundary: {
      type: String,
      default: 'scrollParent'
    },
    item: Object
  },
  components: {
    DownloadAltIcon: __vue_component__$b,
    FolderPlusAltIcon: __vue_component__$5,
    ShareAltIcon: __vue_component__$c,
    TrashAltIcon: __vue_component__$e,
    HeartAltIcon: __vue_component__$i,
    EditIcon: __vue_component__$9,
    TerminalIcon: __vue_component__$n
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (show) {
        this.$parent.dropdownOpened = true;
        this.$nextTick(() => {
          this.popper = createPopper(this.$el, this.$refs.dropdown, {
            placement: this.placement,
            strategy: "fixed",
            modifiers: [{
              name: 'preventOverflow',
              options: {
                boundary: this.boundary
              }
            }, {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }]
          });
        });
      } else if (this.popper) {
        this.$parent.dropdownOpened = false;
        setTimeout(() => this.popper.destroy(), 100);
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    downloadItem() {
      eventBus.emit(this.namespace, 'download', {
        url: this.item.url,
        file_name: this.item.file_name
      });
      this.show = false;
    },

    startEditing() {
      this.$emit('edit');
      this.show = false;
    },

    showMoveModal() {
      eventBus.emit(this.namespace, 'show-move-modal', this.item);
      this.show = false;
    },

    toggleFavorite() {
      api.patch(`/church-media/items/${this.item.uuid}/toggle-favorite`).then(({
        data
      }) => {
        this.show = false;
        this.item.favorited = data.favorited;

        if (!data.favorited) {
          eventBus.emit(this.namespace, 'remove-church-item-from-favorited', this.item);
        }
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
      });
    },

    showRemoveItemModal() {
      eventBus.emit(this.namespace, 'show-remove-item-modal', {
        item: this.item,
        force: false
      });
      this.show = false;
    },

    showEditItemModal() {
      eventBus.emit(this.namespace, 'show-edit-item-modal', this.item);
      this.show = false;
    }

  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

};

/* script */
const __vue_script__$z = script$z;
/* template */

var __vue_render__$z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('button', {
    staticClass: "tm-bg-gray-100",
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("Open")])], {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm.show ? _c('portal', {
    attrs: {
      "to": "dropdown-" + _vm.namespace
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })]), _vm._v(" "), _c('section', {
    ref: "dropdown",
    staticClass: "tm-w-44 tm-z-50 tm-bg-white tm-rounded-md tm-shadow-lg tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-py-1",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Download\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showEditItemModal($event);
      }
    }
  }, [_c('edit-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Edit\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showMoveModal($event);
      }
    }
  }, [_c('folder-plus-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Move\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": _vm.toggleFavorite
    }
  }, [_c('heart-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v(" "), _vm.item.favorited ? _c('span', [_vm._v("Unfavorite")]) : _c('span', [_vm._v("Favorite")])], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.startEditing($event);
      }
    }
  }, [_c('terminal-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Rename\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRemoveItemModal($event);
      }
    }
  }, [_c('trash-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Delete\n        ")], 1)])], 1)]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$z = [];
/* style */

const __vue_inject_styles__$z = undefined;
/* scoped */

const __vue_scope_id__$z = undefined;
/* module identifier */

const __vue_module_identifier__$z = undefined;
/* functional template */

const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);

//
var script$A = {
  name: 'FileTypePreview',
  props: {
    item: Object,
    withBorder: {
      type: Boolean,
      default: true
    }
  },
  components: {
    FolderPreview: __vue_component__$6
  },
  computed: {
    itemExtension() {
      return this.item.url.split('.').pop();
    }

  }
};

var css_248z$1 = "@import url(https://cdn.jsdelivr.net/npm/file-icon-vectors@1.0.0/dist/file-icon-square-o.min.css);";
var stylesheet$1="@import url(https://cdn.jsdelivr.net/npm/file-icon-vectors@1.0.0/dist/file-icon-square-o.min.css);";
styleInject(css_248z$1);

/* script */
const __vue_script__$A = script$A;
/* template */

var __vue_render__$A = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-absolute tm-top-0 tm-left-0 tm-inset-0 tm-flex tm-items-center tm-justify-center tm-select-none"
  }, [_vm.item.type == 'image' ? [_c('div', {
    staticClass: "tm-w-full tm-flex tm-items-center tm-justify-center"
  }, [_c('img', {
    staticClass: "tm-w-full md:tm-w-56 tm-max-h-56 tm-rounded-lg tm-object-cover",
    attrs: {
      "src": _vm.item.url
    }
  })])] : _vm.item.type == 'pdf' ? [_c('div', {
    staticClass: "tm-w-full tm-h-full tm-rounded-lg tm-flex tm-justify-center tm-items-center",
    class: {
      'tm-border-2 tm-border-payneHot': _vm.withBorder
    }
  }, [_c('span', {
    staticClass: "fiv-sqo fiv-size-lg fiv-icon-pdf"
  })])] : _vm.item.type == 'folder' ? [_c('FolderPreview', {
    staticClass: "tm-h-18"
  })] : [_c('div', {
    staticClass: "tm-w-full tm-h-full tm-rounded-lg tm-flex tm-justify-center tm-items-center",
    class: {
      'tm-border-2 tm-border-payneHot': _vm.withBorder
    }
  }, [_c('span', {
    staticClass: "fiv-sqo fiv-size-lg",
    class: "fiv-icon-" + _vm.itemExtension
  })])]], 2);
};

var __vue_staticRenderFns__$A = [];
/* style */

const __vue_inject_styles__$A = undefined;
/* scoped */

const __vue_scope_id__$A = undefined;
/* module identifier */

const __vue_module_identifier__$A = undefined;
/* functional template */

const __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);

//
var script$B = {
  name: 'ItemDropdown',
  props: {
    folder: Object,
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundary: {
      type: String,
      default: 'scrollParent'
    }
  },
  components: {
    DownloadAltIcon: __vue_component__$b,
    EditIcon: __vue_component__$9,
    TrashAltIcon: __vue_component__$e
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (show) {
        this.$parent.dropdownOpened = true;
        this.$nextTick(() => {
          this.popper = createPopper(this.$el, this.$refs.dropdown, {
            placement: this.placement,
            strategy: "fixed",
            modifiers: [{
              name: 'preventOverflow',
              options: {
                boundary: this.boundary
              }
            }, {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }]
          });
        });
      } else if (this.popper) {
        this.$parent.dropdownOpened = false;
        setTimeout(() => this.popper.destroy(), 100);
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    startEditing() {
      this.$emit('edit');
      this.show = false;
    },

    showRemoveItemModal() {
      eventBus.emit(this.namespace, 'show-remove-item-modal', {
        item: this.folder,
        force: false
      });
      this.show = false;
    },

    downloadFolderItems() {
      let time = new Date().getTime();
      eventBus.emit(this.namespace, 'multiple-download', {
        params: this.prepareItems(),
        file_name: `${this.folder.slug}-${time}`
      });
      this.show = false;
    },

    prepareItems() {
      let items = {
        'church-media': []
      };
      this.folder.items.forEach(item => {
        items['church-media'].push(item.uuid);
      });
      return items;
    }

  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

};

/* script */
const __vue_script__$B = script$B;
/* template */

var __vue_render__$B = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('button', {
    staticClass: "tm-bg-gray-100",
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("Open")])], {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm.show ? _c('portal', {
    attrs: {
      "to": "dropdown-" + _vm.namespace
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })]), _vm._v(" "), _c('section', {
    ref: "dropdown",
    staticClass: "tm-w-44 tm-z-50 tm-bg-white tm-rounded-md tm-shadow-lg tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-py-1",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.folder.items.length ? _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadFolderItems($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Download\n        ")], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.startEditing($event);
      }
    }
  }, [_c('edit-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Rename\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRemoveItemModal($event);
      }
    }
  }, [_c('trash-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Delete\n        ")], 1)])], 1)]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$B = [];
/* style */

const __vue_inject_styles__$B = undefined;
/* scoped */

const __vue_scope_id__$B = undefined;
/* module identifier */

const __vue_module_identifier__$B = undefined;
/* functional template */

const __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);

//
var script$C = {
  name: 'FavoriteComponent',
  props: {
    item: {
      type: Object,
      required: true
    },
    itemType: {
      type: String,
      default: 'church'
    }
  },

  data() {
    return {
      processingFavorite: false
    };
  },

  methods: {
    toggleFavorite() {
      this.processingFavorite = true;
      api.patch(this.itemType == 'church' ? `/church-media/items/${this.item.uuid}/toggle-favorite` : `/media/items/${this.item.id}/toggle-favorite`).then(({
        data
      }) => {
        this.item.favorited = data.favorited;

        if (!data.favorited) {
          eventBus.emit(this.namespace, this.itemType == 'church' ? 'remove-church-item-from-favorited' : 'remove-media-item-from-favorited', this.item);
        }

        this.processingFavorite = false;
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
        this.processingFavorite = false;
      });
    }

  }
};

var css_248z$2 = "@import url(https://cdn.jsdelivr.net/npm/file-icon-vectors@1.0.0/dist/file-icon-square-o.min.css);";
var stylesheet$2="@import url(https://cdn.jsdelivr.net/npm/file-icon-vectors@1.0.0/dist/file-icon-square-o.min.css);";
styleInject(css_248z$2);

/* script */
const __vue_script__$C = script$C;
/* template */

var __vue_render__$C = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative tm-z-20",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [!_vm.item.favorited ? _c('button', {
    staticClass: "tm-text-white tm-w-8 tm-h-8 tm-bg-transparent tm-text-opacity-50 hover:tm-text-opacity-100 tm-transition tm-outline-none focus:tm-outline-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleFavorite($event);
      }
    }
  }, [!_vm.processingFavorite ? _c('svg', {
    staticClass: "h-6 w-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
    }
  })]) : _vm._e(), _vm._v(" "), _vm.processingFavorite ? _c('svg', {
    staticClass: "tm-animate-spin tm-h-4 tm-w-4 tm-ml-0.5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "opacity-75",
    attrs: {
      "fill": "currentColor",
      "d": "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.item.favorited ? _c('button', {
    staticClass: "tm-text-white tm-w-8 tm-h-8 tm-bg-transparent hover:tm-text-opacity-90 tm-transition tm-outline-none focus:tm-outline-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleFavorite($event);
      }
    }
  }, [!_vm.processingFavorite ? _c('svg', {
    staticClass: "h-6 w-6",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z",
      "clip-rule": "evenodd"
    }
  })]) : _vm._e(), _vm._v(" "), _vm.processingFavorite ? _c('svg', {
    staticClass: "tm-animate-spin tm-h-4 tm-w-4 tm-ml-0.5",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "opacity-75",
    attrs: {
      "fill": "currentColor",
      "d": "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }
  })]) : _vm._e()]) : _vm._e()]);
};

var __vue_staticRenderFns__$C = [];
/* style */

const __vue_inject_styles__$C = undefined;
/* scoped */

const __vue_scope_id__$C = undefined;
/* module identifier */

const __vue_module_identifier__$C = undefined;
/* functional template */

const __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);

//
var script$D = {
  name: "ItemComponent",
  props: {
    item: Object,
    selectable: {
      type: Boolean,
      default: true
    },
    selected: Boolean
  },
  components: {
    DotsHorizontalIcon: __vue_component__$3,
    CheckboxIcon: __vue_component__$8,
    FolderPreview: __vue_component__$6,
    ItemDropdown: __vue_component__$z,
    FolderDropdown: __vue_component__$B,
    FileTypePreview: __vue_component__$A,
    HeartAltIcon: __vue_component__$i,
    FavoriteComponent: __vue_component__$C
  },

  data() {
    return {
      dropdownOpened: false,
      editing: false,
      editError: false,
      itemName: this.item.name,
      cmdmultipleSelection: false,
      ctrlmultipleSelection: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace || this.$parent.$parent.namespace;
    },

    isSelected() {
      if (typeof this.selected != "undefined") {
        return this.selected;
      }

      let findItem = this.selectedItems.find(i => i.type == this.item.type && i.uuid == this.item.uuid);
      return typeof findItem != "undefined";
    },

    isPreviewing() {
      return this.$parent.$parent.itemPreview == this.item;
    },

    selecting() {
      return this.$parent.selectingItems;
    },

    isActive() {
      return this.isSelected || this.dropdownOpened || this.selecting || this.isPreviewing;
    },

    selectedItems() {
      return this.$parent.$parent.selectedItems;
    }

  },

  mounted() {
    document.addEventListener("keydown", this.enableMultipleSelection);
    document.addEventListener("keyup", this.disableMultipleSelection);
  },

  watch: {
    editing(editing) {
      if (editing) {
        document.addEventListener("keydown", this.handleEscapeKey);
      } else {
        document.removeEventListener("keydown", this.handleEscapeKey);
      }
    },

    itemName(itemName, oldItemName) {
      if (itemName != oldItemName) {
        this.editError = false;
      }
    }

  },
  methods: {
    toggleMediaPreview() {
      if (this.item.type == "folder") {
        eventBus.emit(this.namespace, "select-folder", this.item);
        return;
      }

      let index = this.selectedItems.findIndex(media => media.id == this.item.id && media.type == this.item.type);

      if (!this.isSelected) {
        if (!this.cmdMultipleSelection && !this.ctrlMultipleSelection) {
          eventBus.emit(this.namespace, 'clear-item-selection');
        }

        eventBus.emit(this.namespace, 'select-item', this.item);
      } else if (this.cmdMultipleSelection || this.ctrlMultipleSelection || this.selectedItems.length == 1) {
        eventBus.emit(this.namespace, 'remove-item', index);
      }

      eventBus.emit(this.namespace, "toggle-preview", this.item);
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.editing = false;
      }
    },

    enableMultipleSelection(e) {
      if (e.key === 'Meta') {
        this.cmdMultipleSelection = true;
      }

      if (e.key === 'Control') {
        this.ctrlMultipleSelection = true;
      }

      if (e.key === 'Escape') {
        eventBus.emit(this.namespace, 'clear-item-selection');
      }
    },

    disableMultipleSelection(e) {
      if (e.key === 'Meta') {
        this.cmdMultipleSelection = false;
      }

      if (e.key === 'Control') {
        this.ctrlMultipleSelection = false;
      }
    },

    enableEditing() {
      this.itemName = this.item.name;
      this.editing = true;
      setTimeout(() => {
        this.$refs.itemName.focus();
        this.$refs.itemName.select();
      }, 100);
    },

    saveItem() {
      if (this.item.type == "folder") {
        this.saveFolder();
        return;
      }

      this.saveChurchItem();
    },

    saveFolder() {
      api.put(`/church-media/folders/${this.item.id}`, {
        name: this.itemName,
        location_id: this.item.location_id,
        product_id: this.item.product_id
      }).then(({
        data
      }) => {
        eventBus.emit(this.namespace, "updated-folder", data);
        this.editing = false;
      }).catch(error => {
        this.editError = true;
        eventBus.emit(this.namespace, "toast-error", error.response.data.errors.name[0]);
      });
    },

    saveChurchItem() {
      api.put(`/church-media/items/${this.item.id}`, {
        name: this.itemName,
        location_id: this.item.location_id,
        product_id: this.item.product_id
      }).then(({
        data
      }) => {
        eventBus.emit(this.namespace, "updated-church-item", data);
        this.editing = false;
      }).catch(error => {
        this.editError = true;
        eventBus.emit(this.namespace, "toast-error", error.response.data.errors.name[0]);
      });
    }

  }
};

/* script */
const __vue_script__$D = script$D;
/* template */

var __vue_render__$D = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative tm-group tm-overflow-hidden"
  }, [_c('div', {
    staticClass: "tm-relative tm-pb-full tm-rounded-lg tm-overflow-hidden tm-cursor-pointer",
    on: {
      "click": _vm.toggleMediaPreview
    }
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _vm.item.type != 'folder' ? _c('div', {
    staticClass: "tm-h-full tm-w-full tm-rounded-item tm-absolute tm-top-0 tm-bg-gradient-to-t tm-from-gray-900 tm-opacity-0 group-hover:tm-opacity-30 tm-z-10"
  }) : _vm._e(), _vm._v(" "), _vm.item.type != 'folder' ? _c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-end tm-absolute tm-bottom-1 tm-pr-2 tm-right-0 tm-inset-x-0 tm-z-20 tm-opacity-0 group-hover:tm-opacity-100 tm-transition"
  }, [_c('favorite-component', {
    attrs: {
      "item": _vm.item
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-z-10 tm-bg-carolina tm-transition-all tm-duration-200",
    class: _vm.isSelected || _vm.isPreviewing ? 'tm-bg-opacity-20' : 'tm-bg-opacity-0'
  })], 1), _vm._v(" "), !_vm.editing ? _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2",
    on: {
      "dblclick": _vm.enableEditing
    }
  }, [_vm._v("\n    " + _vm._s(_vm.item.name) + "\n  ")]) : _c('div', {
    staticClass: "tm-mt-1"
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.editing = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-relative tm-z-50"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.saveItem($event);
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.itemName,
      expression: "itemName"
    }],
    ref: "itemName",
    staticClass: "tm-text-xs tm-rounded-lg tm-border  tm-h-7 tm-border-payne  tm-px-2 tm-placeholder-cosmosHot focus:tm-outline-none tm-w-full tm-appearance-none",
    class: _vm.editError ? 'tm-border-red-600 focus:tm-red-600 tm-bg-red-50' : 'focus:tm-border-payneFire',
    attrs: {
      "type": "text",
      "required": "",
      "minlength": "1"
    },
    domProps: {
      "value": _vm.itemName
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.itemName = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tm-sr-only",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save item name")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-top-0 tm-inset-x-0 tm-z-20 tm-flex tm-justify-between tm-mt-2 tm-mx-2 tm-opacity-0 group-hover:tm-opacity-100 tm-transition",
    class: {
      'tm-opacity-100': _vm.isActive
    }
  }, [_c('div', [_vm.isSelected ? _c('div', [_c('checkbox-icon', {
    staticClass: "tm-h-5 tm-w-5 tm-cursor-pointer",
    attrs: {
      "checked": _vm.isSelected
    }
  })], 1) : _vm._e()]), _vm._v(" "), _vm._t("default", [_vm.item.type != 'folder' ? _c('item-dropdown', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "edit": _vm.enableEditing
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var toggle = ref.toggle;
        return [_c('button', {
          staticClass: "tm-bg-white tm-p-0 tm-h-5 tm-w-5 tm-border tm-border-payneHot tm-rounded tm-hidden sm:tm-flex tm-items-center\n          tm-justify-center hover:tm-bg-gray-100 focus:tm-outline-none focus:tm-border-payneFire ",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return toggle($event);
            }
          }
        }, [_c('DotsHorizontalIcon', {
          staticClass: "tm-h-4 tm-text-payneHot"
        })], 1)];
      }
    }], null, false, 181604691)
  }) : _c('folder-dropdown', {
    attrs: {
      "folder": _vm.item
    },
    on: {
      "edit": _vm.enableEditing
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var toggle = ref.toggle;
        return [_c('button', {
          staticClass: "tm-bg-white tm-h-5 tm-w-5 tm-p-0 tm-border tm-border-payneHot tm-rounded tm-hidden sm:tm-flex tm-items-center\n          tm-justify-center hover:tm-bg-gray-100 focus:tm-outline-none focus:tm-border-payneFire ",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              $event.stopPropagation();
              return toggle($event);
            }
          }
        }, [_c('DotsHorizontalIcon', {
          staticClass: "tm-h-4 tm-text-payneHot"
        })], 1)];
      }
    }])
  })], {
    "enableEditing": _vm.enableEditing,
    "item": _vm.item
  })], 2)]);
};

var __vue_staticRenderFns__$D = [];
/* style */

const __vue_inject_styles__$D = undefined;
/* scoped */

const __vue_scope_id__$D = undefined;
/* module identifier */

const __vue_module_identifier__$D = undefined;
/* functional template */

const __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$D = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
var script$E = {
  props: {
    selectLimit: Number
  }
};

/* script */
const __vue_script__$E = script$E;
/* template */

var __vue_render__$E = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "sm:tm-hidden tm-bg-bronze tm-bg-opacity-20 tm-px-3 tm-py-2 tm-rounded-lg tm-border tm-border-payne tm-mt-4"
  }, [_c('span', {
    staticClass: "tm-text-xs tm-text-payne"
  }, [_vm.selectLimit == 1 ? [_vm._v("\n      You can select one file.\n    ")] : [_vm._v("\n      You can select up to " + _vm._s(_vm.selectLimit) + " files.\n    ")]], 2)]);
};

var __vue_staticRenderFns__$E = [];
/* style */

const __vue_inject_styles__$E = undefined;
/* scoped */

const __vue_scope_id__$E = undefined;
/* module identifier */

const __vue_module_identifier__$E = undefined;
/* functional template */

const __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$E = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);

//
var script$F = {
  name: "AllItemsView",
  props: {
    folders: Array,
    items: Array,
    hasPreview: Boolean,
    hasMore: Boolean,
    showOptionsHeader: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ItemComponent: __vue_component__$D,
    SearchIcon: __vue_component__$1,
    UploadIcon: __vue_component__$2,
    FolderPlusIcon: __vue_component__$4,
    ArrowLeftIcon: __vue_component__$f,
    InfiniteLoading,
    CreateFolderDropdown: __vue_component__$x,
    EmptyState: __vue_component__$y,
    MobileFileSelectLimitMessage: __vue_component__$E
  },

  data() {
    return {
      query: ""
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    },

    selectLimit() {
      return this.$parent.selectLimit;
    },

    allItems() {
      return [].concat(this.folders, this.items);
    },

    selectingItems() {
      return this.$parent.selectingItems;
    },

    locationId() {
      return this.$parent.locationId;
    },

    productId() {
      return this.$parent.productId;
    }

  },
  watch: {
    allItems(allItems) {
      const item = allItems.find(item => item.selected);

      if (item) {
        const itemExists = this.$parent.selectedItems.find(selectedItem => item.id == selectedItem.id);

        if (!itemExists) {
          this.$parent.selectedItems.push(item);
        }
      }
    }

  },
  methods: {
    runSearch() {
      this.$emit("search", this.query);
    },

    runSearchEnter() {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        this.$emit("search", this.query);
      }
    },

    isWebP(item) {
      if (!item) {
        return false;
      }

      if (item.type === "folder") {
        return false;
      }

      if (item.files && item.files.length > 0) {
        return item.files[0].mime_type === "image/webp";
      }
    },

    toggleSelect() {
      eventBus.emit(this.namespace, "toggle-selecting-items");
    },

    isSelected(item) {
      let findItem = this.$parent.selectedItems.find(i => i.type == item.type && i.uuid == item.uuid);
      return typeof findItem != "undefined";
    },

    showUploadView() {
      eventBus.emit(this.namespace, "show-upload-view");
    },

    loadMore($state) {
      this.$emit("load-more", $state);
    }

  }
};

/* script */
const __vue_script__$F = script$F;
/* template */

var __vue_render__$F = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_vm.folders.length || _vm.allItems.length ? _c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-between tm-space-x-4"
  }, [_vm.showOptionsHeader ? _c('div', {
    staticClass: "search-field tm-relative tm-max-w-2xs tm-w-full"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.query,
      expression: "query"
    }],
    staticClass: "tm-text-xs tm-rounded-lg tm-border tm-border-payne tm-h-9 tm-pl-4 tm-pr-8 tm-placeholder-cosmosHot focus:tm-outline-none focus:tm-border-payneFire tm-w-full tm-appearance-none",
    attrs: {
      "type": "search",
      "placeholder": "Search My Media"
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "search": _vm.runSearch,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.runSearchEnter($event);
      },
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.query = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-absolute tm-right-0 tm-inset-y-0 tm-flex tm-items-center tm-justify-center tm-mr-4"
  }, [_c('search-icon', {
    staticClass: "tm-h-3 tm-w-3 tm-text-payneFire"
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.showOptionsHeader ? _c('div', {
    staticClass: "tm-flex tm-items-center tm-space-x-4"
  }, [_c('div', [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showUploadView($event);
      }
    }
  }, [_c('upload-icon', {
    staticClass: "tm-h-4 tm-w-4 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("Upload")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-hidden sm:tm-block"
  }, [_c('create-folder-dropdown', {
    attrs: {
      "location-id": _vm.locationId,
      "product-id": _vm.productId
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var toggle = ref.toggle;
        return [_c('button', {
          staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return toggle($event);
            }
          }
        }, [_c('folder-plus-icon', {
          staticClass: "tm-h-4 tm-w-4 tm-text-payneFire"
        }), _vm._v(" "), _c('span', {
          staticClass: "tm-ml-2"
        }, [_vm._v("New Folder")])], 1)];
      }
    }], null, false, 3871242627)
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "all-items tm-mt-6"
  }, [_c('div', {
    staticClass: "sm:tm-hidden tm-flex tm-justify-between tm-items-center"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base"
  }, [_vm._v("All Files")]), _vm._v(" "), _c('div', [!_vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Select\n        ")]) : _vm._e(), _vm._v(" "), _vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]) : _vm._e()])]), _vm._v(" "), _vm.selectingItems && _vm.selectLimit ? _c('div', [_c('mobile-file-select-limit-message', {
    attrs: {
      "select-limit": _vm.selectLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'lg:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, _vm._l(_vm.allItems, function (item) {
    return _c('item-component', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isWebP(item),
        expression: "!isWebP(item)"
      }],
      key: "all-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      }
    });
  }), 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    staticClass: "tm-mt-4",
    attrs: {
      "spinner": "spiral"
    },
    on: {
      "infinite": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("\n        No more media to load\n      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [!_vm.folders.length ? _c('empty-state', {
    attrs: {
      "location-id": _vm.locationId,
      "product-id": _vm.productId
    }
  }) : _vm._e()], 1)])], 1)]);
};

var __vue_staticRenderFns__$F = [];
/* style */

const __vue_inject_styles__$F = undefined;
/* scoped */

const __vue_scope_id__$F = undefined;
/* module identifier */

const __vue_module_identifier__$F = undefined;
/* functional template */

const __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$F = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);

//
var script$G = {
  name: 'FolderEmptyState',
  components: {
    UploadIcon: __vue_component__$2,
    EmptyStateSvg: __vue_component__$h
  },
  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  methods: {
    showUploadView() {
      eventBus.emit(this.namespace, 'show-upload-view');
    }

  }
};

/* script */
const __vue_script__$G = script$G;
/* template */

var __vue_render__$G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-mt-10 sm:tm-mt-0 tm-flex tm-items-center tm-flex-col"
  }, [_c('empty-state-svg', {
    staticClass: "tm-h-48 sm:tm-h-40 sm:tm-mt-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-text-center"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "tm-text-payne tm-text-xs tm-mt-2"
  }, [_vm._v("Use the button below to add files.")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-flex tm-justify-center"
  }, [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-text-xs focus:tm-outline-none tm-px-4 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-aquamarine tm-border-aquamarine tm-text-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showUploadView($event);
      }
    }
  }, [_c('upload-icon', {
    staticClass: "tm-h-4 tm-w-4"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("Upload")])], 1)])])], 1);
};

var __vue_staticRenderFns__$G = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('h2', {
    staticClass: "tm-leading-tight tm-text-lg tm-font-semibold tm-text-yankFire tm-flex tm-items-center tm-flex-col"
  }, [_c('span', [_vm._v("It’s pretty empty in here")]), _vm._v(" "), _c('span', [_vm._v("don’t you think?")])]);
}];
/* style */

const __vue_inject_styles__$G = undefined;
/* scoped */

const __vue_scope_id__$G = undefined;
/* module identifier */

const __vue_module_identifier__$G = undefined;
/* functional template */

const __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);

//
var script$H = {
  name: 'FolderItemsView',
  props: {
    folder: Object,
    hasPreview: Boolean,
    uploadingFilesLength: Number
  },

  data() {
    return {
      actualFolder: null,
      isLoading: false
    };
  },

  components: {
    ItemComponent: __vue_component__$D,
    SearchIcon: __vue_component__$1,
    UploadIcon: __vue_component__$2,
    ArrowLeftIcon: __vue_component__$f,
    FolderEmptyState: __vue_component__$G,
    SpringSpinner
  },
  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'select-folder', folder => this.chargeContent(folder.id));
    this.chargeContent(this.folder.id);
  },

  methods: {
    chargeContent(folderId) {
      this.isLoading = true;
      api.get(`/church-media/folders/${folderId}`).then(({
        data
      }) => {
        this.actualFolder = data;
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
      }).finally(() => {
        this.isLoading = false;
      });
    },

    goToPreviousFolder() {
      eventBus.emit(this.namespace, 'select-folder', this.actualFolder.parentFolder);
    },

    isSelected(item) {
      return this.$parent.selectedItems.find(existingItem => existingItem.id === item.id) != null;
    },

    showUploadView() {
      eventBus.emit(this.namespace, 'show-upload-view');
    }

  },
  watch: {// uploadingFiles(files) {
    //   // console.log("FILES", files)
    //   // this.chargeContent(this.folder.id)
    // }
  }
};

/* script */
const __vue_script__$H = script$H;
/* template */

var __vue_render__$H = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "tm-flex tm-items-start tm-justify-between tm-space-x-4"
  }, [_c('div', {
    staticClass: "tm-space-y-4"
  }, [_c('div', [_c('button', {
    staticClass: "tm-flex tm-items-center tm-text-sm tm-text-carolina sm:tm-text-yankFire focus:tm-outline-none focus:tm-ring focus:tm-ring-yankFire tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.goToPreviousFolder($event);
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-5 tm-h-5 tm--ml-2 tm-opacity-80"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-1"
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), !_vm.isLoading ? _c('h3', {
    staticClass: "tm-font-medium tm-text-yank tm-text-base"
  }, [_vm._v("\n        " + _vm._s(_vm.folder.name) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-items-center tm-space-x-4"
  }, [_vm.actualFolder && _vm.actualFolder.items && _vm.actualFolder.items.length ? _c('div', [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showUploadView($event);
      }
    }
  }, [_c('upload-icon', {
    staticClass: "tm-h-4 tm-w-4 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("Upload")])], 1)]) : _vm._e()])]), _vm._v(" "), !_vm.isLoading ? _c('div', {
    staticClass: "folder-items"
  }, [(!_vm.actualFolder || !_vm.actualFolder.items || !_vm.actualFolder.items.length) && (!_vm.actualFolder || !_vm.actualFolder.folders || !_vm.actualFolder.folders.length) ? _c('div', [_c('folder-empty-state')], 1) : _c('div', {
    staticClass: "tm-grid tm-gap-4 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'sm:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, [_vm._l(_vm.actualFolder.folders, function (folder) {
    return _c('item-component', {
      key: "folder-" + folder.id,
      attrs: {
        "item": folder,
        "selected": _vm.isSelected(folder)
      }
    });
  }), _vm._v(" "), _vm._l(_vm.actualFolder.items, function (item) {
    return _c('item-component', {
      key: "folder-" + item.id,
      attrs: {
        "item": item,
        "selected": _vm.isSelected(item)
      }
    });
  })], 2)]) : _c('div', {
    staticClass: "tm-pt-18 tm-flex tm-pb-18 tm-items-center tm-justify-center"
  }, [_c('SpringSpinner', {
    attrs: {
      "animation-duration": 2000,
      "size": 40,
      "color": '#6B7E99'
    }
  })], 1)]);
};

var __vue_staticRenderFns__$H = [];
/* style */

const __vue_inject_styles__$H = undefined;
/* scoped */

const __vue_scope_id__$H = undefined;
/* module identifier */

const __vue_module_identifier__$H = undefined;
/* functional template */

const __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$H = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);

//
var script$I = {
  name: 'UploadItemsView',
  components: {
    ArrowLeftIcon: __vue_component__$f,
    EmptyStateSvg: __vue_component__$h,
    ItemComponent: __vue_component__$D,
    vueDropzone: vue2Dropzone,
    ExclamationIcon: __vue_component__$j,
    XIcon: __vue_component__$a,
    CheckCircleIcon: __vue_component__$k
  },

  data() {
    return {
      files: [],
      url: null,
      accessToken: null,
      currentFile: null,
      progress: 0,
      filesRemaining: 0,
      filesUploaded: 0,
      uploadSuccess: [],
      uploadErrors: [],
      dropzoneOptions: {
        url: this.url,
        acceptedFiles: `image/jpeg,image/jpg,image/tif,image/tiff,image/png,image/gif,image/svg+xml,image/vnd.adobe.photoshop,
          video/*,
          application/*,text/*,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint,
          audio/*,
          video/avi`,
        previewTemplate: '<div class="tm-hidden"></div>',
        createImageThumbnails: true,
        parallelUploads: 1,
        params: (files, xhr, chunks) => {
          return {
            name: files[0].name,
            product_id: this.productId,
            location_id: this.locationId,
            folder_id: this.selectedFolder ? this.selectedFolder.id : ''
          };
        },
        headers: {
          "Authorization": `Bearer ${this.accessToken}`
        }
      }
    };
  },

  computed: {
    selectedFolder() {
      return this.$parent.selectedFolder;
    },

    productId() {
      return this.$parent.productId;
    },

    locationId() {
      return this.$parent.locationId;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },
  methods: {
    showUploadProgress(file, progress, bytesSent) {
      this.currentFile = file;
      this.progress = Math.round(progress);
      this.$emit('uploadProgress', file, this.progress);
    },

    successUpload(file, response) {
      let item = { ...response,
        selected: true
      };
      this.files.push(item);
      this.uploadSuccess.push(item);
      eventBus.emit(this.namespace, 'select-item', item);
      eventBus.emit(this.namespace, 'toggle-preview', item);
      this.$refs.dropzone.removeFile(file);
      eventBus.emit(this.namespace, 'successful-upload', item);
      this.$emit('uploadSuccess', file);
    },

    updateRemainingFiles() {
      this.$emit('uploadInProgress');
      this.filesRemaining = this.$refs.dropzone.getQueuedFiles().length;
      this.$emit('uploadFiles', this.$refs.dropzone.getQueuedFiles());

      if (this.filesRemaining == 0) {
        this.files = [];
        this.uploadErrors = [];
        this.clearUploadedFiles();
      }
    },

    addThumbnail(file, dataUrl) {
      this.$emit('addThumbnail', file, dataUrl);
    },

    errorUpload(file, message, xhr) {
      this.uploadErrors.push({
        name: file.name,
        message: message.message
      });
      this.$refs.dropzone.removeFile(file);
      this.$emit('uploadError', file);

      if (message && message.errors && message.errors.file && message.errors.file[0]) {
        eventBus.emit(this.namespace, 'toast-error', `${message.errors.file[0]}`);
      }
    },

    closeUploadView() {
      eventBus.emit(this.namespace, 'close-upload-view');
    },

    removeError(error) {
      let index = this.uploadErrors.findIndex(file => file.name == error.name);

      if (index === -1) {
        return;
      }

      this.uploadErrors.splice(index, 1);
    },

    clearUploadedFiles() {
      this.uploadSuccess = [];
    }

  },

  beforeCreate() {
    this.url = `${this.$parent.endpoint}/church-media/items`;
    this.accessToken = this.$parent.accessToken;
  } // beforeDestroy() {
  //   EventBus.off(this.namespace, 'close-upload-view')
  //   EventBus.off(this.namespace, 'successful-upload')
  // }


};

/* script */
const __vue_script__$I = script$I;
/* template */

var __vue_render__$I = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', {
    staticClass: "tm-relative tm-flex tm-flex-col tm-h-full"
  }, [_c('div', {
    staticClass: "tm-flex-shrink-0"
  }, [_c('button', {
    staticClass: "tm-flex tm-items-center tm-text-sm tm-text-yankFire focus:tm-outline-none focus:tm-ring focus:tm-ring-yankFire tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.closeUploadView($event);
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-6 tm-h-6 tm--ml-2"
  }), _vm._v(" "), _c('span', [_vm._v("Back")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex-1 tm-flex"
  }, [_c('vue-dropzone', {
    ref: "dropzone",
    staticClass: "tm-relative tm-z-0 tm-flex-1",
    attrs: {
      "id": "dropzone",
      "useCustomSlot": true,
      "options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-files-added": _vm.updateRemainingFiles,
      "vdropzone-thumbnail": _vm.addThumbnail,
      "vdropzone-upload-progress": _vm.showUploadProgress,
      "vdropzone-success": _vm.successUpload,
      "vdropzone-complete": _vm.updateRemainingFiles,
      "vdropzone-error": _vm.errorUpload
    }
  }, [_c('div', {
    staticClass: "tm-flex tm-flex-col"
  }, [_vm.files.length ? [_c('div', {
    staticClass: "tm-relative tm-z-10 tm-mt-6 tm-grid tm-gap-4 tm-grid-cols-3 sm:tm-grid-cols-6",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l(_vm.files, function (item) {
    return _c('item-component', {
      key: "folder-" + item.id,
      attrs: {
        "item": item,
        "selectable": false,
        "selected": false
      }
    });
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "tm-justify-center tm-flex tm-items-center tm-flex-col"
  }, [_c('div', {
    staticClass: "tm-mt-6 tm-text-center"
  }, [_c('h2', {
    staticClass: "tm-leading-tight tm-text-lg tm-font-semibold tm-text-yankFire"
  }, [_vm._v("\n                Drag files here\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "tm-text-payne tm-text-xs tm-mt-2"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-flex tm-justify-center"
  }, [_c('label', {
    staticClass: "tm-h-11 tm-border tm-rounded-xl tm-font-semibold tm-text-sm focus:tm-outline-none tm-px-6 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-aquamarine tm-border-aquamarine tm-text-white tm-cursor-pointer"
  }, [_vm._v("\n                  Select From Computer\n                ")])])])])] : _c('div', {
    staticClass: "tm-justify-center tm-flex tm-items-center tm-flex-col"
  }, [_c('empty-state-svg', {
    staticClass: "sm:tm-h-40 sm:tm-mt-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-text-center"
  }, [_c('h2', {
    staticClass: "tm-leading-tight tm-text-lg tm-font-semibold tm-text-yankFire"
  }, [_vm._v("\n              Drag files here\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "tm-text-payne tm-text-xs tm-mt-2"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6 tm-flex tm-justify-center"
  }, [_c('label', {
    staticClass: "tm-h-11 tm-border tm-rounded-xl tm-font-semibold tm-text-sm focus:tm-outline-none tm-px-6 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-aquamarine tm-border-aquamarine tm-text-white tm-cursor-pointer"
  }, [_vm._v("\n                Select From Computer\n              ")])])])], 1)], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-bottom-0 tm-inset-x-0  tm-z-20 tm-space-y-4"
  }, [_vm.filesRemaining == 0 && _vm.uploadSuccess.length ? _c('div', {
    staticClass: "tm-rounded-xl tm-bg-white tm-px-4 tm-py-4 tm-shadow-lg tm-border-2 tm-border-aquamarine tm-relative"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-center"
  }, [_c('span', [_c('check-circle-icon', {
    staticClass: "tm-h-6 tm-text-aquamarine"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-6"
  }, [_c('p', {
    staticClass: "tm-font-semibold tm-text-sm tm-text-yank"
  }, [_vm._v("\n            Uploaded " + _vm._s(_vm.uploadSuccess.length) + " " + _vm._s(_vm.uploadSuccess.length == 1 ? 'file' : 'files') + " successfully\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-top-2 tm-right-2"
  }, [_c('button', {
    staticClass: "tm-rounded tm-p-1 focus:tm-outline-none focus-visible:tm-ring",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clearUploadedFiles($event);
      }
    }
  }, [_c('x-icon', {
    staticClass: "tm-h-3"
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm._l(_vm.uploadErrors, function (file) {
    return _vm.uploadErrors.length ? _c('div', {
      staticClass: "tm-rounded-xl tm-bg-white tm-px-4 tm-py-4 tm-shadow-lg tm-border-2 tm-border-red-700 tm-relative"
    }, [_c('div', {
      staticClass: "tm-flex tm-items-center"
    }, [_c('span', [_c('exclamation-icon', {
      staticClass: "tm-h-6 tm-text-red-700"
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "tm-ml-6"
    }, [_c('p', {
      staticClass: "tm-font-semibold tm-text-sm tm-text-red-700"
    }, [_vm._v("Couldn't upload "), _c('span', {
      staticClass: "tm-"
    }, [_vm._v(_vm._s(file.name))])]), _vm._v(" "), _c('p', {
      staticClass: "tm-text-xs tm-text-red-800 tm-mt-2"
    }, [_vm._v(_vm._s(file.message))])])]), _vm._v(" "), _c('div', {
      staticClass: "tm-absolute tm-top-2 tm-right-2"
    }, [_c('button', {
      staticClass: "tm-rounded tm-p-1 focus:tm-outline-none focus-visible:tm-ring",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.removeError(file);
        }
      }
    }, [_c('x-icon', {
      staticClass: "tm-h-3"
    })], 1)])]) : _vm._e();
  }), _vm._v(" "), _vm.filesRemaining > 0 ? _c('div', {
    staticClass: "tm-rounded-xl tm-bg-white tm-px-4 tm-py-4 tm-shadow-lg"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-between"
  }, [_c('span', {
    staticClass: "tm-text-sm tm-font-semibold"
  }, [_vm._v("\n          Uploading " + _vm._s(_vm.currentFile ? _vm.currentFile.name : '') + "\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "tm-text-sm tm-text-yankFire"
  }, [_vm._v("\n          " + _vm._s(_vm.filesRemaining) + " " + _vm._s(_vm.filesRemaining != 1 ? 'files' : 'file') + " left\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3"
  }, [_c('div', {
    staticClass: "tm-h-1.5 tm-bg-platinum tm-rounded-full tm-relative tm-overflow-hidden"
  }, [_c('div', {
    staticClass: "tm-transition-all tm-absolute tm-rounded-full tm-bg-yankMiddle tm-inset-y-0",
    style: {
      width: _vm.progress + "%"
    }
  })])])]) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__$I = [];
/* style */

const __vue_inject_styles__$I = undefined;
/* scoped */

const __vue_scope_id__$I = undefined;
/* module identifier */

const __vue_module_identifier__$I = undefined;
/* functional template */

const __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$I = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);

//
var script$J = {
  name: 'MoveModal',
  props: {
    folders: Array
  },
  components: {
    FileTypePreview: __vue_component__$A
  },

  data() {
    return {
      working: false,
      show: false,
      item: null,
      newFolder: null
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.item = null;
        this.working = false;
        this.newFolder = null;
        document.removeEventListener('keydown', this.handleEscapeKey);
      } else {
        document.addEventListener('keydown', this.handleEscapeKey);
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    moveItem() {
      this.working = true;
      api.put(`/church-media/items/${this.item.id}`, {
        name: this.item.name,
        product_id: this.item.product_id,
        location_id: this.item.location_id,
        folder_id: this.newFolder
      }).then(({
        data
      }) => {
        if (this.item.folder_id) {
          // splice item from folder
          eventBus.emit(this.namespace, 'remove-item-from-folder', {
            item: this.item,
            folder_id: this.item.folder_id
          });
        } else {
          // splice item from root
          eventBus.emit(this.namespace, 'remove-item-from-root', this.item);
        }

        if (data.folder_id) {
          // unshift item into the new folder folder
          eventBus.emit(this.namespace, 'add-item-to-folder', {
            item: data,
            folder_id: data.folder_id
          });
        } else {
          // unshift item into root
          eventBus.emit(this.namespace, 'add-item-to-root', data);
        }

        this.show = false;
      }).finally(() => this.working = false);
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-move-modal', item => {
      this.item = item;
      this.newFolder = item.folder_id;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-move-modal');
  }

};

/* script */
const __vue_script__$J = script$J;
/* template */

var __vue_render__$J = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-px-4 tm-pt-5 tm-pb-4 tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all tm-w-full sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-sm sm:tm-p-6",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "tm-h-24 tm-w-24 tm-relative tm-mx-auto"
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2"
  }, [_vm._v("\n                " + _vm._s(_vm.item.name) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-4"
  }, [_c('label', {
    staticClass: "tm-block tm-text-sm tm-font-medium tm-text-gray-700",
    attrs: {
      "for": "folder"
    }
  }, [_vm._v("Move to folder")]), _vm._v(" "), _c('div', {
    staticClass: "tm-relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newFolder,
      expression: "newFolder"
    }],
    staticClass: "tm-mt-1 tm-border tm-block tm-w-full tm-pl-3 tm-pr-10 tm-py-2 tm-text-base tm-border-gray-300 focus:tm-outline-none focus:tm-ring-aquamarine sm:tm-text-sm tm-rounded-md tm-appearance-none",
    attrs: {
      "id": "folder",
      "name": "folder"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.newFolder = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(":: Root")]), _vm._v(" "), _vm._l(_vm.folders, function (folder) {
    return _c('option', {
      domProps: {
        "value": folder.id
      }
    }, [_vm._v("\n                      " + _vm._s(folder.name) + "\n                    ")]);
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "tm-absolute tm-inset-y-0 tm-right-0 tm-flex tm-items-center tm-pr-2 tm-pointer-events-none"
  }, [_c('svg', {
    staticClass: "tm-h-5 tm-w-5 tm-text-gray-400",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20",
      "fill": "currentColor",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-5 sm:tm-mt-6 sm:tm-grid sm:tm-grid-cols-2 sm:tm-gap-3 sm:tm-grid-flow-row-dense"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-aquamarine tm-text-base tm-font-medium tm-text-white hover:tm-opacity-90 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-col-start-2 sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "button",
      "disabled": _vm.item.folder_id == _vm.newFolder || _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.moveItem($event);
      }
    }
  }, [_vm.working ? _c('span', [_vm._v("Moving...")]) : _c('span', [_vm._v("Move")])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 hover:tm-bg-gray-50 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-mt-0 sm:tm-col-start-1 sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("\n                Cancel\n              ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$J = [];
/* style */

const __vue_inject_styles__$J = undefined;
/* scoped */

const __vue_scope_id__$J = undefined;
/* module identifier */

const __vue_module_identifier__$J = undefined;
/* functional template */

const __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$J = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);

//
var script$K = {
  name: 'EditItemModal',
  components: {
    FileTypePreview: __vue_component__$A
  },

  data() {
    return {
      show: false,
      working: false,
      item: null,
      form: {
        name: null,
        description: null
      },
      errors: []
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.item = null;
        this.form.name = null;
        this.form.description = null;
        this.working = false;
        document.removeEventListener('keydown', this.handleEscapeKey);
      } else {
        document.addEventListener('keydown', this.handleEscapeKey);
      }
    }

  },
  methods: {
    updateItem() {
      this.working = true;
      api.put(`/church-media/items/${this.item.uuid}`, {
        product_id: this.item.product_id,
        location_id: this.item.location_id,
        ...this.form
      }).then(({
        data
      }) => {
        eventBus.emit(this.namespace, 'updated-church-item', data);
        this.show = false;
      }).finally(() => this.working = false);
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-edit-item-modal', item => {
      this.item = item;
      this.form.name = item.name, this.form.description = item.description;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-edit-item-modal');
  }

};

/* script */
const __vue_script__$K = script$K;
/* template */

var __vue_render__$K = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all tm-w-full tm-px-4 tm-pt-5 tm-pb-4 sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-sm sm:tm-w-full sm:tm-p-6",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "tm-h-24 tm-w-24 tm-relative tm-mx-auto"
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-4"
  }, [_c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.updateItem($event);
      }
    }
  }, [_c('div', [_c('label', {
    staticClass: "tm-block tm-text-sm tm-font-medium tm-text-gray-700",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("\n                  Title\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.name,
      expression: "form.name"
    }],
    staticClass: "tm-text-xs tm-rounded-lg tm-border tm-border-payne tm-h-9 tm-px-3 tm-placeholder-cosmosHot focus:tm-outline-none focus:tm-border-payneFire tm-w-full tm-appearance-none",
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": _vm.form.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.$set(_vm.form, "name", $event.target.value);
      }
    }
  })]), _vm._v(" "), _vm.errors.name ? _c('p', {
    staticClass: "tm-mt-1 tm-text-xs tm-red-600"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.name[0]) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-6"
  }, [_c('label', {
    staticClass: "tm-block tm-text-sm tm-font-medium tm-text-gray-700",
    attrs: {
      "for": "description"
    }
  }, [_vm._v("\n                  Description\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-1"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.description,
      expression: "form.description"
    }],
    staticClass: "tm-text-xs tm-rounded-lg tm-border tm-border-payne tm-px-3 tm-py-2 tm-placeholder-cosmosHot focus:tm-outline-none focus:tm-border-payneFire tm-w-full tm-appearance-none",
    attrs: {
      "name": "description",
      "rows": "5"
    },
    domProps: {
      "value": _vm.form.description
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.$set(_vm.form, "description", $event.target.value);
      }
    }
  })]), _vm._v(" "), _vm.errors.name ? _c('p', {
    staticClass: "tm-mt-1 tm-text-xs tm-red-600"
  }, [_vm._v("\n                  " + _vm._s(_vm.errors.name[0]) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-5 sm:tm-mt-6 sm:tm-grid sm:tm-grid-cols-2 sm:tm-gap-3 sm:tm-grid-flow-row-dense"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-aquamarine tm-text-base tm-font-medium tm-text-white hover:tm-opacity-90 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-col-start-2 sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "submit",
      "disabled": _vm.working
    }
  }, [_vm.working ? _c('span', [_vm._v("Saving...")]) : _c('span', [_vm._v("Save")])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 hover:tm-bg-gray-50 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-mt-0 sm:tm-col-start-1 sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n                  Cancel\n                ")])])])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$K = [];
/* style */

const __vue_inject_styles__$K = undefined;
/* scoped */

const __vue_scope_id__$K = undefined;
/* module identifier */

const __vue_module_identifier__$K = undefined;
/* functional template */

const __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$K = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);

//
var script$L = {
  name: 'RemoveItemModal',
  components: {
    FileTypePreview: __vue_component__$A
  },

  data() {
    return {
      show: false,
      working: false,
      item: null,
      force: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.item = null;
        this.working = false;
        this.force = false;
        document.removeEventListener('keydown', this.handleEscapeKey);
      } else {
        document.addEventListener('keydown', this.handleEscapeKey);
      }
    }

  },
  methods: {
    removeItem() {
      this.working = true;

      if (this.item.type == 'folder') {
        return this.removeFolder();
      }

      if (this.force) {
        return this.forceDeleteItem();
      }

      api.delete(`/church-media/items/${this.item.uuid}`).then(() => {
        if (this.item.folder_id) {
          // splice item from folder
          eventBus.emit(this.namespace, 'remove-item-from-folder', {
            item: this.item,
            folder_id: this.item.folder_id
          });
        } else {
          // splice item from root
          eventBus.emit(this.namespace, 'remove-item-from-root', this.item);
        }

        eventBus.emit(this.namespace, 'remove-item-from-selected', this.item);
        eventBus.emit(this.namespace, 'remove-item-from-preview', this.item);
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', error.response.data.message);
      }).finally(() => this.show = false);
    },

    forceDeleteItem() {
      api.delete(`/church-media/items/${this.item.uuid}/force-delete`).then(() => {
        eventBus.emit(this.namespace, 'remove-item-from-deleted', this.item);
        eventBus.emit(this.namespace, 'remove-item-from-preview', this.item);
        eventBus.emit(this.namespace, 'toast-success', 'Media item deleted');
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', error.response.data.message);
      }).finally(() => this.show = false);
    },

    removeFolder() {
      api.delete(`/church-media/folders/${this.item.id}`).then(() => {
        eventBus.emit(this.namespace, 'folder-deleted', this.item);
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', error.response.data.message);
      }).finally(() => this.show = false);
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-remove-item-modal', payload => {
      this.item = payload.item;
      this.force = payload.force || false;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-remove-item-modal');
  }

};

/* script */
const __vue_script__$L = script$L;
/* template */

var __vue_render__$L = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-lg sm:tm-w-full",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-px-4 tm-pt-5 tm-pb-4 sm:tm-p-6 sm:tm-pb-4"
  }, [_c('div', {
    staticClass: "sm:tm-flex sm:tm-items-start tm-relative"
  }, [_c('div', {
    staticClass: "sm:tm-w-14 tm-w-full tm-flex tm-justify-center"
  }, [_c('div', {
    staticClass: "tm-h-12 tm-w-12 sm:tm-w-14 sm:tm-h-14 tm-relative"
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item,
      "with-border": false
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3 tm-text-center sm:tm-mt-0 sm:tm-ml-4 sm:tm-text-left"
  }, [_c('h3', {
    staticClass: "tm-text-lg tm-leading-6 tm-font-medium tm-text-gray-900",
    attrs: {
      "id": "modal-headline"
    }
  }, [_vm._v("\n                  Remove Item\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2"
  }, [_c('p', {
    staticClass: "tm-text-sm tm-text-gray-500"
  }, [_vm.item.type == 'folder' ? [_vm._v("\n                      Are you sure you want to remove this folder? All the folder content will be deleted.\n                    ")] : [_vm.force ? _c('span', [_vm._v("\n                        Are you sure you want to permanently delete this item?\n                      ")]) : _c('span', [_vm._v("\n                        Are you sure you want to remove this item? Any removed media items will still be available in the "), _c('em', [_vm._v("Deleted Items")]), _vm._v(" section.\n                      ")])]], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-bg-gray-50 tm-px-4 tm-py-3 sm:tm-px-6 sm:tm-flex sm:tm-flex-row-reverse"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-red-600 tm-text-base tm-font-medium tm-text-white hover:tm-bg-red-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-red-500 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "button",
      "disabled": _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.removeItem($event);
      }
    }
  }, [_vm.working ? _c('span', [_vm._v("Deleting...")]) : _c('span', [_vm._v("Delete"), _vm.force ? _c('span', [_vm._v(" forever")]) : _vm._e()])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-mt-0 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$L = [];
/* style */

const __vue_inject_styles__$L = undefined;
/* scoped */

const __vue_scope_id__$L = undefined;
/* module identifier */

const __vue_module_identifier__$L = undefined;
/* functional template */

const __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$L = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);

//
var script$M = {
  name: "RemoveItemsModal",

  data() {
    return {
      show: false,
      working: false,
      items: []
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    },

    selectedItems() {
      return this.$parent.$parent.selectedItems;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.working = false;
        document.removeEventListener("keydown", this.handleEscapeKey);
      } else {
        document.addEventListener("keydown", this.handleEscapeKey);
      }
    }

  },
  methods: {
    removeItem() {
      this.working = true;
      api.delete(`/church-media/items`, {
        data: {
          ids: this.selectedItems.map(item => item.id)
        }
      }).then(() => {
        eventBus.emit(this.namespace, "toast-success", "Items removed successfully");
        eventBus.emit(this.namespace, "remove-items-from-selected");
      }).catch(error => {
        eventBus.emit(this.namespace, "toast-error", error.response.data.message);
      }).finally(() => {
        this.show = false;
      });
    }

  },

  mounted() {
    eventBus.on(this.namespace, "show-remove-items-modal", items => {
      this.items = items;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, "show-removes-item-modal");
  }

};

/* script */
const __vue_script__$M = script$M;
/* template */

var __vue_render__$M = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-lg sm:tm-w-full",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-px-4 tm-pt-5 tm-pb-4 sm:tm-p-6 sm:tm-pb-4"
  }, [_c('div', {
    staticClass: "sm:tm-flex sm:tm-items-start tm-relative"
  }, [_c('div', {
    staticClass: "tm-mt-3 tm-text-center sm:tm-mt-0 sm:tm-ml-4 sm:tm-text-left"
  }, [_c('h3', {
    staticClass: "tm-text-lg tm-leading-6 tm-font-medium tm-text-gray-900",
    attrs: {
      "id": "modal-headline"
    }
  }, [_vm._v("\n                    Remove Items\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2"
  }, [_c('p', {
    staticClass: "tm-text-sm tm-text-gray-500"
  }, [_c('span', [_vm._v("\n                        Are you sure you want to remove these items? Any\n                        removed media items will still be available in the\n                        "), _c('em', [_vm._v("Deleted Items")]), _vm._v(" section.\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-bg-gray-50 tm-px-4 tm-py-3 sm:tm-px-6 sm:tm-flex sm:tm-flex-row-reverse"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-red-600 tm-text-base tm-font-medium tm-text-white hover:tm-bg-red-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-red-500 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "button",
      "disabled": _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.removeItem($event);
      }
    }
  }, [_vm.working ? _c('span', [_vm._v("Deleting...")]) : _c('span', [_vm._v("Delete")])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-mt-0 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n                Cancel\n              ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$M = [];
/* style */

const __vue_inject_styles__$M = undefined;
/* scoped */

const __vue_scope_id__$M = undefined;
/* module identifier */

const __vue_module_identifier__$M = undefined;
/* functional template */

const __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$M = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);

//
var script$N = {
  name: "SearchInput",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    query: String
  },
  components: {
    SearchIcon: __vue_component__$1
  },
  methods: {
    runSearch(event) {
      this.$emit("search", event.target.value);
    },

    runSearchEnter(event) {
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        this.$emit("search", event.target.value);
      }
    }

  }
};

/* script */
const __vue_script__$N = script$N;
/* template */

var __vue_render__$N = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "search-field tm-relative"
  }, [_c('input', {
    staticClass: "tm-text-xs tm-rounded-lg tm-border tm-border-payne tm-h-9 tm-pl-4 tm-pr-8 tm-placeholder-cosmosHot focus:tm-outline-none focus:tm-border-payneFire tm-w-full tm-appearance-none",
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.query
    },
    on: {
      "search": _vm.runSearch,
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.runSearchEnter($event);
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-absolute tm-right-0 tm-inset-y-0 tm-flex tm-items-center tm-justify-center tm-mr-4"
  }, [_c('search-icon', {
    staticClass: "tm-h-3 tm-w-3 tm-text-payneFire"
  })], 1)]);
};

var __vue_staticRenderFns__$N = [];
/* style */

const __vue_inject_styles__$N = undefined;
/* scoped */

const __vue_scope_id__$N = undefined;
/* module identifier */

const __vue_module_identifier__$N = undefined;
/* functional template */

const __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$N = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);

//
var script$O = {
  name: 'SearchYourMedia',
  props: {
    query: String
  },
  components: {
    InfiniteLoading,
    SearchInput: __vue_component__$N,
    ItemComponent: __vue_component__$D,
    ArrowLeftIcon: __vue_component__$f
  },

  data() {
    return {
      page: 1,
      searchItems: []
    };
  },

  computed: {
    hasPreview() {
      return this.$parent.hasPreview;
    },

    selectingItems() {
      return this.$parent.selectingItems;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    query(query) {
      if (!query.length) {
        return;
      }

      this.searchItems = [];
      this.page = 1;
      this.$refs.infiniteLoader.stateChanger.reset();
    }

  },
  methods: {
    isSelected(item) {
      let findItem = this.$parent.selectedItems.find(i => i.type == item.type && i.uuid == item.uuid);
      return typeof findItem != 'undefined';
    },

    updateSearch(query) {
      this.$emit('search', query);
    },

    fetchSearchResults() {
      return api.get('/church-media/search', {
        params: {
          per_page: 24,
          page: this.page,
          'filter[search]': this.query
        }
      });
    },

    fetchFirstResults($state) {
      this.page = 1;
      this.searchItems = [];
      this.fetchSearchResults().then(({
        data
      }) => {
        this.searchItems.push(...data.data);

        if (data.meta.current_page < data.meta.last_page) {
          $state.loaded();
          this.page++;
          return;
        }

        $state.complete();
      });
    },

    loadMore($state) {
      if (!this.searchItems.length) {
        this.fetchFirstResults($state);
        return;
      }

      this.fetchSearchResults().then(({
        data
      }) => {
        this.searchItems.push(...data.data);

        if (data.meta.current_page < data.meta.last_page) {
          this.page++;
          $state.loaded();
          return;
        }

        $state.complete();
      });
    },

    toggleSelect() {
      eventBus.emit(this.namespace, 'toggle-selecting-items');
    }

  }
};

/* script */
const __vue_script__$O = script$O;
/* template */

var __vue_render__$O = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "tm-space-y-4"
  }, [_c('div', [_c('button', {
    staticClass: "tm-flex tm-items-center tm-text-sm tm-text-carolina sm:tm-text-yankFire focus:tm-outline-none focus:tm-ring focus:tm-ring-yankFire tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.updateSearch('');
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-5 tm-h-5 tm--ml-2 tm-opacity-80"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-1"
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), _c('search-input', {
    staticClass: "sm:tm-max-w-2xs tm-w-full",
    attrs: {
      "placeholder": "Search My Media",
      "query": _vm.query
    },
    on: {
      "search": _vm.updateSearch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-results-items tm-mt-6"
  }, [_c('div', {
    staticClass: "tm-flex tm-justify-between tm-items-center"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base"
  }, [_vm._v("Search results for "), _c('em', [_vm._v("\"" + _vm._s(_vm.query) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "sm:tm-hidden"
  }, [!_vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Select\n        ")]) : _vm._e(), _vm._v(" "), _vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'lg:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, _vm._l(_vm.searchItems, function (item) {
    return _c('item-component', {
      key: "all-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      }
    });
  }), 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    staticClass: "tm-mt-4",
    attrs: {
      "spinner": "spiral"
    },
    on: {
      "infinite": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("No more media to load")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("No more media to load")])])], 1)]);
};

var __vue_staticRenderFns__$O = [];
/* style */

const __vue_inject_styles__$O = undefined;
/* scoped */

const __vue_scope_id__$O = undefined;
/* module identifier */

const __vue_module_identifier__$O = undefined;
/* functional template */

const __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$O = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$P = {
  name: 'UploadingFile',
  props: {
    name: {
      type: String,
      required: true
    },
    progress: {
      type: Number,
      required: true
    },
    thumbnail: {
      type: String,
      required: true
    }
  },
  methods: {
    getCutName() {
      const parts = this.name.split('.');
      const extension = parts[parts.length - 1];
      return parts[0].slice(0, 5) + '...' + extension;
    }

  }
};

/* script */
const __vue_script__$P = script$P;
/* template */

var __vue_render__$P = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-rounded-lg tm-overflow-hidden tm-cursor-pointer tm-relative tm-flex tm-items-center tm-justify-center"
  }, [_c('div', [_c('div', {
    staticClass: "tm-rounded-lg tm-h-28 tm-w-28"
  }, [_vm.thumbnail ? _c('img', {
    staticClass: "tm-h-28 tm-w-28 tm-rounded-lg",
    attrs: {
      "src": _vm.thumbnail
    }
  }) : _c('img', {
    staticClass: "tm-h-28 tm-w-28 tm-rounded-lg",
    attrs: {
      "src": "//pic.onlinewebfonts.com/svg/img_148071.png",
      "alt": "Image Placeholder"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.getCutName()) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "tm-bottom-9 tm-left-0 tm-right-0 tm-mx-2 tm-absolute tm-z-40"
  }, [_c('div', {
    staticClass: "tm-h-2 tm-bg-platinum tm-rounded-full tm-relative tm-overflow-hidden"
  }, [_c('div', {
    staticClass: "tm-transition-all tm-absolute tm-rounded-full tm-bg-green-500 tm-inset-y-0",
    style: {
      width: _vm.progress + '' + "%"
    }
  })])])]);
};

var __vue_staticRenderFns__$P = [];
/* style */

const __vue_inject_styles__$P = undefined;
/* scoped */

const __vue_scope_id__$P = undefined;
/* module identifier */

const __vue_module_identifier__$P = undefined;
/* functional template */

const __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$P = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);

//
var script$Q = {
  name: 'UploadingError',
  components: {
    UploadFailedIcon: __vue_component__$s,
    XUploadIcon: __vue_component__$t
  },
  props: {
    name: {
      type: String,
      required: true
    },
    thumbnail: {
      type: String,
      required: true
    }
  },
  methods: {
    getCutName() {
      const parts = this.name.split('.');
      const extension = parts[parts.length - 1];
      return parts[0].slice(0, 5) + '...' + extension;
    }

  }
};

/* script */
const __vue_script__$Q = script$Q;
/* template */

var __vue_render__$Q = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-rounded-lg tm-overflow-hidden tm-cursor-pointer tm-relative tm-flex tm-items-center tm-justify-center"
  }, [_c('div', [_c('div', {
    staticClass: "tm-rounded-lg tm-h-28 tm-w-28 tm-relative"
  }, [_vm.thumbnail ? _c('img', {
    staticClass: "tm-h-28 tm-w-28 tm-rounded-lg",
    attrs: {
      "src": _vm.thumbnail
    }
  }) : _c('img', {
    staticClass: "tm-h-28 tm-w-28 tm-rounded-lg",
    attrs: {
      "src": "//pic.onlinewebfonts.com/svg/img_148071.png",
      "alt": "Image Placeholder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-h-full tm-w-full tm-rounded-xl tm-absolute tm-top-0 tm-bg-gradient-to-t tm-from-gray-900 tm-z-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-bottom-1.5 tm-right-1 tm-absolute tm-z-40"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-end"
  }, [_c('span', {
    staticClass: "tm-font-semibold tm-text-xs tm-text-red-600"
  }, [_vm._v("Failed upload")]), _vm._v(" "), _c('upload-failed-icon', {
    staticClass: "tm-ml-1 tm-h-4 tm-w-4 tm-text-red-600"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-text-white tm-top-2 tm-right-2 tm-z-20",
    on: {
      "click": function ($event) {
        return _vm.$emit('remove');
      }
    }
  }, [_c('x-upload-icon', {
    staticClass: "tm-w-6 tm-h-6"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2"
  }, [_vm._v("\n            " + _vm._s(_vm.getCutName()) + "\n        ")])])]);
};

var __vue_staticRenderFns__$Q = [];
/* style */

const __vue_inject_styles__$Q = undefined;
/* scoped */

const __vue_scope_id__$Q = undefined;
/* module identifier */

const __vue_module_identifier__$Q = undefined;
/* functional template */

const __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);

//
var script$R = {
  name: 'YourMediaSection',
  components: {
    AllItemsView: __vue_component__$F,
    FolderItemsView: __vue_component__$H,
    UploadItemsView: __vue_component__$I,
    MoveModal: __vue_component__$J,
    EditItemModal: __vue_component__$K,
    RemoveItemModal: __vue_component__$L,
    SearchYourMedia: __vue_component__$O,
    UploadingFile: __vue_component__$P,
    UploadingError: __vue_component__$Q,
    RemoveItemsModal: __vue_component__$M
  },

  data() {
    return {
      showRecentMedia: true,
      showUploadView: false,
      selectedFolder: null,
      folders: [],
      churchMedia: [],
      page: 1,
      searchQuery: '',
      uploadingFiles: [],
      uploadingErrors: [],
      fileProgress: {
        file: null,
        progress: 0
      },
      fileThumbnails: []
    };
  },

  computed: {
    namespace() {
      return this.$parent.$parent.namespace;
    },

    selectLimit() {
      return this.$parent.$parent.selectLimit;
    },

    selectingItems() {
      return this.$parent.$parent.selectingItems;
    },

    selectedItems() {
      return this.$parent.$parent.selectedItems;
    },

    itemPreview() {
      return this.$parent.$parent.itemPreview;
    },

    locationId() {
      return this.$parent.$parent.locationId;
    },

    productId() {
      return this.$parent.$parent.productId;
    },

    mediaTypes() {
      return this.$parent.$parent.computedTypes;
    },

    accessToken() {
      return this.$parent.$parent.persistedAccessToken;
    },

    endpoint() {
      return this.$parent.$parent.safeEndpoint;
    },

    hasPreview() {
      return this.selectedItems.length > 1 || !!this.itemPreview;
    }

  },
  methods: {
    handleInfiniteLoading($state) {
      if (this.page == 1) {
        this.fetchFolders();
      }

      this.fetchChurchMedia().then(hasMore => {
        if (this.churchMedia.length) {
          $state.loaded();
        }

        if (hasMore) {
          this.page++;
          return;
        }

        $state.complete();
      });
    },

    getThumbnail(file) {
      const thumbnailFile = this.fileThumbnails.find(existingFile => existingFile.file === file);

      if (!thumbnailFile) {
        return '';
      }

      return thumbnailFile.thumbnail;
    },

    removeError(file) {
      this.uploadingErrors = this.uploadingErrors.filter(existingFile => existingFile !== file);
    },

    addUploadError(file) {
      this.uploadingErrors.push(file);
    },

    updateUploadedFiles(files) {
      if (files.length == 0) {
        this.fileProgress = {
          file: null,
          progress: 0
        };
        this.fileThumbnails = [];
      }

      this.uploadingFiles = files;
    },

    removeFromUpload(file) {
      eventBus.emit(this.namespace, 'add-item-to-folder', file);
      this.uploadingFiles = this.uploadingFiles.filter(existingFile => existingFile !== file);
    },

    updateProgress(file, progress) {
      this.fileProgress = {
        file: file,
        progress: progress
      };
    },

    addThumbnail(file, thumbnail) {
      this.fileThumbnails.push({
        file: file,
        thumbnail: thumbnail
      });
    },

    fetchChurchMedia() {
      return api.get('/church-media/items', {
        params: {
          per_page: 24,
          page: this.page,
          'filter[folder]': 'root',
          'filter[type]': this.mediaTypes.join(',')
        }
      }).then(({
        data
      }) => {
        if (this.page == 1) {
          this.churchMedia = data.data;
        } else {
          this.churchMedia.push(...data.data);
        }

        return Promise.resolve(data.meta.current_page < data.meta.last_page);
      });
    },

    fetchFolders() {
      api.get('/church-media/folders', {
        params: {
          'filter[mediaType]': this.mediaTypes.join(',')
        }
      }).then(({
        data
      }) => {
        this.folders = data;
      }).catch(error => console.error('Folder fetching error', error));
    },

    runSearch(query) {
      this.searchQuery = query;
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'select-folder', folder => this.selectedFolder = folder);
    eventBus.on(this.namespace, 'clear-selected-folder', () => this.selectedFolder = null);
    eventBus.on(this.namespace, 'show-upload-view', () => this.showUploadView = true);
    eventBus.on(this.namespace, 'close-upload-view', () => this.showUploadView = false);
    eventBus.on(this.namespace, 'successful-upload', item => {
      if (this.selectedFolder && this.selectedFolder.id == item.folder_id) {
        this.selectedFolder.items.unshift(item);
        return;
      }

      this.churchMedia.unshift(item);
    });
    eventBus.on(this.namespace, 'new-folder-created', folder => this.folders.unshift(folder));
    eventBus.on(this.namespace, 'folder-deleted', folder => {
      if (this.selectedFolder) {
        eventBus.emit(this.namespace, 'select-folder', this.selectedFolder);
      } else {
        let index = this.folders.indexOf(folder);

        if (index === -1) {
          return;
        }

        this.folders.splice(index, 1);
      }
    });
    eventBus.on(this.namespace, 'updated-folder', folder => {
      let index = this.folders.findIndex(f => f.id == folder.id);

      if (index === -1) {
        return;
      }

      this.folders.splice(index, 1, folder);
    });
    eventBus.on(this.namespace, 'updated-church-item', item => {
      let index = this.churchMedia.findIndex(i => i.id == item.id);

      if (index === -1) {
        return;
      }

      this.churchMedia.splice(index, 1, item);

      if (this.itemPreview && this.itemPreview.uuid == item.uuid) {
        eventBus.emit(this.namespace, 'toggle-preview', null);
        eventBus.emit(this.namespace, 'toggle-preview', item);
      }
    });
    eventBus.on(this.namespace, 'add-item-to-folder', payload => {
      eventBus.emit(this.namespace, 'select-folder', this.selectedFolder);
    });
    eventBus.on(this.namespace, 'remove-item-from-folder', payload => {
      let folder = this.folders.find(folder => folder.id == payload.folder_id);

      if (!folder) {
        return;
      }

      let index = folder.items.indexOf(payload.item);

      if (index === -1) {
        return;
      }

      folder.items.splice(index, 1);
    });
    eventBus.on(this.namespace, 'add-item-to-root', item => {
      this.churchMedia.unshift(item);
    });
    eventBus.on(this.namespace, 'remove-item-from-root', item => {
      let index = this.churchMedia.indexOf(item);

      if (index === -1) {
        return;
      }

      this.churchMedia.splice(index, 1);
    });
    eventBus.on(this.namespace, 'remove-item-from-selected', item => {
      let index = this.selectedItems.indexOf(item);

      if (index === -1) {
        return;
      }

      this.selectedItems.splice(index, 1);
    });
    eventBus.on(this.namespace, 'remove-items-from-selected', () => {
      eventBus.emit(this.namespace, 'select-folder', this.selectedFolder);
      this.selectedItems.forEach(item => {
        let index = this.churchMedia.findIndex(i => i.id == item.id);

        if (index === -1) {
          return;
        }

        this.churchMedia.splice(index, 1);
      });
      Vue.set(this.$parent.$parent, 'selectedItems', []);
    });
    eventBus.on(this.namespace, 'remove-item-from-preview', item => {
      if (this.itemPreview && this.itemPreview.uuid == item.uuid) {
        eventBus.emit(this.namespace, 'toggle-preview', null);
      }
    });
  },

  beforeDestroy() {
    this.selectedFolder = null;
    eventBus.off(this.namespace, 'select-folder');
    eventBus.off(this.namespace, 'clear-selected-folder');
    eventBus.off(this.namespace, 'show-upload-view');
    eventBus.off(this.namespace, 'close-upload-view');
    eventBus.off(this.namespace, 'successful-upload');
    eventBus.off(this.namespace, 'new-folder-created');
    eventBus.off(this.namespace, 'folder-deleted');
    eventBus.off(this.namespace, 'updated-folder');
    eventBus.off(this.namespace, 'add-item-to-root');
    eventBus.off(this.namespace, 'remove-item-from-root');
    eventBus.off(this.namespace, 'add-item-to-folder');
    eventBus.off(this.namespace, 'remove-item-from-folder');
    eventBus.off(this.namespace, 'remove-item-from-selected');
    eventBus.off(this.namespace, 'remove-item-from-preview');
    eventBus.off(this.namespace, 'remove-items-from-selected');
  }

};

/* script */
const __vue_script__$R = script$R;
/* template */

var __vue_render__$R = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-flex-1 tm-overflow-y-scroll tm-px-4 tm-py-2 sm:tm-p-6 tm-space-y-6"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showUploadView,
      expression: "showUploadView"
    }]
  }, [_c('upload-items-view', {
    on: {
      "uploadInProgress": function ($event) {
        _vm.showUploadView = false;
      },
      "uploadFiles": _vm.updateUploadedFiles,
      "uploadSuccess": _vm.removeFromUpload,
      "uploadProgress": _vm.updateProgress,
      "addThumbnail": _vm.addThumbnail,
      "uploadError": _vm.addUploadError
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "mode": "out-in"
    }
  }, [!_vm.showUploadView && _vm.searchQuery != '' ? [_c('search-your-media', {
    attrs: {
      "query": _vm.searchQuery
    },
    on: {
      "search": _vm.runSearch
    }
  })] : !_vm.showUploadView && _vm.selectedFolder ? [_c('div', [_c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3 sm:tm-grid-cols-6"
  }, [_vm._l(_vm.uploadingErrors, function (file, index) {
    return _c('uploading-error', {
      key: 'error' + index + file.name,
      attrs: {
        "name": file.name,
        "thumbnail": _vm.getThumbnail(file)
      },
      on: {
        "remove": function ($event) {
          return _vm.removeError(file);
        }
      }
    });
  }), _vm._v(" "), _vm._l(_vm.uploadingFiles, function (file, index) {
    return _c('uploading-file', {
      key: index + file.name,
      attrs: {
        "name": file.name,
        "progress": file === _vm.fileProgress.file ? _vm.fileProgress.progress : 0,
        "thumbnail": _vm.getThumbnail(file)
      }
    });
  })], 2), _vm._v(" "), _c('folder-items-view', {
    attrs: {
      "uploadingFilesLength": _vm.uploadingFiles.length,
      "folder": _vm.selectedFolder,
      "has-preview": _vm.hasPreview
    }
  })], 1)] : !_vm.showUploadView ? [_c('div', [_c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3 sm:tm-grid-cols-6"
  }, [_vm._l(_vm.uploadingErrors, function (file, index) {
    return _c('uploading-error', {
      key: 'error' + index + file.name,
      attrs: {
        "name": file.name,
        "thumbnail": _vm.getThumbnail(file)
      },
      on: {
        "remove": function ($event) {
          return _vm.removeError(file);
        }
      }
    });
  }), _vm._v(" "), _vm._l(_vm.uploadingFiles, function (file, index) {
    return _c('uploading-file', {
      key: index + file.name,
      attrs: {
        "name": file.name,
        "progress": file === _vm.fileProgress.file ? _vm.fileProgress.progress : 0,
        "thumbnail": _vm.getThumbnail(file)
      }
    });
  })], 2), _vm._v(" "), _c('all-items-view', {
    attrs: {
      "showOptionsHeader": _vm.uploadingFiles.length === 0 && _vm.uploadingErrors.length === 0,
      "folders": _vm.folders,
      "items": _vm.churchMedia,
      "has-preview": _vm.hasPreview
    },
    on: {
      "load-more": _vm.handleInfiniteLoading,
      "search": _vm.runSearch
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('move-modal', {
    attrs: {
      "folders": _vm.folders
    }
  }), _vm._v(" "), _c('edit-item-modal'), _vm._v(" "), _c('remove-item-modal'), _vm._v(" "), _c('remove-items-modal')], 1);
};

var __vue_staticRenderFns__$R = [];
/* style */

const __vue_inject_styles__$R = undefined;
/* scoped */

const __vue_scope_id__$R = undefined;
/* module identifier */

const __vue_module_identifier__$R = undefined;
/* functional template */

const __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$R = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);

//
var script$S = {
  name: 'ItemDropdown',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundary: {
      type: String,
      default: 'scrollParent'
    },
    item: Object
  },
  components: {
    DownloadAltIcon: __vue_component__$b,
    FolderPlusAltIcon: __vue_component__$5,
    ShareAltIcon: __vue_component__$c,
    TrashAltIcon: __vue_component__$e,
    HeartAltIcon: __vue_component__$i,
    EditIcon: __vue_component__$9,
    TerminalIcon: __vue_component__$n
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (show) {
        this.$parent.dropdownOpened = true;
        this.$nextTick(() => {
          this.popper = createPopper(this.$el, this.$refs.dropdown, {
            placement: this.placement,
            strategy: "fixed",
            modifiers: [{
              name: 'preventOverflow',
              options: {
                boundary: this.boundary
              }
            }, {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }]
          });
        });
      } else if (this.popper) {
        this.$parent.dropdownOpened = false;
        setTimeout(() => this.popper.destroy(), 100);
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    downloadItem() {
      eventBus.emit(this.namespace, 'download', {
        url: this.item.url,
        file_name: this.item.file_name
      });
      this.show = false;
    },

    startEditing() {
      this.$emit('edit');
      this.show = false;
    },

    toggleFavorite() {
      api.patch(`/church-media/items/${this.item.uuid}/toggle-favorite`).then(({
        data
      }) => {
        this.show = false;
        this.item.favorited = data.favorited;

        if (!data.favorited) {
          eventBus.emit(this.namespace, 'remove-church-item-from-favorited', this.item);
        }
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
      });
    },

    showRemoveItemModal() {
      eventBus.emit(this.namespace, 'show-remove-item-modal', {
        item: this.item,
        force: false
      });
      this.show = false;
    },

    showEditItemModal() {
      eventBus.emit(this.namespace, 'show-edit-item-modal', this.item);
      this.show = false;
    }

  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

};

/* script */
const __vue_script__$S = script$S;
/* template */

var __vue_render__$S = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('button', {
    staticClass: "tm-bg-gray-100",
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("Open")])], {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm.show ? _c('portal', {
    attrs: {
      "to": "dropdown-" + _vm.namespace
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })]), _vm._v(" "), _c('section', {
    ref: "dropdown",
    staticClass: "tm-w-44 tm-z-50 tm-bg-white tm-rounded-md tm-shadow-lg tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-py-1",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Download\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showEditItemModal($event);
      }
    }
  }, [_c('edit-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Edit\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot tm-bg-transparent hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": _vm.toggleFavorite
    }
  }, [_c('heart-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v(" "), _vm.item.favorited ? _c('span', [_vm._v("Unfavorite")]) : _c('span', [_vm._v("Favorite")])], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.startEditing($event);
      }
    }
  }, [_c('terminal-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Rename\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRemoveItemModal($event);
      }
    }
  }, [_c('trash-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Delete\n        ")], 1)])], 1)]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$S = [];
/* style */

const __vue_inject_styles__$S = undefined;
/* scoped */

const __vue_scope_id__$S = undefined;
/* module identifier */

const __vue_module_identifier__$S = undefined;
/* functional template */

const __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$S = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);

//
var script$T = {
  name: 'ItemDropdown',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundary: {
      type: String,
      default: 'scrollParent'
    },
    item: Object
  },
  components: {
    DownloadAltIcon: __vue_component__$b,
    ShareAltIcon: __vue_component__$c,
    HeartAltIcon: __vue_component__$i
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (show) {
        this.$parent.dropdownOpened = true;
        this.$nextTick(() => {
          this.popper = createPopper(this.$el, this.$refs.dropdown, {
            placement: this.placement,
            strategy: "fixed",
            modifiers: [{
              name: 'preventOverflow',
              options: {
                boundary: this.boundary
              }
            }, {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }]
          });
        });
      } else if (this.popper) {
        this.$parent.dropdownOpened = false;
        setTimeout(() => this.popper.destroy(), 100);
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    downloadItem() {
      eventBus.emit(this.namespace, 'download', {
        url: `/download/item/${this.item.uuid}`,
        file_name: `${this.item.slug}.zip`,
        withAxios: true
      });
      this.show = false;
    },

    toggleFavorite() {
      api.patch(`/media/items/${this.item.id}/toggle-favorite`).then(({
        data
      }) => {
        this.show = false;
        this.item.favorited = data.favorited;

        if (!data.favorited) {
          eventBus.emit(this.namespace, 'remove-media-item-from-favorited', this.item);
        }
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
      });
    }

  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

};

/* script */
const __vue_script__$T = script$T;
/* template */

var __vue_render__$T = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('button', {
    staticClass: "tm-bg-gray-100",
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("Open")])], {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm.show ? _c('portal', {
    attrs: {
      "to": "dropdown-" + _vm.namespace
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })]), _vm._v(" "), _c('section', {
    ref: "dropdown",
    staticClass: "tm-w-44 tm-z-50 tm-bg-white tm-rounded-md tm-shadow-lg tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-py-1",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Download\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": _vm.toggleFavorite
    }
  }, [_c('heart-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v(" "), _vm.item.favorited ? _c('span', [_vm._v("Unfavorite")]) : _c('span', [_vm._v("Favorite")])], 1)])], 1)]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$T = [];
/* style */

const __vue_inject_styles__$T = undefined;
/* scoped */

const __vue_scope_id__$T = undefined;
/* module identifier */

const __vue_module_identifier__$T = undefined;
/* functional template */

const __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$T = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);

//
var script$U = {
  name: 'FileTypePreview',
  props: {
    item: Object
  },
  components: {
    FolderPreview: __vue_component__$6
  }
};

/* script */
const __vue_script__$U = script$U;
/* template */

var __vue_render__$U = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-flex tm-items-center tm-justify-center tm-select-none"
  }, [[_c('img', {
    staticClass: "tm-h-full tm-rounded-lg tm-object-cover",
    attrs: {
      "src": _vm.item.previews[0]
    }
  })], _vm._v(" "), _vm.item.type == 'video' ? [_c('div', {
    staticClass: "tm-absolute tm-z-10 tm-inset-0 tm-flex tm-items-center tm-justify-center tm-opacity-75"
  }, [_c('svg', {
    staticClass: "tm-h-16 tm-w-16 tm-text-white",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24",
      "stroke": "currentColor"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1",
      "d": "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1",
      "d": "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }
  })])])] : _vm._e()], 2);
};

var __vue_staticRenderFns__$U = [];
/* style */

const __vue_inject_styles__$U = undefined;
/* scoped */

const __vue_scope_id__$U = undefined;
/* module identifier */

const __vue_module_identifier__$U = undefined;
/* functional template */

const __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$U = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);

//
var script$V = {
  name: 'ItemComponent',
  props: {
    item: Object,
    selectable: {
      type: Boolean,
      default: true
    },
    selected: Boolean
  },
  components: {
    DotsHorizontalIcon: __vue_component__$3,
    CheckboxIcon: __vue_component__$8,
    ItemDropdown: __vue_component__$T,
    TithelyFileTypePreview: __vue_component__$U,
    FavoriteComponent: __vue_component__$C
  },

  data() {
    return {
      dropdownOpened: false,
      cmdmultipleSelection: false,
      ctrlmultipleSelection: false
    };
  },

  computed: {
    isSelected() {
      return this.selected;
    },

    isPreviewing() {
      return this.$parent.itemPreview == this.item;
    },

    selecting() {
      return this.$parent.selectingItems;
    },

    selectedItems() {
      return this.$parent.selectedItems;
    },

    isActive() {
      return this.isSelected || this.dropdownOpened || this.selecting || this.isPreviewing;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },

  mounted() {
    document.addEventListener("keydown", this.enableMultipleSelection);
    document.addEventListener("keyup", this.disableMultipleSelection);
  },

  methods: {
    toggleMediaPreview() {
      if (this.item.type == 'folder') {
        eventBus.emit(this.namespace, 'select-folder', this.item);
        return;
      }

      let index = this.selectedItems.findIndex(media => media.id == this.item.id && media.type == this.item.type);

      if (!this.isSelected) {
        if (!this.cmdMultipleSelection && !this.ctrlMultipleSelection) {
          eventBus.emit(this.namespace, 'clear-item-selection');
        }

        eventBus.emit(this.namespace, 'select-item', this.item);
      } else if (this.cmdMultipleSelection || this.ctrlMultipleSelection || this.selectedItems.length == 1) {
        eventBus.emit(this.namespace, 'remove-item', index);
      }

      eventBus.emit(this.namespace, "toggle-preview", this.item);
    },

    enableMultipleSelection(e) {
      if (e.key === 'Meta') {
        this.cmdMultipleSelection = true;
      }

      if (e.key === 'Control') {
        this.ctrlMultipleSelection = true;
      }

      if (e.key === 'Escape') {
        eventBus.emit(this.namespace, 'clear-item-selection');
      }
    },

    disableMultipleSelection(e) {
      if (e.key === 'Meta') {
        this.cmdMultipleSelection = false;
      }

      if (e.key === 'Control') {
        this.ctrlMultipleSelection = false;
      }
    }

  }
};

/* script */
const __vue_script__$V = script$V;
/* template */

var __vue_render__$V = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative tm-group"
  }, [_c('div', {
    staticClass: "tm-relative tm-pb-full tm-rounded-lg tm-overflow-hidden tm-cursor-pointer",
    on: {
      "click": _vm.toggleMediaPreview
    }
  }, [_c('tithely-file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _vm.item.type != 'folder' ? _c('div', {
    staticClass: "tm-h-full tm-w-full tm-rounded-item tm-absolute tm-top-0 tm-bg-gradient-to-t tm-from-gray-900 tm-opacity-0 group-hover:tm-opacity-30 tm-z-10"
  }) : _vm._e(), _vm._v(" "), _vm.item.type != 'folder' ? _c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-end tm-absolute tm-bottom-1 tm-pr-2 tm-right-0 tm-inset-x-0 tm-z-20 tm-opacity-0 group-hover:tm-opacity-100 tm-transition"
  }, [_c('favorite-component', {
    attrs: {
      "itemType": "media",
      "item": _vm.item
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-z-10 tm-bg-carolina tm-transition-all tm-duration-200",
    class: _vm.isSelected || _vm.isPreviewing ? 'tm-bg-opacity-20' : 'tm-bg-opacity-0'
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2"
  }, [_vm._v("\n    " + _vm._s(_vm.item.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-top-0 tm-inset-x-0 tm-z-20 tm-flex tm-justify-between tm-mt-2 tm-mx-2 tm-opacity-0 group-hover:tm-opacity-100 tm-transition",
    class: {
      'tm-opacity-100': _vm.isActive
    }
  }, [_c('div', [_vm.isSelected ? _c('div', [_c('checkbox-icon', {
    staticClass: "tm-h-5 tm-w-5 tm-cursor-pointer",
    attrs: {
      "checked": _vm.isSelected
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('item-dropdown', {
    attrs: {
      "item": _vm.item
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var toggle = ref.toggle;
        return [_c('button', {
          staticClass: "tm-bg-white tm-h-5 tm-w-5 tm-p-0 tm-border tm-border-payneHot tm-rounded tm-hidden sm:tm-flex tm-items-center\n        tm-justify-center hover:tm-bg-gray-100 focus:tm-outline-none focus:tm-border-payneFire ",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return toggle($event);
            }
          }
        }, [_c('DotsHorizontalIcon', {
          staticClass: "tm-h-4 tm-text-payneHot"
        })], 1)];
      }
    }])
  })], 1)]);
};

var __vue_staticRenderFns__$V = [];
/* style */

const __vue_inject_styles__$V = undefined;
/* scoped */

const __vue_scope_id__$V = undefined;
/* module identifier */

const __vue_module_identifier__$V = undefined;
/* functional template */

const __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$V = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);

//
var script$W = {
  name: 'FavoritedItemsSection',
  components: {
    InfiniteLoading,
    ItemComponent: __vue_component__$D,
    ItemDropdown: __vue_component__$S,
    TithelyItemComponent: __vue_component__$V,
    SearchIcon: __vue_component__$1,
    RefreshIcon: __vue_component__$m,
    EditItemModal: __vue_component__$K,
    RemoveItemModal: __vue_component__$L,
    DotsHorizontalIcon: __vue_component__$3,
    MobileFileSelectLimitMessage: __vue_component__$E
  },

  data() {
    return {
      showYourMediaSection: true,
      loadingChurchItems: false,
      churchMediaPage: 1,
      hasMoreChurchItems: 1,
      churchMedia: [],
      showTithelyMediaSection: true,
      loadingTithelyItems: false,
      mediaPage: 1,
      hasMoreTithelyItems: 1,
      media: []
    };
  },

  computed: {
    selectingItems() {
      return this.$parent.$parent.selectingItems;
    },

    productId() {
      return this.$parent.$parent.productId;
    },

    selectedItems() {
      return this.$parent.$parent.selectedItems;
    },

    itemPreview() {
      return this.$parent.$parent.itemPreview;
    },

    hasPreview() {
      return this.selectedItems.length > 1 || !!this.itemPreview;
    },

    mediaTypes() {
      return this.$parent.$parent.computedTypes;
    },

    namespace() {
      return this.$parent.$parent.namespace;
    },

    selectLimit() {
      return this.$parent.$parent.selectLimit;
    },

    blockedExtensions() {
      return this.$parent.$parent.blockedExtensions;
    }

  },
  methods: {
    toggleSelect() {
      eventBus.emit(this.namespace, 'toggle-selecting-items');
    },

    isWebP(item) {
      if (!item) {
        return false;
      }

      if (item.type === 'folder') {
        return false;
      }

      if (item.files && item.files.length > 0) {
        return item.files[0].mime_type === 'image/webp';
      }
    },

    toggleYourMediaSection() {
      this.showYourMediaSection = !this.showYourMediaSection;
    },

    toggleTithelyMediaSection() {
      this.showTithelyMediaSection = !this.showTithelyMediaSection;
    },

    isSelected(item) {
      let findItem = this.selectedItems.find(i => i.type == item.type && i.uuid == item.uuid);
      return typeof findItem != 'undefined';
    },

    loadMoreChurchMedia() {
      if (!this.hasMoreChurchItems) {
        return;
      }

      this.churchMediaPage += 1;
      this.fetchChurchMedia();
    },

    fetchChurchMedia() {
      this.loadingChurchItems = true;
      api.get('/church-media/items', {
        params: {
          per_page: 24,
          page: this.churchMediaPage,
          'filter[type]': this.mediaTypes.join(','),
          'filter[favorited]': true
        }
      }).then(({
        data
      }) => {
        this.churchMedia.push(...data.data);

        if (data.meta.current_page < data.meta.last_page) {
          this.churchMediaPage++;
          this.hasMoreChurchItems = true;
        } else {
          this.hasMoreChurchItems = false;
        }
      }).finally(() => this.loadingChurchItems = false);
    },

    loadMoreTithelyMedia() {
      if (!this.hasMoreTithelyItems) {
        return;
      }

      this.mediaPage += 1;
      this.fetchTithelyMedia();
    },

    fetchTithelyMedia() {
      this.loadingTithelyItems = true;
      api.get('/media/items', {
        params: {
          per_page: 24,
          page: this.mediaPage,
          'filter[type]': this.mediaTypes.join(','),
          'filter[favorited]': true
        }
      }).then(({
        data
      }) => {
        let filteredItems = this.removeFilesWithBlockedExtensions(data.data);
        this.media.push(...filteredItems);

        if (data.meta.current_page < data.meta.last_page) {
          this.hasMoreTithelyItems = true;
        } else {
          this.hasMoreTithelyItems = false;
        }
      }).finally(() => this.loadingTithelyItems = false);
    },

    removeFilesWithBlockedExtensions(items) {
      return items.map(item => {
        item.files = item.files.filter(file => {
          let extension = file.url.split('.').pop();
          return !this.blockedExtensions.includes(extension);
        });
        return item;
      }).filter(item => !!item.files.length);
    }

  },

  mounted() {
    this.fetchChurchMedia();
    this.fetchTithelyMedia();
    eventBus.on(this.namespace, 'remove-church-item-from-favorited', item => {
      let index = this.churchMedia.indexOf(item);

      if (index === -1) {
        return;
      }

      this.churchMedia.splice(index, 1);
    });
    eventBus.on(this.namespace, 'remove-media-item-from-favorited', item => {
      let index = this.media.indexOf(item);

      if (index === -1) {
        return;
      }

      this.media.splice(index, 1);
    });
    eventBus.on(this.namespace, 'updated-church-item', item => {
      let index = this.churchMedia.findIndex(i => i.id == item.id);

      if (index === -1) {
        return;
      }

      this.churchMedia.splice(index, 1, item);

      if (this.itemPreview && this.itemPreview.uuid == item.uuid) {
        eventBus.emit(this.namespace, 'toggle-preview', null);
        eventBus.emit(this.namespace, 'toggle-preview', item);
      }
    });
    eventBus.on(this.namespace, 'remove-item-from-root', item => {
      let index = this.churchMedia.indexOf(item);

      if (index === -1) {
        return;
      }

      this.churchMedia.splice(index, 1);
    });
    eventBus.on(this.namespace, 'remove-item-from-selected', item => {
      let index = this.selectedItems.indexOf(item);

      if (index === -1) {
        return;
      }

      this.selectedItems.splice(index, 1);
    });
    eventBus.on(this.namespace, 'remove-item-from-preview', item => {
      if (this.itemPreview && this.itemPreview.uuid == item.uuid) {
        eventBus.emit(this.namespace, 'toggle-preview', null);
      }
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'remove-church-item-from-favorited');
    eventBus.off(this.namespace, 'remove-media-item-from-favorited');
    eventBus.off(this.namespace, 'updated-church-item');
    eventBus.off(this.namespace, 'remove-item-from-root');
    eventBus.off(this.namespace, 'remove-item-from-selected');
    eventBus.off(this.namespace, 'remove-item-from-preview');
  }

};

var css_248z$3 = ".loading-container .loading-spiral{display:inline-block;margin:5px 0;width:28px;height:28px;font-size:28px;line-height:28px;border-radius:50%;border:2px solid #777;border-right-color:transparent}";
var stylesheet$3=".loading-container .loading-spiral{display:inline-block;margin:5px 0;width:28px;height:28px;font-size:28px;line-height:28px;border-radius:50%;border:2px solid #777;border-right-color:transparent}";
styleInject(css_248z$3);

/* script */
const __vue_script__$W = script$W;
/* template */

var __vue_render__$W = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-flex-1 tm-overflow-y-scroll tm-p-6 tm-pr-4 tm-space-y-6"
  }, [_c('section', [_c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-end tm-space-x-4"
  }, [_c('div', {
    staticClass: "sm:tm-hidden"
  }, [!_vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Select\n        ")]) : _vm._e(), _vm._v(" "), _vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]) : _vm._e()])]), _vm._v(" "), _vm.selectingItems && _vm.selectLimit ? _c('div', [_c('mobile-file-select-limit-message', {
    attrs: {
      "select-limit": _vm.selectLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "your-media-items tm-mt-6 sm:tm-mt-0"
  }, [_c('div', {
    staticClass: "tm-flex tm-justify-between tm-items-center"
  }, [_c('h2', {
    staticClass: "tm-font-medium tm-text-yank tm-text-base"
  }, [_vm._v("My Media Favorites")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tm-text-xs tm-text-yank tm-underline tm-rounded focus:tm-outline-none focus:tm-ring-offset-2 focus-visible:tm-outline-none focus-visible:tm-ring focus:tm-ring-aquamarine tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleYourMediaSection($event);
      }
    }
  }, [_vm.showYourMediaSection ? _c('span', [_vm._v("Hide")]) : _c('span', [_vm._v("Show")])])])]), _vm._v(" "), _vm.showYourMediaSection ? _c('div', [_vm.churchMedia.length ? [_c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'sm:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, _vm._l(_vm.churchMedia, function (item) {
    return _c('item-component', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isWebP(item),
        expression: "!isWebP(item)"
      }],
      key: "your-media-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (ref) {
          var enableEditing = ref.enableEditing;
          var item = ref.item;
          return [item.type != 'folder' ? _c('item-dropdown', {
            attrs: {
              "item": item
            },
            on: {
              "edit": enableEditing
            },
            scopedSlots: _vm._u([{
              key: "default",
              fn: function (ref) {
                var toggle = ref.toggle;
                return [_c('button', {
                  staticClass: "tm-bg-white tm-h-5 tm-w-5 tm-p-0 tm-border tm-border-payneHot tm-rounded tm-hidden sm:tm-flex tm-items-center\n                    tm-justify-center hover:tm-bg-gray-100 focus:tm-outline-none focus:tm-border-payneFire ",
                  attrs: {
                    "type": "button"
                  },
                  on: {
                    "click": function ($event) {
                      $event.preventDefault();
                      return toggle($event);
                    }
                  }
                }, [_c('DotsHorizontalIcon', {
                  staticClass: "tm-h-4 tm-text-payneHot"
                })], 1)];
              }
            }], null, true)
          }) : _vm._e()];
        }
      }], null, true)
    });
  }), 1), _vm._v(" "), _vm.hasMoreChurchItems ? _c('div', {
    staticClass: "tm-flex tm-justify-center tm-mt-4"
  }, [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loadMoreChurchMedia($event);
      }
    }
  }, [_c('refresh-icon', {
    staticClass: "tm-h-3.5 tm-w-3.5 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("\n                Load More\n              ")])], 1)]) : _vm._e()] : [!_vm.loadingChurchItems ? _c('div', {
    staticClass: "tm-mt-4 tm-flex tm-justify-center"
  }, [_c('span', {
    staticClass: "tm-text-sm tm-font-medium tm-text-payneFire"
  }, [_vm._v("\n              No favorites found in my media.\n            ")])]) : _vm._e()], _vm._v(" "), _vm.loadingChurchItems ? _c('div', {
    staticClass: "tm-mt-3 loading-container"
  }, [_vm._m(0)]) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "your-media-items tm-mt-6"
  }, [_c('div', {
    staticClass: "tm-flex tm-justify-between tm-items-center"
  }, [_c('h2', {
    staticClass: "tm-font-medium tm-text-yank tm-text-base"
  }, [_vm._v("Tithe.ly Media Favorites")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tm-text-xs tm-text-yank tm-underline tm-rounded focus:tm-outline-none focus:tm-ring-offset-2 focus-visible:tm-outline-none focus-visible:tm-ring focus:tm-ring-aquamarine tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleTithelyMediaSection($event);
      }
    }
  }, [_vm.showTithelyMediaSection ? _c('span', [_vm._v("Hide")]) : _c('span', [_vm._v("Show")])])])]), _vm._v(" "), _vm.showTithelyMediaSection ? _c('div', [_vm.media.length ? [_c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'sm:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, _vm._l(_vm.media, function (item) {
    return _c('tithely-item-component', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isWebP(item),
        expression: "!isWebP(item)"
      }],
      key: "tithely-media-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      }
    });
  }), 1), _vm._v(" "), _vm.hasMoreChurchItems ? _c('div', {
    staticClass: "tm-flex tm-justify-center tm-mt-4"
  }, [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.loadMoreTithelyMedia($event);
      }
    }
  }, [_c('refresh-icon', {
    staticClass: "tm-h-3.5 tm-w-3.5 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("\n                Load More\n              ")])], 1)]) : _vm._e()] : [!_vm.loadingTithelyItems ? _c('div', {
    staticClass: "tm-mt-4 tm-flex tm-justify-center"
  }, [_c('span', {
    staticClass: "tm-text-sm tm-font-medium tm-text-payneFire"
  }, [_vm._v("\n              No favorites found in Tithe.ly media.\n            ")])]) : _vm._e()], _vm._v(" "), _vm.loadingTithelyItems ? _c('div', {
    staticClass: "tm-mt-3 loading-container"
  }, [_vm._m(1)]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('edit-item-modal'), _vm._v(" "), _c('remove-item-modal')], 1);
};

var __vue_staticRenderFns__$W = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "status-prompt tm-flex tm-items-center tm-justify-center"
  }, [_c('i', {
    staticClass: "loading-spiral tm-animate-spin",
    attrs: {
      "spinner": "spiral"
    }
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "status-prompt tm-flex tm-items-center tm-justify-center"
  }, [_c('i', {
    staticClass: "loading-spiral tm-animate-spin",
    attrs: {
      "spinner": "spiral"
    }
  })]);
}];
/* style */

const __vue_inject_styles__$W = undefined;
/* scoped */

const __vue_scope_id__$W = undefined;
/* module identifier */

const __vue_module_identifier__$W = undefined;
/* functional template */

const __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$W = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);

//
var script$X = {
  name: 'EmptyState',
  components: {
    EmptyStateSvg: __vue_component__$h
  }
};

/* script */
const __vue_script__$X = script$X;
/* template */

var __vue_render__$X = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-mt-10 sm:tm-mt-0 tm-flex tm-items-center tm-flex-col"
  }, [_c('empty-state-svg', {
    staticClass: "tm-h-48 sm:tm-h-40 sm:tm-mt-6"
  }), _vm._v(" "), _vm._m(0)], 1);
};

var __vue_staticRenderFns__$X = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-mt-6 tm-text-center"
  }, [_c('h2', {
    staticClass: "tm-leading-tight tm-text-lg tm-font-semibold tm-text-yankFire tm-flex tm-items-center tm-flex-col"
  }, [_c('span', [_vm._v("You don't have any")]), _vm._v(" "), _c('span', [_vm._v("deleted items")])]), _vm._v(" "), _c('p', {
    staticClass: "tm-text-payne tm-text-xs tm-mt-2"
  }, [_vm._v("Any media items you delete will show in here.")])]);
}];
/* style */

const __vue_inject_styles__$X = undefined;
/* scoped */

const __vue_scope_id__$X = undefined;
/* module identifier */

const __vue_module_identifier__$X = undefined;
/* functional template */

const __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$X = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);

//
var script$Y = {
  name: 'ItemDropdown',
  props: {
    placement: {
      type: String,
      default: 'bottom-start'
    },
    boundary: {
      type: String,
      default: 'scrollParent'
    },
    item: Object
  },
  components: {
    DownloadAltIcon: __vue_component__$b,
    RefreshIcon: __vue_component__$m,
    TrashAltIcon: __vue_component__$e
  },

  data() {
    return {
      show: false
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (show) {
        this.$parent.dropdownOpened = true;
        this.$nextTick(() => {
          this.popper = createPopper(this.$el, this.$refs.dropdown, {
            placement: this.placement,
            strategy: "fixed",
            modifiers: [{
              name: 'preventOverflow',
              options: {
                boundary: this.boundary
              }
            }, {
              name: 'offset',
              options: {
                offset: [0, 8]
              }
            }]
          });
        });
      } else if (this.popper) {
        this.$parent.dropdownOpened = false;
        setTimeout(() => this.popper.destroy(), 100);
      }
    }

  },
  methods: {
    toggle() {
      this.show = !this.show;
    },

    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    downloadItem() {
      fileDownload(this.item.url, this.item.file_name);
      this.show = false;
    },

    showRemoveItemModal() {
      eventBus.emit(this.namespace, 'show-remove-item-modal', {
        item: this.item,
        force: true
      });
      this.show = false;
    },

    showRestoreItemModal() {
      eventBus.emit(this.namespace, 'show-restore-item-modal', this.item);
      this.show = false;
    }

  },

  mounted() {
    document.addEventListener('keydown', this.handleEscapeKey);
  },

  destroyed() {
    document.removeEventListener('keydown', this.handleEscapeKey);
  }

};

/* script */
const __vue_script__$Y = script$Y;
/* template */

var __vue_render__$Y = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm._t("default", [_c('button', {
    staticClass: "tm-bg-gray-100",
    attrs: {
      "aria-haspopup": "true",
      "aria-expanded": "true"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggle($event);
      }
    }
  }, [_vm._v("Open")])], {
    "toggle": _vm.toggle
  }), _vm._v(" "), _vm.show ? _c('portal', {
    attrs: {
      "to": "dropdown-" + _vm.namespace
    }
  }, [_c('div', [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-40 tm-inset-0 tm-bg-transparent",
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  })]), _vm._v(" "), _c('section', {
    ref: "dropdown",
    staticClass: "tm-w-44 tm-z-50 tm-bg-white tm-rounded-md tm-shadow-lg tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-py-1",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Download\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRestoreItemModal($event);
      }
    }
  }, [_c('refresh-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Restore\n        ")], 1), _vm._v(" "), _c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-2 tm-text-xs tm-text-yank  tm-bg-transparent hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRemoveItemModal($event);
      }
    }
  }, [_c('trash-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n          Delete Forever\n        ")], 1)])], 1)]) : _vm._e()], 2);
};

var __vue_staticRenderFns__$Y = [];
/* style */

const __vue_inject_styles__$Y = undefined;
/* scoped */

const __vue_scope_id__$Y = undefined;
/* module identifier */

const __vue_module_identifier__$Y = undefined;
/* functional template */

const __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);

//
var script$Z = {
  name: 'ItemComponent',
  props: {
    item: Object,
    selectable: {
      type: Boolean,
      default: true
    },
    selected: Boolean
  },
  components: {
    DotsHorizontalIcon: __vue_component__$3,
    CheckboxIcon: __vue_component__$8,
    ItemDropdown: __vue_component__$Y,
    FileTypePreview: __vue_component__$A
  },

  data() {
    return {
      dropdownOpened: false,
      cmdmultipleSelection: false,
      ctrlmultipleSelection: false
    };
  },

  computed: {
    isSelected() {
      return this.selected;
    },

    selecting() {
      return this.$parent.selectingItems;
    },

    selectedItems() {
      return this.$parent.selectedItems;
    },

    isPreviewing() {
      return this.$parent.itemPreview == this.item;
    },

    isActive() {
      return this.isSelected || this.dropdownOpened || this.selecting || this.isPreviewing;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },

  mounted() {
    document.addEventListener("keydown", this.enableMultipleSelection);
    document.addEventListener("keyup", this.disableMultipleSelection);
  },

  methods: {
    toggleMediaPreview() {
      if (this.item.type == 'folder') {
        eventBus.emit(this.namespace, 'select-folder', this.item);
        return;
      }

      let index = this.selectedItems.findIndex(media => media.id == this.item.id && media.type == this.item.type);

      if (!this.isSelected) {
        if (!this.cmdMultipleSelection && !this.ctrlMultipleSelection) {
          eventBus.emit(this.namespace, 'clear-item-selection');
        }

        eventBus.emit(this.namespace, 'select-item', this.item);
      } else if (this.cmdMultipleSelection || this.ctrlMultipleSelection || this.selectedItems.length == 1) {
        eventBus.emit(this.namespace, 'remove-item', index);
      }

      eventBus.emit(this.namespace, "toggle-preview", this.item);
    },

    enableMultipleSelection(e) {
      if (e.key === 'Meta') {
        this.cmdMultipleSelection = true;
      }

      if (e.key === 'Control') {
        this.ctrlMultipleSelection = true;
      }

      if (e.key === 'Escape') {
        eventBus.emit(this.namespace, 'clear-item-selection');
      }
    },

    disableMultipleSelection(e) {
      if (e.key === 'Meta') {
        this.cmdMultipleSelection = false;
      }

      if (e.key === 'Control') {
        this.ctrlMultipleSelection = false;
      }
    }

  }
};

/* script */
const __vue_script__$Z = script$Z;
/* template */

var __vue_render__$Z = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative tm-group"
  }, [_c('div', {
    staticClass: "tm-relative tm-pb-full tm-rounded-lg tm-overflow-hidden tm-cursor-pointer",
    on: {
      "click": _vm.toggleMediaPreview
    }
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-z-10 tm-bg-carolina tm-transition-all tm-duration-200",
    class: _vm.isSelected || _vm.isPreviewing ? 'tm-bg-opacity-20' : 'tm-bg-opacity-0'
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2 tm-max-w-full tm-overflow-hidden tm-truncate"
  }, [_vm._v("\n    " + _vm._s(_vm.item.name) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-absolute tm-top-0 tm-inset-x-0 tm-z-20 tm-flex tm-justify-between tm-mt-2 tm-mx-2 tm-opacity-0 group-hover:tm-opacity-100 tm-transition",
    class: {
      'tm-opacity-100': _vm.isActive
    }
  }, [_c('div', [_vm.isSelected ? _c('div', [_c('checkbox-icon', {
    staticClass: "tm-h-5 tm-w-5 tm-cursor-pointer",
    attrs: {
      "checked": _vm.isSelected
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('item-dropdown', {
    attrs: {
      "item": _vm.item
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (ref) {
        var toggle = ref.toggle;
        return [_c('button', {
          staticClass: "tm-bg-white tm-h-5 tm-w-5 tm-p-0 tm-border tm-border-payneHot tm-rounded tm-hidden sm:tm-flex tm-items-center\n        tm-justify-center hover:tm-bg-gray-100 focus:tm-outline-none focus:tm-border-payneFire ",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return toggle($event);
            }
          }
        }, [_c('DotsHorizontalIcon', {
          staticClass: "tm-h-4 tm-text-payneHot"
        })], 1)];
      }
    }])
  })], 1)]);
};

var __vue_staticRenderFns__$Z = [];
/* style */

const __vue_inject_styles__$Z = undefined;
/* scoped */

const __vue_scope_id__$Z = undefined;
/* module identifier */

const __vue_module_identifier__$Z = undefined;
/* functional template */

const __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$Z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);

//
var script$_ = {
  name: 'RestoreItemModal',
  components: {
    FileTypePreview: __vue_component__$A
  },

  data() {
    return {
      show: false,
      working: false,
      item: null
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.item = null;
        this.working = false;
      }
    }

  },
  methods: {
    restoreItem() {
      this.working = true;
      api.patch(`/church-media/items/${this.item.uuid}/restore`).then(() => {
        // splice item from deleted items
        eventBus.emit(this.namespace, 'remove-item-from-deleted', this.item);
        eventBus.emit(this.namespace, 'toast-success', 'Media item restored!');
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', error.response.data.message);
      }).finally(() => this.show = false);
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-restore-item-modal', item => {
      this.item = item;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-restore-item-modal');
  }

};

/* script */
const __vue_script__$_ = script$_;
/* template */

var __vue_render__$_ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-lg sm:tm-w-full",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-px-4 tm-pt-5 tm-pb-4 sm:tm-p-6 sm:tm-pb-4"
  }, [_c('div', {
    staticClass: "sm:tm-flex sm:tm-items-start"
  }, [_c('div', {
    staticClass: "tm-mx-auto tm-flex-shrink-0 tm-flex tm-items-center tm-justify-center tm-h-12 tm-w-12 sm:tm-mx-0 sm:tm-h-10 sm:tm-w-10"
  }, [_c('div', {
    staticClass: "tm-h-12 tm-w-12 sm:tm-h-10 sm:tm-w-10 tm-relative"
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3 tm-text-center sm:tm-mt-0 sm:tm-ml-4 sm:tm-text-left"
  }, [_c('h3', {
    staticClass: "tm-text-lg tm-leading-6 tm-font-medium tm-text-gray-900",
    attrs: {
      "id": "modal-headline"
    }
  }, [_vm._v("\n                  Restore Item\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2"
  }, [_c('p', {
    staticClass: "tm-text-sm tm-text-gray-500"
  }, [_vm._v("\n                    Are you sure you want to restore this item?\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-bg-gray-50 tm-px-4 tm-py-3 sm:tm-px-6 sm:tm-flex sm:tm-flex-row-reverse"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-payneFire tm-text-base tm-font-medium tm-text-white hover:tm-bg-red-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-payneFire sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "button",
      "disabled": _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.restoreItem($event);
      }
    }
  }, [_vm.working ? _c('span', [_vm._v("Restoring...")]) : _c('span', [_vm._v("Restore")])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-aquamarine sm:tm-mt-0 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$_ = [];
/* style */

const __vue_inject_styles__$_ = undefined;
/* scoped */

const __vue_scope_id__$_ = undefined;
/* module identifier */

const __vue_module_identifier__$_ = undefined;
/* functional template */

const __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$_ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);

//
var script$$ = {
  name: 'RestoreItemModal',
  components: {
    TrashIcon: __vue_component__$d
  },

  data() {
    return {
      show: false,
      working: false,
      items: []
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.items = [];
        this.working = false;
      }
    },

    items(items) {
      if (!items.length) {
        this.show = false;
      }
    }

  },
  methods: {
    deleteItems() {
      this.working = true;
      this.items.forEach((item, index) => {
        api.delete(`/church-media/items/${item.uuid}/force-delete`).then(() => {
          // splice item from deleted items
          eventBus.emit(this.namespace, 'remove-item-from-deleted', item);
          eventBus.emit(this.namespace, 'remove-item-from-preview', item);
          this.items.splice(index, 1);
        }).catch(error => {
          eventBus.emit(this.namespace, 'toast-error', error.response.data.message);
        }).finally(() => this.show = false);
      });
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-delete-items-modal', items => {
      this.items = items;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-delete-items-modal');
  }

};

/* script */
const __vue_script__$$ = script$$;
/* template */

var __vue_render__$$ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-lg sm:tm-w-full",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-px-4 tm-pt-5 tm-pb-4 sm:tm-p-6 sm:tm-pb-4"
  }, [_c('div', {
    staticClass: "sm:tm-flex sm:tm-items-start"
  }, [_c('div', {
    staticClass: "tm-mx-auto tm-flex-shrink-0 tm-flex tm-items-center tm-justify-center tm-h-12 tm-w-12 sm:tm-mx-0 sm:tm-h-10 sm:tm-w-10 tm-rounded-full tm-bg-red-50"
  }, [_c('trash-icon', {
    staticClass: "tm-h-6 tm-w-6 sm:tm-h-5 sm:tm-w-5 tm-text-red-700"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3 tm-text-center sm:tm-mt-0 sm:tm-ml-4 sm:tm-text-left"
  }, [_c('h3', {
    staticClass: "tm-text-lg tm-leading-6 tm-font-medium tm-text-gray-900",
    attrs: {
      "id": "modal-headline"
    }
  }, [_vm._v("\n                  Delete " + _vm._s(_vm.items.length) + " " + _vm._s(_vm.items.length == 1 ? 'Item' : 'Items') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2"
  }, [_c('p', {
    staticClass: "tm-text-sm tm-text-gray-500"
  }, [_vm._v("\n                    Are you sure you want to delete these items? This action cannot be undone.\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-bg-gray-50 tm-px-4 tm-py-3 sm:tm-px-6 sm:tm-flex sm:tm-flex-row-reverse"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-red-600 tm-text-base tm-font-medium tm-text-white hover:tm-bg-red-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-red-500 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "button",
      "disabled": _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.deleteItems($event);
      }
    }
  }, [_vm.working ? _c('span', [_vm._v("Deleting...")]) : _c('span', [_vm._v("Delete " + _vm._s(_vm.items.length) + " " + _vm._s(_vm.items.length == 1 ? 'Item' : 'Items'))])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-gray-300 sm:tm-mt-0 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$$ = [];
/* style */

const __vue_inject_styles__$$ = undefined;
/* scoped */

const __vue_scope_id__$$ = undefined;
/* module identifier */

const __vue_module_identifier__$$ = undefined;
/* functional template */

const __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$$ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);

//
var script$10 = {
  name: 'RestoreItemModal',
  components: {
    RefreshIcon: __vue_component__$m
  },

  data() {
    return {
      show: false,
      working: false,
      items: []
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!this.show) {
        this.items = [];
        this.working = false;
      }
    },

    items(items) {
      if (!items.length) {
        this.show = false;
      }
    }

  },
  methods: {
    restoreItems() {
      this.working = true;
      this.items.forEach((item, index) => {
        api.patch(`/church-media/items/${item.uuid}/restore`).then(() => {
          // splice item from deleted items
          eventBus.emit(this.namespace, 'remove-item-from-deleted', item);
          this.items.splice(index, 1);
        }).catch(error => {
          eventBus.emit(this.namespace, 'toast-error', error.response.data.message);
        }).finally(() => this.show = false);
      });
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-restore-items-modal', items => {
      this.items = items;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-restore-items-modal');
  }

};

/* script */
const __vue_script__$10 = script$10;
/* template */

var __vue_render__$10 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all sm:tm-my-8 sm:tm-align-middle sm:tm-max-w-lg sm:tm-w-full",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-px-4 tm-pt-5 tm-pb-4 sm:tm-p-6 sm:tm-pb-4"
  }, [_c('div', {
    staticClass: "sm:tm-flex sm:tm-items-start"
  }, [_c('div', {
    staticClass: "tm-mx-auto tm-flex-shrink-0 tm-flex tm-items-center tm-justify-center tm-h-12 tm-w-12 sm:tm-mx-0 sm:tm-h-10 sm:tm-w-10 tm-rounded-full tm-bg-platinum"
  }, [_c('refresh-icon', {
    staticClass: "tm-h-6 tm-w-6 sm:tm-h-5 sm:tm-w-5 tm-text-payneFire"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3 tm-text-center sm:tm-mt-0 sm:tm-ml-4 sm:tm-text-left"
  }, [_c('h3', {
    staticClass: "tm-text-lg tm-leading-6 tm-font-medium tm-text-gray-900",
    attrs: {
      "id": "modal-headline"
    }
  }, [_vm._v("\n                  Restore " + _vm._s(_vm.items.length) + " " + _vm._s(_vm.items.length == 1 ? 'Item' : 'Items') + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2"
  }, [_c('p', {
    staticClass: "tm-text-sm tm-text-gray-500"
  }, [_vm._v("\n                    Are you sure you want to restore these items?\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-bg-gray-50 tm-px-4 tm-py-3 sm:tm-px-6 sm:tm-flex sm:tm-flex-row-reverse"
  }, [_c('button', {
    staticClass: "tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-transparent tm-shadow-sm tm-px-4 tm-py-2 tm-bg-payneFire tm-text-base tm-font-medium tm-text-white hover:opacity-90 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-platinum sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm disabled:tm-bg-platinum disabled:tm-text-cosmos",
    attrs: {
      "type": "button",
      "disabled": _vm.working
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.restoreItems($event);
      }
    }
  }, [_vm.working ? _c('span', [_vm._v("Restoring...")]) : _c('span', [_vm._v("Restore " + _vm._s(_vm.items.length) + " " + _vm._s(_vm.items.length == 1 ? 'Item' : 'Items'))])]), _vm._v(" "), _c('button', {
    staticClass: "tm-mt-3 tm-w-full tm-inline-flex tm-justify-center tm-rounded-md tm-border tm-border-gray-300 tm-shadow-sm tm-px-4 tm-py-2 tm-bg-white tm-text-base tm-font-medium tm-text-gray-700 focus:tm-outline-none focus-visible:tm-ring-2 focus:tm-ring-offset-2 focus-visible:tm-ring-gray-300 sm:tm-mt-0 sm:tm-ml-3 sm:tm-w-auto sm:tm-text-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n              Cancel\n            ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$10 = [];
/* style */

const __vue_inject_styles__$10 = undefined;
/* scoped */

const __vue_scope_id__$10 = undefined;
/* module identifier */

const __vue_module_identifier__$10 = undefined;
/* functional template */

const __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$10 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);

//
var script$11 = {
  name: 'DeletedItemsSection',
  components: {
    InfiniteLoading,
    ItemComponent: __vue_component__$Z,
    SearchIcon: __vue_component__$1,
    RefreshIcon: __vue_component__$m,
    TrashIcon: __vue_component__$d,
    RemoveItemModal: __vue_component__$L,
    RestoreItemModal: __vue_component__$_,
    DeleteItemsModal: __vue_component__$$,
    RestoreItemsModal: __vue_component__$10,
    EmptyState: __vue_component__$X
  },

  data() {
    return {
      page: 1,
      churchMedia: []
    };
  },

  computed: {
    productId() {
      return this.$parent.$parent.productId;
    },

    itemPreview() {
      return this.$parent.$parent.itemPreview;
    },

    hasPreview() {
      return !!this.itemPreview || !!this.selectedItems.length;
    },

    mediaTypes() {
      return this.$parent.$parent.computedTypes;
    },

    selectingItems() {
      return this.$parent.$parent.selectingItems;
    },

    selectedItems() {
      return this.$parent.$parent.selectedItems;
    },

    namespace() {
      return this.$parent.$parent.namespace;
    }

  },
  methods: {
    toggleSelect() {
      eventBus.emit(this.namespace, 'toggle-selecting-items');
    },

    isSelected(item) {
      let findItem = this.selectedItems.find(i => i.type == item.type && i.uuid == item.uuid);
      return typeof findItem != 'undefined';
    },

    handleInfiniteLoading($state) {
      this.fetchChurchMedia().then(hasMore => {
        if (this.churchMedia.length) {
          $state.loaded();
        }

        if (hasMore) {
          this.page++;
          return;
        }

        $state.complete();
      });
    },

    fetchChurchMedia() {
      return api.get('/church-media/items', {
        params: {
          per_page: 24,
          page: this.page,
          'filter[type]': this.mediaTypes.join(','),
          'filter[trashed]': 'only'
        }
      }).then(({
        data
      }) => {
        this.churchMedia.push(...data.data);
        return Promise.resolve(data.meta.current_page < data.meta.last_page);
      });
    },

    showDeleteItemsModal() {
      eventBus.emit(this.namespace, 'show-delete-items-modal', this.selectedItems);
    },

    showRestoreItemsModal() {
      eventBus.emit(this.namespace, 'show-restore-items-modal', this.selectedItems);
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'remove-item-from-deleted', item => {
      let index = this.churchMedia.indexOf(item);

      if (index === -1) {
        return;
      }

      this.churchMedia.splice(index, 1); // remove from selected

      let selectedIndex = this.selectedItems.indexOf(item);

      if (selectedIndex === -1) {
        return;
      }

      this.selectedItems.splice(selectedIndex, 1);
    });
    eventBus.on(this.namespace, 'remove-item-from-preview', item => {
      if (this.itemPreview && this.itemPreview.uuid == item.uuid) {
        eventBus.emit(this.namespace, 'toggle-preview', null);
      }
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'remove-item-from-deleted');
    eventBus.off(this.namespace, 'remove-item-from-preview');
  }

};

/* script */
const __vue_script__$11 = script$11;
/* template */

var __vue_render__$11 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-flex-1 tm-overflow-y-scroll tm-p-6 tm-pr-4 tm-space-y-6"
  }, [_c('section', [_c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-between tm-space-y-4 sm:tm-space-x-4 tm-flex-col sm:tm-flex-row"
  }, [_vm._m(0), _vm._v(" "), _vm.selectedItems.length ? _c('div', {
    staticClass: "tm-flex tm-items-center tm-space-x-2"
  }, [_c('div', [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRestoreItemsModal($event);
      }
    }
  }, [_c('refresh-icon', {
    staticClass: "tm-h-3.5 tm-w-3.5 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("Restore " + _vm._s(_vm.selectedItems.length) + " " + _vm._s(_vm.selectedItems.length == 1 ? 'Item' : 'Items'))])], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tm-h-9 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showDeleteItemsModal($event);
      }
    }
  }, [_c('trash-icon', {
    staticClass: "tm-h-3.5 tm-w-3.5 tm-text-payneFire"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-2"
  }, [_vm._v("Delete " + _vm._s(_vm.selectedItems.length) + " " + _vm._s(_vm.selectedItems.length == 1 ? 'Item' : 'Items') + " forever")])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "all-items tm-mt-6"
  }, [_c('div', {
    staticClass: "sm:tm-hidden tm-flex tm-justify-between tm-items-center"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base"
  }, [_vm._v("All Files")]), _vm._v(" "), _c('div', [!_vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n            Select\n          ")]) : _vm._e(), _vm._v(" "), _vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n            Cancel\n          ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'sm:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, _vm._l(_vm.churchMedia, function (item) {
    return _c('item-component', {
      key: "all-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      }
    });
  }), 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    staticClass: "tm-mt-4",
    attrs: {
      "spinner": "spiral"
    },
    on: {
      "infinite": _vm.handleInfiniteLoading
    }
  }, [_c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("No more media to load")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_c('empty-state')], 1)])], 1)]), _vm._v(" "), _c('remove-item-modal'), _vm._v(" "), _c('restore-item-modal'), _vm._v(" "), _c('delete-items-modal'), _vm._v(" "), _c('restore-items-modal')], 1);
};

var __vue_staticRenderFns__$11 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-hidden sm:tm-block"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base"
  }, [_vm._v("Deleted Items")])]);
}];
/* style */

const __vue_inject_styles__$11 = undefined;
/* scoped */

const __vue_scope_id__$11 = undefined;
/* module identifier */

const __vue_module_identifier__$11 = undefined;
/* functional template */

const __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$11 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);

//
var script$12 = {
  name: 'CollectionComponent',
  props: {
    collection: Object
  },
  components: {
    DotsHorizontalIcon: __vue_component__$3,
    CheckboxIcon: __vue_component__$8,
    TithelyFileTypePreview: __vue_component__$U,
    FavoriteComponent: __vue_component__$C
  }
};

/* script */
const __vue_script__$12 = script$12;
/* template */

var __vue_render__$12 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative tm-group",
    on: {
      "click": function ($event) {
        return _vm.$emit('click', _vm.collection.uuid);
      }
    }
  }, [_c('div', {
    staticClass: "tm-relative tm-pb-full tm-rounded-lg tm-overflow-hidden tm-cursor-pointer"
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-z-10 tm-transition-all tm-duration-200",
    class: _vm.isSelected || _vm.isPreviewing ? 'tm-bg-opacity-20' : 'tm-bg-opacity-0'
  }, [_c('img', {
    staticClass: "tm-h-full tm-rounded-lg tm-object-cover",
    attrs: {
      "src": _vm.collection.cover_thumb_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2"
  }, [_vm._v("\n    " + _vm._s(_vm.collection.name) + "\n  ")])]);
};

var __vue_staticRenderFns__$12 = [];
/* style */

const __vue_inject_styles__$12 = undefined;
/* scoped */

const __vue_scope_id__$12 = undefined;
/* module identifier */

const __vue_module_identifier__$12 = undefined;
/* functional template */

const __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$12 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);

//
var script$13 = {
  name: 'SermonKitComponent',
  props: {
    sermonKit: Object
  },
  components: {
    DotsHorizontalIcon: __vue_component__$3,
    CheckboxIcon: __vue_component__$8,
    TithelyFileTypePreview: __vue_component__$U,
    FavoriteComponent: __vue_component__$C
  }
};

/* script */
const __vue_script__$13 = script$13;
/* template */

var __vue_render__$13 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative tm-group",
    on: {
      "click": function ($event) {
        return _vm.$emit('click', _vm.sermonKit.uuid);
      }
    }
  }, [_c('div', {
    staticClass: "tm-relative tm-pb-full tm-rounded-lg tm-overflow-hidden tm-cursor-pointer"
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-z-10 tm-transition-all tm-duration-200",
    class: _vm.isSelected || _vm.isPreviewing ? 'tm-bg-opacity-20' : 'tm-bg-opacity-0'
  }, [_c('img', {
    staticClass: "tm-h-full tm-rounded-lg tm-object-cover",
    attrs: {
      "src": _vm.sermonKit.cover_thumb_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tm-text-xs tm-text-yank tm-text-center tm-mt-2"
  }, [_vm._v("\n    " + _vm._s(_vm.sermonKit.name) + "\n  ")])]);
};

var __vue_staticRenderFns__$13 = [];
/* style */

const __vue_inject_styles__$13 = undefined;
/* scoped */

const __vue_scope_id__$13 = undefined;
/* module identifier */

const __vue_module_identifier__$13 = undefined;
/* functional template */

const __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$13 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);

//
var script$14 = {
  name: 'MediaTypeSelector',
  props: {
    value: String,
    allowedTypes: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SelectorIcon: __vue_component__$l
  },

  data() {
    return {
      mediaType: this.value || null,
      types: [{
        value: 'photo',
        label: 'Photos'
      }, {
        value: 'social-media',
        label: 'Social Media'
      }, {
        value: 'graphic',
        label: 'Graphics'
      }, {
        value: 'video',
        label: 'Videos'
      }, {
        value: 'collections',
        label: 'Collections'
      }, {
        value: 'sermon-kits',
        label: 'Sermon Kits'
      }]
    };
  },

  computed: {
    computedTypes() {
      if (!this.allowedTypes.length) {
        return this.types;
      }

      return this.types.filter(type => {
        return this.allowedTypes.includes(type.value);
      });
    }

  },
  methods: {
    updateSelected() {
      this.$emit('input', this.mediaType);
      this.$emit('change', this.mediaType);
    }

  }
};

/* script */
const __vue_script__$14 = script$14;
/* template */

var __vue_render__$14 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-relative"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mediaType,
      expression: "mediaType"
    }],
    staticClass: "tm-border tm-block tm-w-full tm-pl-3 tm-pr-7 tm-h-9 tm-text-xs tm-border-payne focus:tm-outline-none focus:tm-border-payneFire tm-rounded-lg tm-appearance-none tm-text-payneFire",
    attrs: {
      "id": "media_type",
      "name": "media_type"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.mediaType = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.updateSelected]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("All Media")]), _vm._v(" "), _vm._l(_vm.computedTypes, function (type) {
    return _c('option', {
      key: type.value,
      domProps: {
        "value": type.value
      }
    }, [_vm._v(_vm._s(type.label))]);
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "tm-absolute tm-inset-y-0 tm-right-0 tm-flex tm-items-center tm-pr-2 tm-pointer-events-none"
  }, [_c('selector-icon', {
    staticClass: "tm-h-4 tm-w-4 tm-text-payneFire"
  })], 1)]);
};

var __vue_staticRenderFns__$14 = [];
/* style */

const __vue_inject_styles__$14 = undefined;
/* scoped */

const __vue_scope_id__$14 = undefined;
/* module identifier */

const __vue_module_identifier__$14 = undefined;
/* functional template */

const __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$14 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);

//
var script$15 = {
  name: 'SearchTiyhelyMedia',
  props: ['query', 'mediaTypeProp'],
  components: {
    InfiniteLoading,
    SearchInput: __vue_component__$N,
    ItemComponent: __vue_component__$V,
    MediaTypeSelector: __vue_component__$14,
    ArrowLeftIcon: __vue_component__$f
  },

  data() {
    return {
      page: 1,
      mediaType: this.mediaTypeProp,
      searchItems: []
    };
  },

  computed: {
    hasPreview() {
      return this.$parent.hasPreview;
    },

    mediaTypes() {
      return this.$parent.mediaTypes;
    },

    selectingItems() {
      return this.$parent.selectingItems;
    },

    namespace() {
      return this.$parent.namespace;
    },

    selectedItems() {
      return this.$parent.selectedItems;
    }

  },
  watch: {
    query(query) {
      if (!query.length) {
        return;
      }

      this.searchItems = [];
      this.page = 1;
      this.$refs.infiniteLoader.stateChanger.reset();
    },

    mediaType(mediaType) {
      this.page = 1;
      this.searchItems = [];
      this.$refs.infiniteLoader.stateChanger.reset();
    }

  },
  methods: {
    isSelected(item) {
      let findItem = this.$parent.selectedItems.find(i => i.type == item.type && i.uuid == item.uuid);
      return typeof findItem != 'undefined';
    },

    handleSearch(query) {
      this.$emit('search', query);
    },

    fetchSearchResults() {
      return api.get('/media/search', {
        params: {
          per_page: 24,
          page: this.page,
          'filter[search]': this.query,
          'filter[type]': this.mediaType || this.mediaTypes.join(',')
        }
      });
    },

    fetchFirstResults($state) {
      this.page = 1;
      this.searchItems = [];
      this.fetchSearchResults().then(({
        data
      }) => {
        this.searchItems.push(...data.data);

        if (data.meta.current_page < data.meta.last_page) {
          $state.loaded();
          this.page++;
          return;
        }

        $state.complete();
      });
    },

    loadMore($state) {
      if (!this.searchItems.length) {
        this.fetchFirstResults($state);
        return;
      }

      this.fetchSearchResults().then(({
        data
      }) => {
        this.searchItems.push(...data.data);

        if (data.meta.current_page < data.meta.last_page) {
          this.page++;
          $state.loaded();
          return;
        }

        $state.complete();
      });
    },

    toggleSelect() {
      eventBus.emit(this.namespace, 'toggle-selecting-items');
    }

  }
};

/* script */
const __vue_script__$15 = script$15;
/* template */

var __vue_render__$15 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('section', [_c('div', {
    staticClass: "tm-space-y-4"
  }, [_c('div', [_c('button', {
    staticClass: "tm-flex tm-items-center tm-text-sm tm-text-carolina sm:tm-text-yankFire focus:tm-outline-none focus:tm-ring focus:tm-ring-yankFire tm-rounded  tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.handleSearch('');
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-5 tm-h-5 tm--ml-2 tm-opacity-80"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-1"
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-items-center tm-space-x-2 sm:tm-space-x-4"
  }, [_c('search-input', {
    staticClass: "sm:tm-max-w-2xs tm-w-full",
    attrs: {
      "placeholder": "Search Tithe.ly Media",
      "query": _vm.query
    },
    on: {
      "search": _vm.handleSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-relative tm-w-48 sm:tm-w-auto"
  }, [_c('media-type-selector', {
    attrs: {
      "allowed-types": _vm.mediaTypes
    },
    model: {
      value: _vm.mediaType,
      callback: function ($$v) {
        _vm.mediaType = $$v;
      },
      expression: "mediaType"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-results-items tm-mt-6"
  }, [_c('div', {
    staticClass: "tm-flex tm-justify-between tm-items-center"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base"
  }, [_vm._v("Search results for "), _c('em', [_vm._v("\"" + _vm._s(_vm.query) + "\"")])]), _vm._v(" "), _c('div', {
    staticClass: "sm:tm-hidden"
  }, [!_vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Select\n        ")]) : _vm._e(), _vm._v(" "), _vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n          Cancel\n        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'lg:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, _vm._l(_vm.searchItems, function (item) {
    return _c('item-component', {
      key: "all-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      }
    });
  }), 1), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    staticClass: "tm-mt-4",
    attrs: {
      "spinner": "spiral"
    },
    on: {
      "infinite": _vm.loadMore
    }
  }, [_c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("No more media to load")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("No more media to load")])])], 1)]);
};

var __vue_staticRenderFns__$15 = [];
/* style */

const __vue_inject_styles__$15 = undefined;
/* scoped */

const __vue_scope_id__$15 = undefined;
/* module identifier */

const __vue_module_identifier__$15 = undefined;
/* functional template */

const __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$15 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);

//
var script$16 = {
  name: "TithelyItemsSection",
  components: {
    InfiniteLoading,
    ItemComponent: __vue_component__$V,
    CollectionComponent: __vue_component__$12,
    SermonKitComponent: __vue_component__$13,
    SearchIcon: __vue_component__$1,
    ArrowLeftIcon: __vue_component__$f,
    SearchTithelyMedia: __vue_component__$15,
    SearchInput: __vue_component__$N,
    MediaTypeSelector: __vue_component__$14,
    MobileFileSelectLimitMessage: __vue_component__$E
  },

  data() {
    return {
      searchQuery: "",
      page: 1,
      media: [],
      collections: [],
      sermonKits: [],
      mediaType: null,
      showingCollectionItems: false,
      showingSermonKitItems: false
    };
  },

  watch: {
    mediaType(mediaType) {
      this.page = 1;
      this.media = [];
      this.collections = [];
      this.sermonKits = [];
      this.$refs.infiniteLoader.stateChanger.reset();
    }

  },
  computed: {
    productId() {
      return this.$parent.$parent.productId;
    },

    selectedItems() {
      return this.$parent.$parent.selectedItems;
    },

    selectingItems() {
      return this.$parent.$parent.selectingItems;
    },

    itemPreview() {
      return this.$parent.$parent.itemPreview;
    },

    hasPreview() {
      return this.selectedItems.length > 1 || !!this.itemPreview;
    },

    mediaTypes() {
      return this.$parent.$parent.computedTypes;
    },

    namespace() {
      return this.$parent.$parent.namespace;
    },

    selectLimit() {
      return this.$parent.$parent.selectLimit;
    },

    blockedExtensions() {
      return this.$parent.$parent.blockedExtensions;
    }

  },
  methods: {
    handleSearch(query) {
      this.searchQuery = query;
    },

    isWebP(item) {
      if (!item) {
        return false;
      }

      if (item.type === "folder") {
        return false;
      }

      if (item.files && item.files.length > 0) {
        return item.files[0].mime_type === "image/webp";
      }
    },

    toggleSelect() {
      eventBus.emit(this.namespace, "toggle-selecting-items");
    },

    isSelected(item) {
      let findItem = this.selectedItems.find(i => i.type == item.type && i.uuid == item.uuid);
      return typeof findItem != "undefined";
    },

    handleInfiniteLoading($state) {
      this.fetchTithelyMedia().then(hasMore => {
        if (hasMore) {
          $state.loaded();
          return;
        }

        $state.complete();
      });
    },

    fetchTithelyMedia() {
      if (this.mediaType === "collections") {
        return api.get("/media/collections", {
          params: {
            per_page: 24,
            page: this.page,
            "filter[type]": this.mediaType || this.mediaTypes.join(",")
          }
        }).then(({
          data
        }) => {
          return this.setFilteredElements("collections", data);
        });
      } else if (this.mediaType === "sermon-kits") {
        return api.get("/media/sermon-kits", {
          params: {
            per_page: 24,
            page: this.page,
            "filter[type]": this.mediaType || this.mediaTypes.join(",")
          }
        }).then(({
          data
        }) => {
          return this.setFilteredElements("sermonKits", data);
        });
      }

      return api.get("/media/items", {
        params: {
          per_page: 24,
          page: this.page,
          "filter[type]": this.mediaType || this.mediaTypes.join(",")
        }
      }).then(({
        data
      }) => {
        return this.setFilteredElements("media", data);
      });
    },

    setFilteredElements(source, data) {
      if (source === 'media') {
        this[source].push(...this.removeFilesWithBlockedExtensions(data.data));
      } else {
        this[source].push(...data.data);
      }

      if (data.meta.current_page < data.meta.last_page) {
        this.page++;
      }

      return Promise.resolve(data.meta.current_page < data.meta.last_page);
    },

    removeFilesWithBlockedExtensions(items) {
      return items.map(item => {
        item.files = item.files.filter(file => {
          let extension = file.url.split(".").pop();
          return !this.blockedExtensions.includes(extension);
        });
        return item;
      }).filter(item => !!item.files.length);
    },

    onCollectionClick(collectionUuid) {
      api.get(`/media/collections/${collectionUuid}`).then(({
        data
      }) => {
        this.showingCollectionItems = true;
        this.media = data.items;
      });
    },

    onSermonKitClick(sermonKitUuid) {
      api.get(`/media/sermon-kits/${sermonKitUuid}`).then(({
        data
      }) => {
        this.showingSermonKitItems = true;
        this.media = data.items;
      });
    }

  }
};

/* script */
const __vue_script__$16 = script$16;
/* template */

var __vue_render__$16 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-flex-1 tm-overflow-y-scroll tm-p-6 tm-pr-4 tm-space-y-6"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "mode": "out-in"
    }
  }, [_vm.searchQuery != '' ? [_c('search-tithely-media', {
    attrs: {
      "query": _vm.searchQuery,
      "media-type-prop": _vm.mediaType
    },
    on: {
      "search": _vm.handleSearch
    }
  })] : [_c('section', [_c('div', {
    staticClass: "tm-flex tm-items-center tm-space-x-2 sm:tm-space-x-4"
  }, [_c('search-input', {
    staticClass: "sm:tm-max-w-2xs tm-w-full",
    attrs: {
      "placeholder": "Search Tithe.ly Media",
      "query": _vm.searchQuery
    },
    on: {
      "search": _vm.handleSearch
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tm-w-48 sm:tm-w-auto"
  }, [_c('media-type-selector', {
    attrs: {
      "allowed-types": _vm.mediaTypes
    },
    model: {
      value: _vm.mediaType,
      callback: function ($$v) {
        _vm.mediaType = $$v;
      },
      expression: "mediaType"
    }
  })], 1)], 1), _vm._v(" "), _vm.showingCollectionItems || _vm.showingSermonKitItems ? _c('div', {
    staticClass: "w-full tm-mt-6 tm-flex"
  }, [_c('div', {
    staticClass: "tm-cursor-pointer",
    on: {
      "click": function ($event) {
        _vm.showingSermonKitItems = false;
        _vm.showingCollectionItems = false;
        _vm.media = [];
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-5 tm-h-5"
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "all-items tm-mt-6"
  }, [_c('div', {
    staticClass: "sm:tm-hidden tm-flex tm-justify-between tm-items-center"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base"
  }, [_vm._v("\n              All Files\n            ")]), _vm._v(" "), _c('div', [!_vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n                Select\n              ")]) : _vm._e(), _vm._v(" "), _vm.selectingItems ? _c('button', {
    staticClass: "tm-text-sm tm-font-semibold tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-p-1 tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleSelect($event);
      }
    }
  }, [_vm._v("\n                Cancel\n              ")]) : _vm._e()])]), _vm._v(" "), _vm.selectingItems && _vm.selectLimit ? _c('div', [_c('mobile-file-select-limit-message', {
    attrs: {
      "select-limit": _vm.selectLimit
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tm-grid tm-gap-x-4 tm-gap-y-6 tm-mt-3 tm-grid-cols-3",
    class: _vm.hasPreview ? 'sm:tm-grid-cols-4' : 'sm:tm-grid-cols-6'
  }, [_vm._l(_vm.media, function (item) {
    return _c('item-component', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isWebP(item),
        expression: "!isWebP(item)"
      }],
      key: "all-" + item.type + "-" + item.uuid,
      attrs: {
        "selected": _vm.isSelected(item),
        "item": item
      }
    });
  }), _vm._v(" "), _vm._l(_vm.collections, function (collection) {
    return _c('collection-component', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isWebP(collection) && !_vm.showingCollectionItems,
        expression: "!isWebP(collection) && !showingCollectionItems"
      }],
      key: "all-collection-" + collection.uuid,
      attrs: {
        "collection": collection
      },
      on: {
        "click": _vm.onCollectionClick
      }
    });
  }), _vm._v(" "), _vm._l(_vm.sermonKits, function (sermonKit) {
    return _c('sermon-kit-component', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isWebP(sermonKit) && !_vm.showingSermonKitItems,
        expression: "!isWebP(sermonKit) && !showingSermonKitItems"
      }],
      key: "all-collection-" + sermonKit.uuid,
      attrs: {
        "sermon-kit": sermonKit
      },
      on: {
        "click": _vm.onSermonKitClick
      }
    });
  })], 2), _vm._v(" "), _c('infinite-loading', {
    ref: "infiniteLoader",
    staticClass: "tm-mt-4",
    attrs: {
      "spinner": "spiral"
    },
    on: {
      "infinite": _vm.handleInfiniteLoading
    }
  }, [_c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("\n              No more media to load\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-8 tm-text-sm tm-font-medium tm-text-payneFire",
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("\n              No more media to load\n            ")])])], 1)])]], 2)], 1);
};

var __vue_staticRenderFns__$16 = [];
/* style */

const __vue_inject_styles__$16 = undefined;
/* scoped */

const __vue_scope_id__$16 = undefined;
/* module identifier */

const __vue_module_identifier__$16 = undefined;
/* functional template */

const __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$16 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);

//
var script$17 = {
  name: 'FileExplorer',
  components: {
    YourMediaSection: __vue_component__$R,
    TithelyMediaSection: __vue_component__$16,
    FavoriteMediaSection: __vue_component__$W,
    DeletedItemsSection: __vue_component__$11
  },
  computed: {
    activeView() {
      return this.$parent.activeView;
    },

    selectedItems() {
      return this.$parent.selectedItems;
    }

  }
};

/* script */
const __vue_script__$17 = script$17;
/* template */

var __vue_render__$17 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-flex-1 tm-flex tm-overflow-hidden tm-transition-all tm-duration-500"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "mode": "out-in"
    }
  }, [_vm.activeView == 'my-media' ? [_c('your-media-section')] : _vm.activeView == 'tithely-media' ? [_c('tithely-media-section')] : _vm.activeView == 'favorites' ? [_c('favorite-media-section')] : _vm.activeView == 'deleted-items' ? [_c('deleted-items-section')] : [_c('div', {
    staticClass: "tm-flex-1 tm-p-6 tm-pr-4 tm-flex tm-items-center tm-justify-center"
  }, [_vm._v("\n        Select a media section from the menu.\n      ")])]], 2)], 1);
};

var __vue_staticRenderFns__$17 = [];
/* style */

const __vue_inject_styles__$17 = undefined;
/* scoped */

const __vue_scope_id__$17 = undefined;
/* module identifier */

const __vue_module_identifier__$17 = undefined;
/* functional template */

const __vue_is_functional_template__$17 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$17 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, undefined, undefined, undefined);

//
var script$18 = {
  name: 'ItemDropdownModal',
  components: {
    DownloadAltIcon: __vue_component__$b,
    FolderPlusAltIcon: __vue_component__$5,
    TrashAltIcon: __vue_component__$e,
    HeartAltIcon: __vue_component__$i,
    EditIcon: __vue_component__$9
  },

  data() {
    return {
      show: false,
      item: null
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!show) {
        this.item = null;
        document.removeEventListener('keydown', this.handleEscapeKey);
      } else {
        document.addEventListener('keydown', this.handleEscapeKey);
      }
    }

  },
  methods: {
    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    downloadItem() {
      eventBus.emit(this.namespace, 'download', {
        url: this.item.url,
        file_name: this.item.file_name
      });
      this.show = false;
    },

    showModeItemModal() {
      eventBus.emit(this.namespace, 'show-move-modal', this.item);
      this.show = false;
    },

    toggleFavorite() {
      api.patch(`/church-media/items/${this.item.uuid}/toggle-favorite`).then(({
        data
      }) => {
        this.show = false;
        this.item.favorited = data.favorited;

        if (!data.favorited) {
          eventBus.emit(this.namespace, 'remove-church-item-from-favorited', this.item);
        }
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
      });
    },

    showEditItemModal() {
      eventBus.emit(this.namespace, 'show-edit-item-modal', this.item);
      this.show = false;
    },

    showMoveItemModal() {
      eventBus.emit(this.namespace, 'show-move-modal', this.item);
      this.show = false;
    },

    showRemoveItemModal() {
      eventBus.emit(this.namespace, 'show-remove-item-modal', {
        item: this.item,
        force: false
      });
      this.show = false;
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-item-dropdown-modal', item => {
      this.item = item;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-item-dropdown-modal');
  }

};

/* script */
const __vue_script__$18 = script$18;
/* template */

var __vue_render__$18 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300 tm-transform",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300 tm-transform",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-w-full sm:tm-align-middle sm:tm-max-w-sm",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all tm-w-full"
  }, [_c('ul', {
    staticClass: "tm-py-1 tm-list-none tm-px-0 tm-m-0",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    }
  }, [_c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n                   Download\n                 ")], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showEditItemModal($event);
      }
    }
  }, [_c('edit-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n                   Edit\n                 ")], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showMoveItemModal($event);
      }
    }
  }, [_c('folder-plus-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n                   Move\n                 ")], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": _vm.toggleFavorite
    }
  }, [_c('heart-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v(" "), _vm.item.favorited ? _c('span', [_vm._v("Unfavorite")]) : _c('span', [_vm._v("Favorite")])], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showRemoveItemModal($event);
      }
    }
  }, [_c('trash-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n                   Delete\n                 ")], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3 tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all "
  }, [_c('button', {
    staticClass: "tm-w-full tm-h-10 tm-block tm-text-sm focus:tm-ring focus:tm-ring-yank focus:tm-ring-offset-2 tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n               Close\n             ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$18 = [];
/* style */

const __vue_inject_styles__$18 = undefined;
/* scoped */

const __vue_scope_id__$18 = undefined;
/* module identifier */

const __vue_module_identifier__$18 = undefined;
/* functional template */

const __vue_is_functional_template__$18 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$18 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, undefined, undefined, undefined);

//
var script$19 = {
  name: 'TithelyItemDropdownModal',
  components: {
    DownloadAltIcon: __vue_component__$b,
    HeartAltIcon: __vue_component__$i
  },

  data() {
    return {
      show: false,
      item: null
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  watch: {
    show(show) {
      if (!show) {
        this.item = null;
        document.removeEventListener('keydown', this.handleEscapeKey);
      } else {
        document.addEventListener('keydown', this.handleEscapeKey);
      }
    }

  },
  methods: {
    handleEscapeKey(e) {
      if (e.keyCode === 27) {
        this.show = false;
      }
    },

    downloadItem() {
      eventBus.emit(this.namespace, 'download', {
        url: this.item.url,
        file_name: this.item.file_name
      });
      this.show = false;
    },

    toggleFavorite() {
      api.patch(`/media/items/${this.item.id}/toggle-favorite`).then(({
        data
      }) => {
        this.show = false;
        this.item.favorited = data.favorited;

        if (!data.favorited) {
          eventBus.emit(this.namespace, 'remove-media-item-from-favorited', this.item);
        }
      }).catch(error => {
        eventBus.emit(this.namespace, 'toast-error', 'Server error.');
      });
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'show-tithely-item-dropdown-modal', item => {
      this.item = item;
      this.show = true;
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'show-tithely-item-dropdown-modal');
  }

};

/* script */
const __vue_script__$19 = script$19;
/* template */

var __vue_render__$19 = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.show ? _c('portal', {
    attrs: {
      "to": "modals-" + _vm.namespace
    }
  }, [_c('div', {
    staticClass: "tm-fixed tm-z-20 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-end tm-justify-center tm-min-h-screen tm-pt-4 tm-px-4 tm-pb-4 tm-text-center sm:tm-block sm:tm-p-0"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "appear": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-40"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300 tm-transform",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300 tm-transform",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "appear": ""
    }
  }, [_vm.show ? _c('div', {
    staticClass: "tm-inline-block tm-align-bottom tm-w-full sm:tm-align-middle sm:tm-max-w-sm",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all tm-w-full"
  }, [_c('ul', {
    staticClass: "tm-py-1 tm-list-none tm-px-0 tm-m-0",
    attrs: {
      "role": "menu",
      "aria-orientation": "vertical",
      "aria-labelledby": "options-menu"
    }
  }, [_c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_c('download-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v("\n                   Download\n                 ")], 1)]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "tm-group tm-w-full tm-flex tm-items-center tm-px-4 tm-py-3 tm-text-sm tm-text-yank hover:tm-bg-platinumHot hover:tm-text-gray-900 focus:tm-outline-none focus-visible:tm-ring focus-visible:tm-ring-aquamarine tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button",
      "role": "menuitem"
    },
    on: {
      "click": _vm.toggleFavorite
    }
  }, [_c('heart-alt-icon', {
    staticClass: "tm-mr-3 tm-h-3.5 tm-w-3.5 tm-text-payneHot"
  }), _vm._v(" "), _vm.item.favorited ? _c('span', [_vm._v("Unfavorite")]) : _c('span', [_vm._v("Favorite")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-3 tm-bg-white tm-rounded-lg tm-text-left tm-overflow-hidden tm-shadow-xl tm-transform tm-transition-all "
  }, [_c('button', {
    staticClass: "tm-w-full tm-h-10 tm-block tm-text-sm focus:tm-ring focus:tm-ring-yank focus:tm-ring-offset-2 tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.show = false;
      }
    }
  }, [_vm._v("\n               Close\n             ")])])]) : _vm._e()])], 1)])]) : _vm._e()], 1);
};

var __vue_staticRenderFns__$19 = [];
/* style */

const __vue_inject_styles__$19 = undefined;
/* scoped */

const __vue_scope_id__$19 = undefined;
/* module identifier */

const __vue_module_identifier__$19 = undefined;
/* functional template */

const __vue_is_functional_template__$19 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$19 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, undefined, undefined, undefined);

//
var script$1a = {
  name: 'AudioPlayer',
  props: {
    title: String,
    src: String
  },
  components: {
    PlayIcon: __vue_component__$q,
    PauseIcon: __vue_component__$r,
    VolumeUpIcon: __vue_component__$o,
    VolumeOffIcon: __vue_component__$p
  },

  data() {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      innerLoop: false,
      loaded: false,
      playing: false,
      previousVolume: 50,
      showVolume: false,
      volume: 50
    };
  },

  computed: {
    muted() {
      return this.volume / 100 === 0;
    },

    percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    }

  },
  watch: {
    playing(playing) {
      if (playing) {
        return this.$refs.audio.play();
      }

      this.$refs.audio.pause();
    },

    volume(volume) {
      this.$refs.audio.volume = volume / 100;
    }

  },
  filters: {
    convertTimeHHMMSS(val) {
      let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
      return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
    }

  },
  methods: {
    togglePlay() {
      this.playing = !this.playing;
    },

    pause() {
      this.playing = false;
    },

    play() {
      this.playing = true;
    },

    init() {
      if (this.$refs.audio.readyState < 2) {
        return;
      }

      this.loaded = true;
      this.durationSeconds = parseInt(this.$refs.audio.duration);
      this.$refs.audio.volume = this.volume / 100;
      this.playing = this.autoPlay;
    },

    toggleMute() {
      if (this.muted) {
        return this.volume = this.previousVolume;
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },

    seek(e) {
      if (!this.loaded) {
        return;
      }

      const el = e.target.getBoundingClientRect();
      const seekPos = (e.clientX - el.left) / el.width;
      this.$refs.audio.currentTime = parseInt(this.$refs.audio.duration * seekPos);
    },

    stop() {
      this.playing = false;
      this.$refs.audio.currentTime = 0;
    },

    updateProgress() {
      if (typeof this.$refs.audio == 'undefined') {
        return;
      }

      this.currentSeconds = parseInt(this.$refs.audio.currentTime);
    }

  },

  beforeDestroy() {
    this.stop();
  }

};

/* script */
const __vue_script__$1a = script$1a;
/* template */

var __vue_render__$1a = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-w-full tm-bg-white tm-rounded-lg tm-p-4 tm-shadow tm-border tm-border-platinum"
  }, [_c('div', {
    staticClass: "tm-leading-none"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base tm-max-w-full tm-overflow-hidden",
    attrs: {
      "title": _vm.title
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "tm-text-sm tm-text-payneFire tm-mt-1"
  }, [_vm._v("Audio Preview")])]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-mt-2 tm-justify-between tm-items-center"
  }, [_c('div', [_c('button', {
    staticClass: "tm-rounded-full tm-flex tm-items-center tm-justify-center tm-text-yank focus:tm-outline-none focus:tm-ring focus:tm-ring-carolina tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.togglePlay($event);
      }
    }
  }, [!_vm.playing ? _c('play-icon', {
    staticClass: "tm-h-14"
  }) : _c('pause-icon', {
    staticClass: "tm-h-14"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-ml-4 tm-items-center tm-space-x-2 tm-w-full"
  }, [_c('button', {
    staticClass: "tm-rounded-full tm-flex tm-items-center tm-justify-center tm-text-yank focus:tm-outline-none focus:tm-ring focus:tm-ring-offset-2 focus:tm-ring-carolina tm-bg-transparent",
    attrs: {
      "title": "Mute"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleMute($event);
      }
    }
  }, [_vm.muted ? _c('volume-off-icon', {
    staticClass: "tm-h-5"
  }) : _c('volume-up-icon', {
    staticClass: "tm-h-5"
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "tm-flex-1 tm-flex tm-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: _vm.volume,
      expression: "volume",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    staticClass: "tm-w-full",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": _vm.volume
    },
    on: {
      "change": function ($event) {
        _vm.volume = _vm._n($event.target.value);
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-2"
  }, [_c('div', {
    staticClass: "player-time tm-flex tm-space-x-2 tm-text-xs tm-text-cosmos tm-font-medium"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("convertTimeHHMMSS")(this.currentSeconds)))]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("convertTimeHHMMSS")(this.durationSeconds)))])]), _vm._v(" "), _c('div', {
    staticClass: "player-progress tm-cursor-pointer tm-relative tm-h-2 tm-bg-platinum tm-rounded-full tm-overflow-hidden",
    attrs: {
      "title": "Seek"
    },
    on: {
      "click": _vm.seek
    }
  }, [_c('div', {
    staticClass: "player-seeker tm-absolute tm-inset-y-0 tm-bg-aquamarine tm-transition-all tm-duration-100",
    style: {
      width: this.percentComplete + '%'
    }
  })])]), _vm._v(" "), _c('audio', {
    ref: "audio",
    staticClass: "tm-hidden",
    attrs: {
      "src": _vm.src,
      "preload": "auto"
    },
    on: {
      "timeupdate": _vm.updateProgress,
      "loadeddata": _vm.init,
      "pause": function ($event) {
        _vm.playing = false;
      },
      "play": function ($event) {
        _vm.playing = true;
      }
    }
  })]);
};

var __vue_staticRenderFns__$1a = [];
/* style */

const __vue_inject_styles__$1a = undefined;
/* scoped */

const __vue_scope_id__$1a = undefined;
/* module identifier */

const __vue_module_identifier__$1a = undefined;
/* functional template */

const __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);

//
var script$1b = {
  name: 'ItemPreview',
  components: {
    Flickity,
    DotsHorizontalIcon: __vue_component__$3,
    XIcon: __vue_component__$a,
    ArrowLeftIcon: __vue_component__$f,
    ArrowRightIcon: __vue_component__$g,
    FileTypePreview: __vue_component__$A,
    TithelyFileTypePreview: __vue_component__$U,
    ItemDropdownModal: __vue_component__$18,
    TithelyItemDropdownModal: __vue_component__$19,
    AudioPlayer: __vue_component__$1a
  },

  data() {
    return {
      previewAsset: null,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        freeScroll: false,
        wrapAround: false,
        contain: true,
        imagesLoaded: true,
        percentPosition: false
      },
      currentSlide: 1,
      totalSlides: 1
    };
  },

  watch: {
    item(item) {
      this.currentSlide = 1;

      if (typeof this.$refs.flickity == 'undefined') {
        return;
      }

      this.$refs.flickity.destroy();
      setTimeout(() => {
        this.$refs.flickity.reloadCells();
        this.$refs.flickity.rerender();
        this.totalSlides = this.$refs.flickity.cells().length;
      }, 500);
    }

  },
  computed: {
    namespace() {
      return this.$parent.namespace;
    },

    isSelected() {
      let findItem = this.selectedItems.find(i => i.type == this.item.type && i.uuid == this.item.uuid);
      return typeof findItem != 'undefined';
    },

    selectedItems() {
      return this.$parent.selectedItems;
    },

    item() {
      return this.$parent.selectedItems[0];
    },

    videoPreview() {
      if (!this.item.files) {
        return this.item.mime_type.startsWith('video/') ? this.item : null;
      }

      let preview = this.item.files.find(file => file.mime_type.startsWith('video/'));
      return typeof preview != 'undefined' ? preview : null;
    },

    audioPreview() {
      if (!this.item.files) {
        return this.item.mime_type.startsWith('audio/') ? this.item : null;
      }

      let preview = this.item.files.find(file => file.mime_type.startsWith('audio/'));
      return typeof preview != 'undefined' ? preview : null;
    },

    blockedExtensions() {
      return this.$parent.blockedExtensions;
    },

    validFiles() {
      if (!this.item.files) {
        return [];
      }

      if (!this.item.files.length) {
        return [];
      }

      return this.item.files.filter(file => {
        let extension = file.url.split('.').pop();
        return !this.blockedExtensions.includes(extension);
      });
    }

  },
  methods: {
    closeItemPreview() {
      eventBus.emit(this.namespace, 'clear-item-preview');
    },

    enableEditing() {//
    },

    videoPlayerUrl(url, posterUrl) {
      let videoUrl = encodeURIComponent(url);
      let coverUrl = encodeURIComponent(posterUrl);
      return `https://onelineplayer.com/player.html?autoplay=false&autopause=false&muted=false&loop=false&url=${videoUrl}&poster=${coverUrl}&time=true&progressBar=true&overlay=true&muteButton=true&fullscreenButton=true&style=light&quality=1080p&playButton=true`;
    },

    setSlides(flickity) {
      this.totalSlides = flickity.cells.length;
    },

    prev() {
      this.$refs.flickity.previous();
    },

    next() {
      this.$refs.flickity.next();
    },

    initFlickity(flickity) {
      this.setSlides(flickity);
      this.$refs.flickity.on('change', this.handleSlideChange); // fix for flickity components overlapping when directly loading page

      setTimeout(() => {
        this.$refs.flickity.resize();
      }, 500);
    },

    handleSlideChange(index) {
      this.currentSlide = index + 1;

      if (index == 0) {
        return;
      }

      if (typeof this.$refs.audioPlayer != 'undefined') {
        this.$refs.audioPlayer.pause();
      }

      if (typeof this.$refs.videoIframe != 'undefined') {
        setTimeout(() => {
          this.$refs.videoIframe.src = '';
          this.$refs.videoIframe.src = this.videoPlayerUrl(this.videoPreview.url, this.item.previews[0]);
        }, 350);
      }
    },

    downloadItem() {
      if (this.item.files && this.item.files.length) {
        eventBus.emit(this.namespace, 'download', {
          url: `/download/item/${this.item.uuid}`,
          file_name: `${this.item.slug}.zip`,
          withAxios: true
        });
      } else {
        eventBus.emit(this.namespace, 'download', {
          url: this.item.url,
          file_name: this.item.file_name
        });
      }
    },

    toggleMediaSelect() {
      let index = this.selectedItems.findIndex(media => media == this.item);

      if (index === -1) {
        eventBus.emit(this.namespace, 'select-item', this.item);
        return;
      }

      eventBus.emit(this.namespace, 'remove-item', index);
    },

    showItemDropdownModal() {
      eventBus.emit(this.namespace, 'show-item-dropdown-modal', this.item);
    },

    showTithelyItemDropdownModal() {
      eventBus.emit(this.namespace, 'show-tithely-item-dropdown-modal', this.item);
    }

  },

  mounted() {
    if (this.item.previews) {
      this.previewAsset = this.item.previews[0];
    } else {
      this.previewAsset = this.item.url;
    }
  },

  beforeDestroy() {
    if (this.$refs.flickity) {
      this.$refs.flickity.off('change', this.handleSlideChange);
    }
  }

};

/* script */
const __vue_script__$1b = script$1b;
/* template */

var __vue_render__$1b = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-w-full tm-h-full tm-absolute tm-inset-0 sm:tm-relative sm:tm-w-64 sm:tm-flex-shrink-0 sm:tm-pr-6 sm:tm-pl-4 tm-overflow-y-hidden sm:tm-py-6 tm-bg-white sm:tm-bg-transparent tm-z-30 tm-overflow-x-hidden"
  }, [_c('div', {
    staticClass: "tm-bg-white tm-h-full tm-relative sm:tm-bg-transparent tm-z-20 tm-p-4 sm:tm-p-0"
  }, [_c('div', {
    staticClass: "sm:tm-hidden tm-mb-6 tm-mt-4"
  }, [_c('button', {
    staticClass: "tm-flex tm-items-center tm-font-medium tm-text-sm tm-text-carolina tm-bg-transparent focus:tm-outline-none focus:tm-ring focus:tm-ring-yankFire tm-rounded",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.closeItemPreview($event);
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-5 tm-h-5 tm--ml-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-1"
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-justify-between tm-items-center tm-space-x-4"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-center tm-space-x-2 sm:tm-hidden"
  }, [_vm.item.files ? [_c('button', {
    staticClass: "tm-h-9 tm-w-9 tm-p-0 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center tm-justify-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showTithelyItemDropdownModal($event);
      }
    }
  }, [_c('DotsHorizontalIcon', {
    staticClass: "tm-h-4 tm-text-payneFire"
  })], 1)] : [_c('button', {
    staticClass: "tm-h-9 tm-w-9 tm-p-0 tm-border tm-rounded-lg tm-bg-white tm-border-payne tm-text-yankFire tm-text-xs focus:tm-outline-none focus:tm-border-payneFire tm-px-2 tm-flex tm-items-center tm-justify-center hover:tm-bg-gray-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.showItemDropdownModal($event);
      }
    }
  }, [_c('DotsHorizontalIcon', {
    staticClass: "tm-h-4 tm-text-payneFire"
  })], 1)]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "media-preview tm-relative tm-w-full tm-mt-4"
  }, [_c('div', {
    staticClass: "tm-hidden sm:tm-block tm-absolute tm-right-3 tm-top-3 tm-z-20"
  }, [_c('button', {
    staticClass: "tm-flex tm-p-0 tm-bg-white tm-h-5 tm-w-5 tm-border tm-border-payneHot tm-rounded tm-items-center tm-justify-center hover:tm-bg-gray-100 focus:tm-outline-none focus:tm-border-payneFire",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.closeItemPreview($event);
      }
    }
  }, [_c('XIcon', {
    staticClass: "tm-h-2 tm-text-payneHot"
  })], 1)]), _vm._v(" "), _vm.item.previews && _vm.item.previews.length ? [_c('flickity', {
    ref: "flickity",
    attrs: {
      "options": _vm.flickityOptions
    },
    on: {
      "init": _vm.initFlickity
    }
  }, [_vm.videoPreview ? [_c('div', {
    key: "cell-video-" + _vm.item.uuid,
    staticClass: "media-carousel-cell tm-w-full tm-h-64 tm-relative tm-overflow-hidden tm-rounded-md",
    staticStyle: {
      "padding-top": "56.25%"
    }
  }, [_c('iframe', {
    ref: "videoIframe",
    staticClass: "tm-absolute tm-inset-0 tm-w-full tm-h-full",
    attrs: {
      "frameborder": "0",
      "scrolling": "no",
      "allow": "autoplay;fullscreen",
      "src": _vm.videoPlayerUrl(_vm.videoPreview.url, _vm.item.previews[0])
    }
  })])] : _vm._e(), _vm._v(" "), _vm.audioPreview ? [_c('div', {
    key: "cell-video-" + _vm.item.uuid,
    staticClass: "media-carousel-cell tm-w-full tm-h-64 tm-relative tm-overflow-hidden tm-rounded-md"
  }, [_c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "title": _vm.audioPreview.name,
      "src": _vm.audioPreview.url
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm._l(_vm.item.previews, function (image, index) {
    return _c('div', {
      key: "image-" + _vm.item.uuid + "-" + index,
      staticClass: "media-carousel-cell tm-cursor-pointer tm-w-full tm-h-64 tm-rounded-md tm-overflow-hidden"
    }, [_c('img', {
      staticClass: "tm-w-full tm-h-64 tm-object-cover",
      attrs: {
        "src": image,
        "alt": _vm.item.name
      }
    })]);
  })], 2)] : [_vm.videoPreview ? [_c('div', {
    staticClass: "tm-w-full tm-relative tm-overflow-hidden tm-rounded-md",
    staticStyle: {
      "padding-top": "56.25%"
    }
  }, [_c('iframe', {
    ref: "videoIframe",
    staticClass: "tm-absolute tm-inset-0 tm-w-full tm-h-full",
    attrs: {
      "frameborder": "0",
      "scrolling": "no",
      "allow": "autoplay;fullscreen",
      "src": _vm.videoPlayerUrl(_vm.videoPreview.url)
    }
  })])] : _vm.audioPreview ? [_c('div', {
    staticClass: "tm-rounded-md tm-overflow-hidden"
  }, [_c('audio-player', {
    ref: "audioPlayer",
    attrs: {
      "title": _vm.audioPreview.name,
      "src": _vm.audioPreview.url
    }
  })], 1)] : [_c('div', {
    staticClass: "tm-h-56 tm-w-56"
  }, [_c('file-type-preview', {
    attrs: {
      "item": _vm.item
    }
  })], 1)]]], 2), _vm._v(" "), _vm.item.previews && _vm.item.previews.length > 1 ? _c('div', {
    staticClass: "media-navigation tm-mt-4 tm-space-x-4 tm-flex tm-items-center tm-justify-center"
  }, [_c('button', {
    staticClass: "tm-rounded focus:tm-ring focus:tm-ring-offset-1 focus:tm-ring-aquamarine focus:tm-outline-none disabled:tm-opacity-50 tm-bg-transparent",
    attrs: {
      "type": "button",
      "disabled": _vm.currentSlide == 1
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.prev($event);
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-h-6 tm-text-cosmos tm-opacity-80"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tm-text-cosmos tm-text-sm"
  }, [_vm._v("\n        " + _vm._s(_vm.currentSlide) + " of " + _vm._s(_vm.totalSlides) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "tm-rounded focus:tm-ring focus:tm-ring-offset-1 focus:tm-ring-aquamarine focus:tm-outline-none disabled:tm-opacity-50 tm-bg-transparent",
    attrs: {
      "type": "button",
      "disabled": _vm.currentSlide == _vm.totalSlides
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.next($event);
      }
    }
  }, [_c('arrow-right-icon', {
    staticClass: "tm-h-6 tm-text-cosmos tm-opacity-80"
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-details tm-mt-4 tm-pb-20"
  }, [_c('dl', {
    staticClass: "tm-text-sm sm:tm-text-xs tm-h-full md:tm-h-32 tm-overflow-scroll tm-pb-10"
  }, [_c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n            Title\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "tm-text-yank"
  }, [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n          ")])]), _vm._v(" "), _vm.item.description ? _c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n            Description\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "tm-text-yank",
    domProps: {
      "innerHTML": _vm._s(_vm.item.description)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n            File Type\n          ")]), _vm._v(" "), _c('dd', {
    staticClass: "tm-text-yank"
  }, [_vm._v("\n            " + _vm._s(_vm.item.type) + "\n          ")])]), _vm._v(" "), _vm.validFiles.length ? [_c('div', {
    staticClass: "tm-mt-4"
  }, [_c('h4', {
    staticClass: "tm-text-yank tm-text-sm tm-font-semibold"
  }, [_vm._v("Files")]), _vm._v(" "), _vm._l(_vm.validFiles, function (file) {
    return _c('div', {
      staticClass: "tm-mb-4"
    }, [_c('div', {
      staticClass: "tm-py-2 sm:tm-py-1"
    }, [_c('dt', {
      staticClass: "tm-text-payneHot tm-font-semibold"
    }, [_vm._v("\n                  File Name\n                ")]), _vm._v(" "), _c('dd', {
      staticClass: "tm-text-yank"
    }, [_vm._v("\n                  " + _vm._s(file.name) + "\n                ")])]), _vm._v(" "), _c('div', {
      staticClass: "tm-py-2 sm:tm-py-1"
    }, [_c('dt', {
      staticClass: "tm-text-payneHot tm-font-semibold"
    }, [_vm._v("\n                  File Size\n                ")]), _vm._v(" "), _c('dd', {
      staticClass: "tm-text-yank"
    }, [_vm._v("\n                  " + _vm._s(file.size) + "\n                ")])]), _vm._v(" "), file.dimensions ? _c('div', {
      staticClass: "tm-py-2 sm:tm-py-1"
    }, [_c('dt', {
      staticClass: "tm-text-payneHot tm-font-semibold"
    }, [_vm._v("\n                  Dimensions\n                ")]), _vm._v(" "), _c('dd', {
      staticClass: "tm-text-yank"
    }, [_vm._v("\n                  " + _vm._s(file.dimensions.width) + "x" + _vm._s(file.dimensions.height) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "tm-py-2 sm:tm-py-2 "
    }, [_c('dt', {
      staticClass: "tm-text-payneHot tm-font-semibold"
    }, [_vm._v("\n                  Public URL\n                ")]), _vm._v(" "), _c('dd', [_c('a', {
      staticClass: "tm-text-carolina",
      attrs: {
        "href": file.url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n                    " + _vm._s(file.url) + "\n                  ")])])]), _vm._v(" "), file.transform_url ? _c('div', {
      staticClass: "tm-py-2 sm:tm-py-2 "
    }, [_c('dt', {
      staticClass: "tm-text-payneHot tm-font-semibold"
    }, [_vm._v("\n                  Transform URL\n                ")]), _vm._v(" "), _c('dd', [_c('a', {
      staticClass: "tm-text-carolina",
      attrs: {
        "href": file.transform_url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n                    " + _vm._s(file.transform_url) + "\n                  ")])])]) : _vm._e()]);
  })], 2)] : [_c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n              File Size\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "tm-text-yank"
  }, [_vm._v("\n              " + _vm._s(_vm.item.size) + "\n            ")])]), _vm._v(" "), _vm.item.dimensions ? _c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n              Dimensions\n            ")]), _vm._v(" "), _c('dd', {
    staticClass: "tm-text-yank"
  }, [_vm._v("\n              " + _vm._s(_vm.item.dimensions.width) + "x" + _vm._s(_vm.item.dimensions.height) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n              Public URL\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "tm-text-carolina",
    attrs: {
      "href": _vm.item.url,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.item.url) + "\n              ")])])]), _vm._v(" "), _vm.item.transform_url ? _c('div', {
    staticClass: "tm-py-2 sm:tm-py-2 "
  }, [_c('dt', {
    staticClass: "tm-text-payneHot tm-font-semibold"
  }, [_vm._v("\n              Transform URL\n            ")]), _vm._v(" "), _c('dd', [_c('a', {
    staticClass: "tm-text-carolina",
    attrs: {
      "href": _vm.item.transform_url,
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.item.transform_url) + "\n              ")])])]) : _vm._e()]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tm-z-20 tm-w-full tm-relative tm-bg-white sm:tm-bg-transparent tm-bottom-0 tm-left-0 tm-pb-4 tm-pt-2 tm-inset-x-0 tm-px-4 sm:tm-px-0"
  }, [_c('div', {
    staticClass: "tm-fixed tm-bottom-2 tm-w-full tm-left-0 md:tm-left-auto tm-px-5 md:tm-px-0 md:tm-w-56 tm-block tm-items-center tm-space-y-2"
  }, [_c('button', {
    staticClass: "tm-w-full tm-block tm-flex-shrink-0 tm-h-11 sm:tm-h-9 tm-border-2 tm-rounded-xl tm-text-sm sm:tm-text-xs focus:tm-outline-none tm-px-8 hover:tm-opacity-80 tm-select-none tm-bg-white tm-border-carolina tm-text-payne sm:tm-w-full",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadItem($event);
      }
    }
  }, [_vm._v("\n        Download\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "tm-w-full tm-block tm-h-11 sm:tm-h-9 tm-flex-1 tm-border tm-rounded-xl tm-text-sm sm:tm-text-xs focus:tm-outline-none tm-px-4 hover:tm-opacity-80 tm-select-none tm-bg-aquamarine tm-border-aquamarine tm-text-white sm:tm-w-full",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleMediaSelect($event);
      }
    }
  }, [_vm.isSelected ? _c('span', [_vm._v("Remove From Selection")]) : _c('span', [_vm._v("Add To Selection")])])])])]), _vm._v(" "), _c('item-dropdown-modal'), _vm._v(" "), _c('tithely-item-dropdown-modal')], 1);
};

var __vue_staticRenderFns__$1b = [];
/* style */

const __vue_inject_styles__$1b = undefined;
/* scoped */

const __vue_scope_id__$1b = undefined;
/* module identifier */

const __vue_module_identifier__$1b = undefined;
/* functional template */

const __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);

//
var script$1c = {
  name: "SelectedItemsPreview",
  components: {
    DotsHorizontalIcon: __vue_component__$3,
    FileTypePreview: __vue_component__$A,
    TithelyFileTypePreview: __vue_component__$U,
    CheckboxIcon: __vue_component__$8
  },
  computed: {
    namespace() {
      return this.$parent.namespace;
    },

    selectedItems() {
      return this.$parent.selectedItems;
    },

    previewItems() {
      return this.selectedItems.slice(-3);
    }

  },
  methods: {
    removeAllItems() {
      if (this.$parent.activeView === 'deleted-items') {
        eventBus.emit(this.namespace, "show-delete-items-modal", this.selectedItems);
      } else {
        eventBus.emit(this.namespace, "show-remove-items-modal", this.selectedItems);
      }
    },

    unselectItem(item) {
      let index = this.selectedItems.findIndex(media => media == item);
      eventBus.emit(this.namespace, "remove-item", index);
    },

    clearSelection() {
      eventBus.emit(this.namespace, "clear-item-selection");
    },

    downloadAll() {
      let time = new Date().getTime();
      eventBus.emit(this.namespace, "multiple-download", {
        params: this.prepareItems(),
        file_name: `multiple-media-${time}`
      });
    },

    prepareItems() {
      let items = {
        media: [],
        "church-media": []
      };
      this.selectedItems.forEach(item => {
        if (item.files && item.files.length) {
          items.media.push(item.uuid);
        } else if (item.type == "folder" && item.items && item.items.length) {
          let churchItems = item.items.map(churchItem => {
            return churchItem.uuid;
          });
          items["church-media"] = items["church-media"].concat(churchItems);
        } else {
          items["church-media"].push(item.uuid);
        }
      });
      return items;
    }

  }
};

/* script */
const __vue_script__$1c = script$1c;
/* template */

var __vue_render__$1c = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-w-full tm-h-full tm-absolute tm-inset-0 sm:tm-relative sm:tm-w-64 sm:tm-flex-shrink-0 sm:tm-pr-6 sm:tm-pl-4 tm-overflow-y-scroll sm:tm-py-6 tm-transform tm-translate-y-full sm:tm-translate-y-0"
  }, [_vm.selectedItems.length > 1 ? _c('div', {}, [_c('div', {
    staticClass: "tm-flex tm-justify-between"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base tm-m-0"
  }, [_vm._v("\n        Selected Items (" + _vm._s(_vm.selectedItems.length) + ")\n      ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tm-text-xs tm-text-yank tm-rounded focus:tm-outline-none focus:tm-ring-offset-2 focus-visible:tm-outline-none focus-visible:tm-ring focus:tm-ring-aquamarine tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clearSelection($event);
      }
    }
  }, [_vm._v("\n          Clear\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-4 tm-space-y-3"
  }, _vm._l(_vm.selectedItems, function (item) {
    return _c('div', {
      key: item.type + "-" + item.uuid,
      staticClass: "tm-bg-white tm-shadow-md tm-rounded-lg tm-flex tm-items-center tm-px-3 tm-py-2"
    }, [_c('div', {
      staticClass: "tm-w-5 tm-flex-shrink-0"
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.unselectItem(item);
        }
      }
    }, [_c('checkbox-icon', {
      staticClass: "tm-h-5 tm-w-5 tm-cursor-pointer",
      attrs: {
        "checked": true
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tm-flex tm-items-center tm-ml-2 tm-flex-1 tm-overflow-hidden"
    }, [_c('div', {
      staticClass: "tm-text-xs"
    }, [_c('h4', {
      staticClass: "tm-text-yank tm-font-semibold tm-m-0"
    }, [_c('span', [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]), _vm._v(" "), _c('span', {
      staticClass: "tm-font-normal tm-text-payneFire"
    }, [_vm._v("\n                " + _vm._s(item.type === "folder" ? " (" + item.items.length + " file" + (item.items.length != 1 ? "s" : "") + ")" : "") + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "tm-text-payneFire"
    }, [_vm._v("\n              " + _vm._s(item.type) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tm-relative tm-ml-2 tm-h-8 tm-w-8 tm-flex-shrink-0"
    }, [item.previews ? _c('tithely-file-type-preview', {
      attrs: {
        "item": item
      }
    }) : _c('file-type-preview', {
      attrs: {
        "item": item,
        "with-border": false
      }
    })], 1)]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "tm-mt-4 tm-space-y-2"
  }, [_c('button', {
    staticClass: "tm-block tm-flex-shrink-0 tm-h-11 sm:tm-h-9 tm-border-2 tm-rounded-xl tm-text-sm sm:tm-text-xs focus:tm-outline-none tm-px-8 hover:tm-opacity-80 tm-select-none tm-bg-white tm-border-carolina tm-text-payne sm:tm-w-full",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadAll($event);
      }
    }
  }, [_vm._v("\n        Download Selection\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "tm-block tm-flex-shrink-0 tm-h-11 sm:tm-h-9 tm-border-2 tm-rounded-xl tm-text-sm sm:tm-text-xs focus:tm-outline-none tm-px-8 hover:tm-opacity-80 tm-select-none tm-bg-red-600 tm-border-red-600 tm-text-white sm:tm-w-full",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeAllItems
    }
  }, [_vm._v("\n        Delete Selection\n      ")])])]) : _vm._e()]);
};

var __vue_staticRenderFns__$1c = [];
/* style */

const __vue_inject_styles__$1c = undefined;
/* scoped */

const __vue_scope_id__$1c = undefined;
/* module identifier */

const __vue_module_identifier__$1c = undefined;
/* functional template */

const __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);

//
var script$1d = {
  name: 'ToastNotifications',
  components: {
    ExclamationIcon: __vue_component__$j,
    CheckCircleIcon: __vue_component__$k
  },

  data() {
    return {
      notifications: []
    };
  },

  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'toast-error', message => {
      this.notifications.push({
        type: 'error',
        message: message
      });
      setTimeout(() => this.notifications.shift(), 5000);
    });
    eventBus.on(this.namespace, 'toast-success', message => {
      this.notifications.push({
        type: 'success',
        message: message
      });
      setTimeout(() => this.notifications.shift(), 5000);
    });
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'toast-error');
    eventBus.off(this.namespace, 'toast-success');
  }

};

/* script */
const __vue_script__$1d = script$1d;
/* template */

var __vue_render__$1d = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-right-5 tm-absolute tm-z-30 tm-bottom-5 tm-max-w-xs tm-w-full tm-space-y-2"
  }, [_c('transition-group', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-4",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-4"
    }
  }, [_vm._l(_vm.notifications, function (notification, index) {
    return [notification.type == 'error' ? _c('div', {
      key: "notification-" + index,
      staticClass: "tm-mt-2 sm:tm-max-w-sm tm-w-full tm-bg-white tm-shadow-lg tm-rounded-lg tm-pointer-events-auto tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-overflow-hidden"
    }, [_c('div', {
      staticClass: "tm-p-4"
    }, [_c('div', {
      staticClass: "tm-flex tm-items-start"
    }, [_c('div', {
      staticClass: "tm-flex-shrink-0"
    }, [_c('exclamation-icon', {
      staticClass: "tm-h-6 tm-w-6 tm-text-red-600"
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "tm-ml-3 tm-w-0 tm-flex-1 tm-pt-0.5"
    }, [_c('p', {
      staticClass: "tm-text-sm tm-font-medium tm-text-yank"
    }, [_vm._v("\n                " + _vm._s(notification.message) + "\n              ")])])])])]) : notification.type == 'success' ? _c('div', {
      key: "notification-" + index,
      staticClass: "tm-mt-2 sm:tm-max-w-sm tm-w-full tm-bg-white tm-shadow-lg tm-rounded-lg tm-pointer-events-auto tm-ring-1 tm-ring-black tm-ring-opacity-5 tm-overflow-hidden"
    }, [_c('div', {
      staticClass: "tm-p-4"
    }, [_c('div', {
      staticClass: "tm-flex tm-items-start"
    }, [_c('div', {
      staticClass: "tm-flex-shrink-0"
    }, [_c('check-circle-icon', {
      staticClass: "tm-h-6 tm-w-6 tm-text-aquamarine"
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "tm-ml-3 tm-w-0 tm-flex-1 tm-pt-0.5"
    }, [_c('p', {
      staticClass: "tm-text-sm tm-font-medium tm-text-yank"
    }, [_vm._v("\n                " + _vm._s(notification.message) + "\n              ")])])])])]) : _vm._e()];
  })], 2)], 1);
};

var __vue_staticRenderFns__$1d = [];
/* style */

const __vue_inject_styles__$1d = undefined;
/* scoped */

const __vue_scope_id__$1d = undefined;
/* module identifier */

const __vue_module_identifier__$1d = undefined;
/* functional template */

const __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);

//
var script$1e = {
  name: 'MobileSelectedActions',
  components: {
    ArrowLeftIcon: __vue_component__$f,
    FileTypePreview: __vue_component__$A,
    TithelyFileTypePreview: __vue_component__$U,
    CheckboxIcon: __vue_component__$8
  },

  data() {
    return {
      showSelectedPreview: false
    };
  },

  computed: {
    selectingItems() {
      return this.$parent.selectingItems;
    },

    selectedItems() {
      return this.$parent.selectedItems;
    },

    namespace() {
      return this.$parent.namespace;
    }

  },
  methods: {
    toggleSelectedPreview() {
      this.showSelectedPreview = !this.showSelectedPreview;
    },

    downloadSelectedItems() {
      let time = new Date().getTime();
      eventBus.emit(this.namespace, 'multiple-download', {
        params: this.prepareItems(),
        file_name: `multiple-media-${time}`
      });
    },

    prepareItems() {
      let items = {
        media: [],
        'church-media': []
      };
      this.selectedItems.forEach(item => {
        if (item.files && item.files.length) {
          items.media.push(item.uuid);
        } else if (item.type == 'folder' && item.items && item.items.length) {
          let churchItems = item.items.map(churchItem => {
            return churchItem.uuid;
          });
          items['church-media'] = items['church-media'].concat(churchItems);
        } else {
          items['church-media'].push(item.uuid);
        }
      });
      return items;
    },

    returnSelectedItems() {
      eventBus.emit(this.namespace, 'return-selected');
    },

    unselectItem(item) {
      let index = this.selectedItems.findIndex(media => media == item);
      eventBus.emit(this.namespace, 'remove-item', index);
    },

    clearSelection() {
      eventBus.emit(this.namespace, 'clear-item-selection');
      this.showSelectedPreview = false;
    }

  }
};

/* script */
const __vue_script__$1e = script$1e;
/* template */

var __vue_render__$1e = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_vm.selectingItems ? _c('section', {
    staticClass: "sm:tm-hidden tm-flex tm-items-center tm-justify-between tm-h-16 tm-fixed tm-bottom-0 tm-inset-x-0 tm-p-2 tm-bg-white tm-z-20 tm-border-t"
  }, [_c('button', {
    staticClass: "tm-font-semibold tm-rounded-xl tm-text-sm focus:tm-outline-none tm-px-4 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-transparent",
    class: _vm.selectedItems.length ? 'tm-text-yank' : 'tm-text-cosmosFire',
    attrs: {
      "type": "button",
      "disabled": _vm.selectedItems.length == 0
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.downloadSelectedItems($event);
      }
    }
  }, [_vm._v("\n      Download\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "tm-font-semibold tm-rounded-xl tm-text-sm focus:tm-outline-none tm-px-4 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-transparent",
    class: _vm.selectedItems.length ? 'tm-text-yank' : 'tm-text-cosmosFire',
    attrs: {
      "type": "button",
      "disabled": _vm.selectedItems.length == 0
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.returnSelectedItems($event);
      }
    }
  }, [_vm._v("\n      Select and Close\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "tm-font-semibold tm-rounded-xl tm-text-sm focus:tm-outline-none tm-px-4 tm-flex tm-items-center hover:tm-opacity-80 tm-select-none tm-bg-transparent",
    class: _vm.selectedItems.length ? 'tm-text-yank' : 'tm-text-cosmosFire',
    attrs: {
      "type": "button",
      "disabled": _vm.selectedItems.length == 0
    },
    on: {
      "click": _vm.toggleSelectedPreview
    }
  }, [_vm._v("\n      More\n    ")])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-in-out tm-duration-300 tm-transform",
      "enter-class": "tm-opacity-0 tm-translate-y-12",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0",
      "leave-active-class": "tm-ease-in-out tm-duration-300 tm-transform",
      "leave-class": "tm-opacity-100 tm-translate-y-0",
      "leave-to-class": "tm-opacity-0 tm-translate-y-12"
    }
  }, [_c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectingItems && _vm.showSelectedPreview,
      expression: "selectingItems && showSelectedPreview"
    }],
    staticClass: "tm-absolute tm-inset-0 tm-bg-white tm-z-20 tm-mb-16 tm-flex tm-flex-col tm-px-6"
  }, [_c('div', {
    staticClass: "tm-flex-shrink-0"
  }, [_c('div', {
    staticClass: "tm-mb-6 tm-mt-4"
  }, [_c('button', {
    staticClass: "tm-flex tm-items-center tm-font-medium tm-text-sm tm-text-carolina focus:tm-outline-none focus:tm-ring focus:tm-ring-yankFire tm-rounded tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        _vm.showSelectedPreview = false;
      }
    }
  }, [_c('arrow-left-icon', {
    staticClass: "tm-w-5 tm-h-5 tm--ml-2"
  }), _vm._v(" "), _c('span', {
    staticClass: "tm-ml-1"
  }, [_vm._v("Back")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex tm-justify-between"
  }, [_c('h3', {
    staticClass: "tm-text-yank tm-font-medium tm-text-base tm-m-0"
  }, [_vm._v("\n            Selected Items (" + _vm._s(_vm.selectedItems.length) + ")\n          ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "tm-text-xs tm-text-yank tm-rounded focus:tm-outline-none focus:tm-ring-offset-2 focus-visible:tm-outline-none focus-visible:tm-ring focus:tm-ring-aquamarine tm-bg-transparent",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clearSelection($event);
      }
    }
  }, [_vm._v("\n              Clear\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tm-flex-1 tm-overflow-y-scroll"
  }, [_c('div', {
    staticClass: "tm-space-y-3 tm-mt-4 tm-px-1"
  }, _vm._l(_vm.selectedItems, function (item) {
    return _c('div', {
      key: item.type + "-" + item.uuid,
      staticClass: "tm-bg-white tm-shadow-md tm-rounded-lg tm-flex tm-items-center tm-px-3 tm-py-2 tm-ring-1 tm-ring-black tm-ring-opacity-10"
    }, [_c('div', {
      staticClass: "tm-w-5 tm-flex-shrink-0"
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.unselectItem(item);
        }
      }
    }, [_c('checkbox-icon', {
      staticClass: "tm-h-5 tm-w-5 tm-cursor-pointer",
      attrs: {
        "checked": true
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "tm-flex tm-items-center tm-ml-2 tm-flex-1 tm-overflow-hidden"
    }, [_c('div', {
      staticClass: "tm-text-xs"
    }, [_c('h4', {
      staticClass: "tm-text-yank tm-font-semibold tm-text-xs tm-m-0"
    }, [_c('span', [_vm._v("\n                    " + _vm._s(item.name) + "\n                  ")]), _vm._v(" "), _c('span', {
      staticClass: "tm-font-normal tm-text-payneFire"
    }, [_vm._v("\n                    " + _vm._s(item.type === 'folder' ? " (" + item.items.length + " file" + (item.items.length != 1 ? 's' : '') + ")" : '') + "\n                  ")])]), _vm._v(" "), _c('div', {
      staticClass: "tm-text-payneFire"
    }, [_vm._v("\n                  " + _vm._s(item.type) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "tm-relative tm-ml-2 tm-h-8 tm-w-8 tm-flex-shrink-0"
    }, [item.previews ? _c('tithely-file-type-preview', {
      attrs: {
        "item": item
      }
    }) : _c('file-type-preview', {
      attrs: {
        "item": item,
        "with-border": false
      }
    })], 1)]);
  }), 0)])])])], 1);
};

var __vue_staticRenderFns__$1e = [];
/* style */

const __vue_inject_styles__$1e = undefined;
/* scoped */

const __vue_scope_id__$1e = undefined;
/* module identifier */

const __vue_module_identifier__$1e = undefined;
/* functional template */

const __vue_is_functional_template__$1e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, undefined, undefined, undefined);

//
var script$1f = {
  name: 'DownloadComponent',
  computed: {
    namespace() {
      return this.$parent.namespace;
    }

  },
  methods: {
    download(payload) {
      eventBus.emit(this.namespace, 'toast-success', 'The download will start shortly.');

      if (payload.withAxios) {
        api.get(payload.url, {
          responseType: 'blob'
        }).then(({
          data
        }) => {
          fileDownload(data, `${payload.file_name}.zip`);
        });
      } else {
        fileDownload(payload.url, payload.file_name);
      }
    },

    multipleDownload(payload) {
      eventBus.emit(this.namespace, 'toast-success', 'The download will start shortly.');
      api.get('download/multiple/all', {
        responseType: 'blob',
        params: payload.params
      }).then(({
        data
      }) => {
        fileDownload(data, `${payload.file_name}.zip`);
      });
    }

  },

  mounted() {
    eventBus.on(this.namespace, 'download', this.download);
    eventBus.on(this.namespace, 'multiple-download', this.multipleDownload);
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'download', this.download);
    eventBus.off(this.namespace, 'multiple-download', this.multipleDownload);
  }

};

/* script */
const __vue_script__$1f = script$1f;
/* template */

var __vue_render__$1f = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div');
};

var __vue_staticRenderFns__$1f = [];
/* style */

const __vue_inject_styles__$1f = undefined;
/* scoped */

const __vue_scope_id__$1f = undefined;
/* module identifier */

const __vue_module_identifier__$1f = undefined;
/* functional template */

const __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);

//
Vue.use(PortalVue);
Vue.use(SpringSpinner);
var script$1g = {
  name: 'VueTithelyMedia',
  props: {
    ssoToken: String,
    accessToken: String,
    productId: String,
    locationId: {
      type: String,
      default: ''
    },
    endpoint: {
      type: String,
      default: 'https://media.tithelyqa.com/api/v1'
    },
    mediaTypes: {
      type: Array,
      default: () => []
    },
    blockedExtensions: {
      type: Array,
      default: () => ['psd', 'ai', 'eps', 'zip']
    },
    selectLimit: Number
  },
  components: {
    MainHeader: __vue_component__$u,
    DesktopMenu: __vue_component__$v,
    FileExplorer: __vue_component__$17,
    ItemPreview: __vue_component__$1b,
    SelectedItemsPreview: __vue_component__$1c,
    SearchIcon: __vue_component__$1,
    UploadIcon: __vue_component__$2,
    DotsHorizontalIcon: __vue_component__$3,
    FolderPlusIcon: __vue_component__$4,
    MenuIcon: __vue_component__$7,
    ToastNotifications: __vue_component__$1d,
    MobileSelectedActions: __vue_component__$1e,
    DownloadComponent: __vue_component__$1f,
    MobileMenu: __vue_component__$w,
    FocusLock
  },

  data() {
    return {
      persistedAccessToken: null,
      activeView: 'my-media',
      showMediaModal: false,
      itemPreview: null,
      selectedItems: [],
      selectingItems: false,
      views: [{
        name: 'My Media',
        slug: 'my-media'
      }, {
        name: 'Tithe.ly Media',
        slug: 'tithely-media'
      }, {
        name: 'Favorites',
        slug: 'favorites'
      }, {
        name: 'Deleted Items',
        slug: 'deleted-items'
      }],
      namespace: null
    };
  },

  watch: {
    showMediaModal(showMediaModal) {
      if (!showMediaModal) {
        this.resetState();
      }
    }

  },
  computed: {
    authenticated() {
      return !!(this.accessToken || this.persistedAccessToken);
    },

    safeEndpoint() {
      return this.endpoint.replace(/\/+$/, '');
    },

    computedTypes() {
      let types = [...this.mediaTypes];

      if (types.includes('image')) {
        types.push('photo');
      }

      return types;
    }

  },
  methods: {
    toggleMediaModal() {
      if (!this.authenticated) {
        console.error('Not authenticated!');
        return;
      }

      this.showMediaModal = !this.showMediaModal;
    },

    selectedUrls() {
      let selectedUrls = [];
      this.selectedItems.forEach(item => {
        if (item.type == 'folder' && item.items.length) {
          selectedUrls = selectedUrls.concat(item.items.map(i => i.url));
        } else if (item.files && item.files.length) {
          let validFiles = item.files.filter(file => {
            let extension = file.url.split('.').pop();
            return !this.blockedExtensions.includes(extension);
          });
          selectedUrls.push(validFiles[0].url);
        } else {
          selectedUrls.push(item.url);
        }
      });
      return selectedUrls;
    },

    selectedTransformUrls() {
      let selectedTransformUrls = [];
      this.selectedItems.forEach(item => {
        if (item.type === 'folder' && item.items.length) {
          selectedTransformUrls = selectedTransformUrls.concat(item.items.map(i => i.transform_url));
        } else if (item.files && item.files.length) {
          let validFiles = item.files.filter(file => {
            let extension = file.transform_url.split('.').pop();
            return !this.blockedExtensions.includes(extension);
          });
          selectedTransformUrls.push(validFiles[0].transform_url);
        } else {
          selectedTransformUrls.push(item.transform_url);
        }
      });
      return selectedTransformUrls.filter(url => !!url);
    },

    switchView(view) {
      this.activeView = view;
    },

    resetState() {
      this.itemPreview = null;
      this.selectedItems = [];
      this.activeView = 'my-media';
      this.selectingItems = false;
    },

    getAccessToken() {
      return new Promise(resolve => {
        if (this.accessToken) {
          api.setAuthHeader(this.accessToken);
          this.persistedAccessToken = this.accessToken;
          return resolve(true);
        }

        let cookie = Cookies.get('tithely_media_auth');
        this.persistedAccessToken = typeof cookie != 'undefined' ? cookie : null;

        if (this.persistedAccessToken) {
          api.setAuthHeader(this.persistedAccessToken);
        }

        return resolve(true);
      });
    },

    authenticate() {
      if (!this.ssoToken || typeof this.ssoToken == 'undefined') {
        console.error('No SSO token provided to the Vue Tithely Media component');
        return;
      }

      api.post('/auth/sso', {
        token: this.ssoToken
      }).then(({
        data
      }) => {
        this.persistedAccessToken = data.access_token;
        api.setAuthHeader(data.access_token);
        Cookies.set('tithely_media_auth', data.access_token, {
          expires: 1,
          sameSite: 'Lax'
        });
      });
    },

    createComponentNamespace() {
      this.namespace = Math.random().toString(16).substr(2, 8);
    },

    handleSelectItem(item) {
      if (!this.selectLimit) {
        return this.selectedItems.push(item);
      }

      if (item.type == 'folder' && this.selectedItems.length + item.items.length > this.selectLimit) {
        return eventBus.emit(this.namespace, 'toast-error', 'Too many files in this folder.');
      }

      if (this.selectedItems.length + 1 > this.selectLimit) {
        return eventBus.emit(this.namespace, 'toast-error', "You've reached the file selection limit.");
      }

      this.selectedItems.push(item);
    }

  },

  created() {
    this.createComponentNamespace();
    api.setBaseUrl(this.safeEndpoint);
    this.getAccessToken().then(() => {
      if (!this.authenticated) {
        this.authenticate();
      }
    });
  },

  mounted() {
    eventBus.on(this.namespace, 'close-media-modal', () => this.showMediaModal = false);
    eventBus.on(this.namespace, 'toggle-preview', item => {
      if (this.itemPreview != item) {
        this.itemPreview = item;
      }
    });
    eventBus.on(this.namespace, 'change-view', view => {
      this.activeView = view;
      this.itemPreview = null;
    });
    eventBus.on(this.namespace, 'select-item', item => this.handleSelectItem(item));
    eventBus.on(this.namespace, 'remove-item', index => this.selectedItems.splice(index, 1));
    eventBus.on(this.namespace, 'clear-item-preview', () => this.itemPreview = null);
    eventBus.on(this.namespace, 'clear-item-selection', () => this.selectedItems = []);
    eventBus.on(this.namespace, 'return-selected', () => {
      this.$emit('selected', this.selectedUrls());
      this.$emit('selected-transform', this.selectedTransformUrls());
      this.showMediaModal = false;
      api.post('media-modal/used-items', {
        items: this.selectedItems.map(item => ({
          item_id: item.id,
          location: window.location.href,
          is_church_item: !!item.organization_id
        }))
      }).catch(error => {
        console.error(error);
      });
    });
    eventBus.on(this.namespace, 'toggle-selecting-items', () => {
      this.selectingItems = !this.selectingItems;

      if (!this.selectingItems) {
        this.selectedItems = [];
      }
    });

    if (typeof this.ssoToken == 'undefined' && typeof this.accessToken == 'undefined') {
      console.error('No SSO token or access token provided to the Vue Tithely Media component');
    }

    if (typeof this.productId == 'undefined') {
      console.error('No product id provided to the Vue Tithely Media component');
    }
  },

  beforeDestroy() {
    eventBus.off(this.namespace, 'close-media-modal');
    eventBus.off(this.namespace, 'toggle-preview');
    eventBus.off(this.namespace, 'change-view');
    eventBus.off(this.namespace, 'select-item');
    eventBus.off(this.namespace, 'remove-item');
    eventBus.off(this.namespace, 'clear-item-preview');
    eventBus.off(this.namespace, 'clear-item-selection');
    eventBus.off(this.namespace, 'return-selected');
    eventBus.off(this.namespace, 'toggle-selecting-items');
  }

};

/* script */
const __vue_script__$1g = script$1g;
/* template */

var __vue_render__$1g = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tm-media-modal font-inter tm-leading-normal tm-text-base tm-antialiased"
  }, [_c('portal-target', {
    attrs: {
      "name": "dropdown-" + _vm.namespace,
      "slim": ""
    }
  }), _vm._v(" "), _c('focus-lock', [_c('portal-target', {
    attrs: {
      "name": "modals-" + _vm.namespace,
      "slim": ""
    }
  })], 1), _vm._v(" "), _vm._t("default", [_c('button', {
    staticClass: "modal-trigger tm-bg-yankFire tm-text-white tm-px-4 tm-py-2 tm-rounded tm-shadow",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleMediaModal
    }
  }, [_vm._v("\n\t\t\tOpen Media Modal\n\t\t")])], {
    "toggle": _vm.toggleMediaModal,
    "disabled": this.authenticated
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMediaModal,
      expression: "showMediaModal"
    }],
    staticClass: "tm-fixed tm-z-10 tm-inset-0 tm-overflow-y-auto"
  }, [_c('div', {
    staticClass: "tm-flex tm-items-center tm-justify-center tm-min-h-screen tm-text-center"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMediaModal,
      expression: "showMediaModal"
    }],
    staticClass: "tm-fixed tm-inset-0 tm-transition-opacity",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.toggleMediaModal
    }
  }, [_c('div', {
    staticClass: "tm-absolute tm-inset-0 tm-bg-yank tm-opacity-90"
  })])]), _vm._v(" "), _c('span', {
    staticClass: "tm-hidden sm:tm-inline-block sm:tm-align-middle sm:tm-h-screen",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("​")]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95",
      "enter-to-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-active-class": "tm-ease-in tm-duration-300",
      "leave-class": "tm-opacity-100 tm-translate-y-0 sm:tm-scale-100",
      "leave-to-class": "tm-opacity-0 tm-translate-y-4 sm:tm-translate-y-0 sm:tm-scale-95"
    }
  }, [_vm.showMediaModal ? _c('div', {
    staticClass: "tm-h-screen tm-w-full tm-max-w-screen-lg tm-inline-block tm-bg-white sm:tm-rounded-2.5xl sm:tm-mt-4 sm:tm-mx-4 sm:tm-mb-4 tm-text-left tm-overflow-hidden sm:tm-shadow-xl tm-transform tm-transition-all sm:tm-max-h-148",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "modal-headline"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('section', {
    staticClass: "tm-flex tm-h-full"
  }, [_c('desktop-menu'), _vm._v(" "), _c('mobile-menu'), _vm._v(" "), _c('main', {
    staticClass: "tm-flex-1 tm-flex tm-flex-col"
  }, [_c('main-header', {
    attrs: {
      "selecting": _vm.selectingItems
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content tm-mt-3 sm:tm-mt-0 tm-flex tm-flex-1 tm-overflow-hidden tm-bg-white sm:tm-bg-cosmos sm:tm-bg-opacity-5"
  }, [_c('file-explorer'), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "tm-transform tm-transition tm-ease-in-out tm-duration-300 sm:tm-duration-300",
      "enter-class": "tm-translate-x-full",
      "enter-to-class": "tm-translate-x-0",
      "leave-active-class": "tm-transform tm-transition tm-ease-in-out tm-duration-75 sm:tm-duration-75",
      "leave-class": "tm-translate-x-0",
      "leave-to-class": "tm-translate-x-full"
    }
  }, [_vm.itemPreview && _vm.selectedItems.length === 1 || _vm.selectedItems.length > 1 ? [_c('transition', {
    attrs: {
      "enter-active-class": "tm-transition-opacity tm-ease-out tm-duration-300",
      "enter-class": "tm-opacity-0",
      "enter-to-class": "tm-opacity-100",
      "leave-active-class": "tm-transition-opacity tm-ease-in tm-duration-100",
      "leave-class": "tm-opacity-100",
      "leave-to-class": "tm-opacity-0",
      "mode": "out-in"
    }
  }, [_vm.itemPreview && _vm.selectedItems.length === 1 ? _c('item-preview') : _c('selected-items-preview')], 1)] : _vm._e()], 2)], 1), _vm._v(" "), _c('mobile-selected-actions'), _vm._v(" "), _c('toast-notifications')], 1)], 1)]) : _vm._e()])], 1)]), _vm._v(" "), _c('download-component')], 2);
};

var __vue_staticRenderFns__$1g = [];
/* style */

const __vue_inject_styles__$1g = undefined;
/* scoped */

const __vue_scope_id__$1g = undefined;
/* module identifier */

const __vue_module_identifier__$1g = undefined;
/* functional template */

const __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);

// Import vue component

const install = function installVueTithelyMedia(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueTithelyMedia', __vue_component__$1g);
}; // Create module definition for Vue.use()


const plugin = {
  install
}; // To auto-install on non-es builds, when vue is found
// eslint-disable-next-line no-redeclare

/* global window, global */

if ('false' === "true") {
  let GlobalVue = null;

  if (typeof window !== 'undefined') {
    GlobalVue = window.Vue;
  } else if (typeof global !== 'undefined') {
    GlobalVue = global.Vue;
  }

  if (GlobalVue) {
    GlobalVue.use(plugin);
  }
} // Inject install function into component - allows component
// to be registered via Vue.use() as well as Vue.component()


__vue_component__$1g.install = install; // Export component by default
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

export default __vue_component__$1g;
